import app from "@/main";

import { Promise } from "es6-promise";

import {
  isCookieEnabled,
  getCookie,
  setCookie,
  removeCookie
} from "tiny-cookie";

import store from "../store";

import common from "./api/ajax";
import { data } from "jquery";
import Enum from "../../enum/enum"
import utils from '@/lib/utils';

export default {
  SET_TOKEN: (context, payload) => {
    return new Promise((resolve, reject) => {
      common.postRequest(
        "api/v1/auth/jwt-auth/",
        {
          username: payload.username,
          password: payload.password
        },
        function(res) {
          context.commit("SET_TOKEN", res.data);
          if (isCookieEnabled()) {
            setCookie("id_token", res.data.token);
            resolve(res);
          } else {
            reject(res);
          }
        },
        function(error) {
          if (isCookieEnabled()) {
            removeCookie("id_token");
          }
          reject(error);
        }
      );
    });
  },
  CHECK_TOKEN: (context, payload) => {
    return new Promise((resolve, reject) => {
      let idToken = "";
      let enableCookie = isCookieEnabled();
      if (enableCookie) {
        idToken = getCookie("id_token");
      }
      if (idToken && enableCookie) {
        store.state.user.authenticated = true;
        resolve();
      } else {
        let error = "";
        store.state.user.authenticated = false;
        reject(error);
      }
    });
  },
  RESET_TOKEN: (context, payload) => {
    return new Promise((resolve, reject) => {
      if (isCookieEnabled()) {
        const idToken = getCookie("id_token");
        context.commit("SET_TOKEN", idToken);
        resolve();
      } else {
        let error = "";
        reject(error);
      }
    });
  },
  REMOVE_TOKEN: (context, payload) => {
    return new Promise((resolve, reject) => {
      common.postRequest(
        "api/v1/auth/jwt-refresh/",
        {
          token: payload
        },
        function(res) {
          context.commit("REMOVE_TOKEN", res.data);
          if (isCookieEnabled()) {
            removeCookie("id_token");
            resolve(res);
          } else {
            let error = "";
            reject(error);
          }
        },
        function(error) {
          reject(error);
        }
      );
    });
  },
  ACCOUNT_PASSWORD_RESET: (context, payload) => {
    return new Promise((resolve, reject) => {
      common.postRequest(
        `/api/v1/${utils.getProjectId()}/accounts/password_reset/`,
        payload,
        function(res) {
          resolve(res);
        },
        function(error) {
          reject(error);
        }
      );
    });
  },
  ACCOUNT_PASSWORD_RESET_SET_PASSWORD: (context, payload) => {
    return new Promise((resolve, reject) => {
      common.postRequest(
        `/api/v1/${utils.getProjectId()}/accounts/password_reset/set_password/`,
        payload,
        function(res) {
          resolve(res);
        },
        function(error) {
          reject(error);
        }
      );
    });
  },
  SET_USER_DATA: (context, payload) => {
    return new Promise((resolve, reject) => {
      common.getRequest(
        `api/v1/auth/${utils.getProjectId()}/userinfo/`,
        payload,
        function(res) {
          context.commit("SET_USER_DATA", res.data);
          if (isCookieEnabled()) {
            setCookie("role", res.data.response.group_id);
            resolve(res);
          } else {
            reject(res);
          }
        },
        function(error) {
          reject(error);
        }
      );
    });
  },
  GET_INFORMATION_PROJECT: (context, payload) => {
    return new Promise((resolve, reject) => {
      common.getRequest(
        `/api/v1/project/${payload.id}/get_project_information/`,
        {},
        function(res) {
          resolve(res);
        },
        function(error) {
          reject(error);
        }
      );
    });
  },
  UPDATE_INFORMATION_PROJECT: (context, payload) => {
    return new Promise((resolve, reject) => {
      common.postRequest(
        `/api/v1/project/${payload.id}/update_project_information/`,
        payload,
        function(res) {
          resolve(res);
        },
        function(error) {
          reject(error);
        },
        600000
      );
    });
  },
  GET_PROJECT_LIST: (context, payload) => {
    return new Promise((resolve, reject) => {
      common.getRequest(
        "/api/v1/project/",
        payload,
        function(res) {
          context.commit("GET_PROJECT_LIST", res.data);
          resolve(res);
        },
        function(error) {
          reject(error);
        }
      );
    });
  },
  UPDATE_PROJECT: (context, payload) => {
    return new Promise((resolve, reject) => {
      common.putRequest(
        `/api/v1/project/${payload.id}/`,
        payload.data,
        function(res) {
          resolve(res);
        },
        function(error) {
          reject(error);
        },
        6000000
      );
    });
  },
  GET_PROJECT_DETAIL: (context, payload) => {
    return new Promise((resolve, reject) => {
      common.getRequest(
        `/api/v1/project/${payload.id}/`,
        {},
        function(res) {
          resolve(res);
        },
        function(error) {
          reject(error);
        }
      );
    });
  },
  GET_PROJECT_MODULE: (context, payload) => {
    return new Promise((resolve, reject) => {
      common.getRequest(
        `/api/v1/project/${payload.id}/get_project_module/`,
        payload,
        function(res) {
          context.commit("GET_PROJECT_MODULE", res.data);
          resolve(res);
        },
        function(error) {
          reject(error);
        }
      );
    });
  },
  GET_PROJECT_SCHEDULER_DETAIL: (context, payload) => {
    return new Promise((resolve, reject) => {
      common.getRequest(
        `/api/v1/project/${payload.id}/get_scheduler/`,
        {},
        function(res) {
          resolve(res);
        },

        function(error) {
          reject(error);
        }
      );
    });
  },
  ON_SHOW_TOAST: (context, payload) => {
    return new Promise((resolve, reject) => {
      const id = Math.floor(1000000 * Math.random()).toString();
      const data = {
        id: id,
        message: payload.message,
        styleType: payload.styleType
      };
      context.commit("ON_SHOW_TOAST", data);
      resolve();
    });
  },
  SUCCESS_TOAST: (context, payload) => {
    return new Promise((resolve, reject) => {
      const id = Math.floor(1000000 * Math.random()).toString();
      const data = {
        id: id,
        message: "Success",
        styleType: "success"
      };
      context.commit("ON_SHOW_TOAST", data);
      resolve();
    });
  },
  ERROR_TOAST: (context, payload) => {
    return new Promise((resolve, reject) => {
      const id = Math.floor(1000000 * Math.random()).toString();
      const data = {
        id: id,
        message: "Error",
        styleType: "danger"
      };
      context.commit("ON_SHOW_TOAST", data);
      resolve();
    });
  },
  DELETE_TOAST: (context, payload) => {
    return new Promise((resolve, reject) => {
      const data = payload;
      context.commit("DELETE_TOAST", data);
      resolve();
    });
  },
  SET_LANG: async (context, payload) => {
    if (!(payload in app.$i18n.messages)) {
      try {
        const res = await require(`@/lang/${payload}.json`);
        app.$i18n.setLocaleMessage(payload, res);
      } catch (e) {
        //console.log(e)
      }
    }
    return new Promise((resolve, reject) => {
      context.commit("SET_LANG", payload);
      if (isCookieEnabled()) {
        setCookie("select_lang", payload);
        resolve();
      } else {
        reject();
      }
    });
  },
  PAGINATION_NEXT_PAGE: (context, payload) => {
    return new Promise((resolve, reject) => {
      common.getRequest(
        payload.url,
        {},
        function(res) {
          res.data["page"] = payload.page;
          context.commit(payload.commit_function, res.data);
          resolve(res.data);
        },
        function(error) {
          reject(error);
        }
      );
    });
  },
  PAGINATION_PREV_PAGE: (context, payload) => {
    return new Promise((resolve, reject) => {
      // adding default page 1
      const str = payload.url.slice(-1);
      if (str === "/") {
        payload.url = `${payload.url}?page=1`;
      }
      common.getRequest(
        payload.url,
        {},
        function(res) {
          res.data["page"] = payload.page;
          context.commit(payload.commit_function, res.data);
          resolve(res.data);
        },
        function(error) {
          reject(error);
        }
      );
    });
  },
  GET_PROPERTY_LIST_NO_PAGE: (context, payload) => {
    return new Promise((resolve, reject) => {
      common.getRequest(
        `/api/v1/${utils.getProjectId()}/propertylist/?propertytype=${payload.propertytype}`,
        {},
        function(res) {
          resolve(res);
        },
        function(error) {
          reject(error);
        }
      );
    });
  },
  GET_SERVICE_LIST_NO_PAGE: (context, payload) => {
    return new Promise((resolve, reject) => {
      common.getRequest(
        `/api/v1/${utils.getProjectId()}/servicelist/`,
        payload,
        function(res) {
          //context.commit('GET_SERVICE_LIST_NO_PAGE', res.data)
          resolve(res);
        },
        function(error) {
          reject(error);
        }
      );
    });
  },
  GET_SERVICES_BY_GROUP: (context, payload) => {
    return new Promise((resolve, reject) => {
      common.getRequest(
        `/api/v1/${utils.getProjectId()}/service/get_services_by_group/`,
        payload,
        function(res) {
          resolve(res);
        },
        function(error) {
          reject(error);
        }
      );
    });
  },
  GET_SERVICE_LIST: (context, payload) => {
    return new Promise((resolve, reject) => {
      common.getRequest(
        `/api/v1/${utils.getProjectId()}/service/`,
        payload,
        function(res) {
          res.data["page"] = payload.params.page;
          context.commit("GET_SERVICE_LIST", res.data);
          resolve(res);
        },
        function(error) {
          reject(error);
        }
      );
    });
  },
  ADD_SERVICE: (context, payload) => {
    return new Promise((resolve, reject) => {
      common.postRequest(
        `/api/v1/${utils.getProjectId()}/service/`,
        {
          name: payload.name,
          service_provider_name: payload.serviceProviderName,
          service_provider_address: payload.serviceProviderAddress,
          feegroup: payload.serviceFeeGroup,
          service_type: payload.serviceType,
          service_fee: payload.servicePrice,
          service_business_hour: payload.serviceBusinessHour,
          category: payload.category,
          service_free: payload.serviceFree,
          vat: payload.serviceVAT,

          // [loitt] - add for project history
          project_id: payload.project_id,
          user_created_id: payload.user_created_id,
          app: payload.app, // 1. CONASI Webadmin // 2. CONASI Mobile App
          action: payload.action // 0. Tạo // 1. Sửa, cập nhật // 2. Xóa
        },
        function(res) {
          resolve(res);
        },
        function(error) {
          reject(error);
        },
        300000
      );
    });
  },
  UPDATE_SERVICE: (context, payload) => {
    return new Promise((resolve, reject) => {
      common.putRequest(
        `/api/v1/${utils.getProjectId()}/service/${payload.id}/`,
        {
          name: payload.name,
          service_provider_name: payload.serviceProviderName,
          service_provider_address: payload.serviceProviderAddress,
          feegroup: payload.serviceFeeGroup,
          service_type: payload.serviceType,
          service_fee: payload.servicePrice,
          service_business_hour: payload.serviceBusinessHour,
          category: payload.category,
          service_free: payload.serviceFree,
          vat: payload.serviceVAT,

          // [loitt] - add for project history
          project_id: payload.project_id,
          user_created_id: payload.user_created_id,
          app: payload.app, // 1. CONASI Webadmin // 2. CONASI Mobile App
          action: payload.action // 0. Tạo // 1. Sửa, cập nhật // 2. Xóa
        },
        function(res) {
          context.commit("UPDATE_SERVICE", res.data);
          resolve(res.data);
        },
        function(error) {
          reject(error);
        },
        300000
      );
    });
  },
  DELETE_SERVICE: (context, payload) => {
    return new Promise((resolve, reject) => {
      common.deleteRequest(
        `api/v1/${utils.getProjectId()}/service/${payload.id}/`,
        {},
        function(res) {
          context.commit("DELETE_SERVICE", res.data);
          resolve(res);
        },
        function(error) {
          reject(error);
        }
      );
    });
  },
  GET_SERVICE_DETAILS: (context, payload) => {
    return new Promise((resolve, reject) => {
      common.getRequest(
        `/api/v1/${utils.getProjectId()}/service/${payload.id}/`,
        {},
        function(res) {
          context.commit("SERVICE_DETAILS", res.data);
          resolve(res.data);
        },

        function(error) {
          reject(error);
        }
      );
    });
  },
  GET_SERVICE_TYPE_LIST: (context, payload) => {
    return new Promise((resolve, reject) => {
      common.getRequest(
        `/api/v1/${utils.getProjectId()}/servicetype/`,
        payload,
        function(res) {
          //res.data["page"] = payload.params.page;
          context.commit("SERVICE_TYPE_LIST", res.data);
          resolve(res);
        },
        function(error) {
          reject(error);
        }
      );
    });
  },
  ADD_ASSIGN_SERVICE: (context, payload) => {
    return new Promise((resolve, reject) => {
      common.postRequest(
        `/api/v1/${utils.getProjectId()}/serviceuser/`,
        payload,
        function(res) {
          resolve(res);
        },
        function(error) {
          reject(error);
        }
      );
    });
  },
  GET_ASSIGN_SERVICE_DETAIL: (context, payload) => {
    return new Promise((resolve, reject) => {
      common.getRequest(
        `/api/v1/${utils.getProjectId()}/serviceuser/${payload.id}/`,
        {},
        function(res) {
          resolve(res);
        },
        function(error) {
          reject(error);
        }
      );
    });
  },
  GET_RECORD_HISTORY_LIST: (context, payload) => {
    return new Promise((resolve, reject) => {
      common.getRequest(
        `/api/v1/${utils.getProjectId()}/serviceusagebyassignedservicehistory/?serviceusageid=${
          payload.serviceusageid
        }`,
        {},
        function(res) {
          context.commit("GET_RECORD_HISTORY_LIST", res.data);
          resolve(res);
        },
        function(error) {
          reject(error);
        }
      );
    });
  },
  GET_SERVICE_HISTORY_LIST: (context, payload) => {
    return new Promise((resolve, reject) => {
      let api = "";
      if (payload != null) {
        api = `/api/v1/${utils.getProjectId()}/serviceusage/?userid=${payload.params.userid}`;
      } else {
        api = `/api/v1/${utils.getProjectId()}/serviceusage/`;
      }
      common.getRequest(
        api,
        payload,
        function(res) {
          if (payload != null) {
            res.data["page"] = payload.params.page;
          }
          context.commit("GET_SERVICE_HISTORY_LIST", res.data);
          resolve(res);
        },
        function(error) {
          reject(error);
        }
      );
    });
  },
  GET_SERVICE_LIST_BY_USER: (context, payload) => {
    return new Promise((resolve, reject) => {
      common.getRequest(
        `/api/v1/${utils.getProjectId()}/servicelistbyuser/?userid=${payload.userid}`,
        {},
        function(res) {
          context.commit("GET_ASSIGN_SERVICE_DATA", res.data);
          resolve(res);
        },
        function(error) {
          reject(error);
        }
      );
    });
  },
  DELETE_ASSIGNED_SERVICE: (context, payload) => {
    return new Promise((resolve, reject) => {
      common.deleteRequest(
        `api/v1/${utils.getProjectId()}/serviceuser/${payload.id}/`,
        {},
        function(res) {
          resolve(res);
        },
        function(error) {
          reject(error);
        }
      );
    });
  },
  ADD_NEW_USAGE_SERVICE: (context, payload) => {
    return new Promise((resolve, reject) => {
      common.postRequest(
        `/api/v1/${utils.getProjectId()}/serviceusage/`,
        payload,
        function(res) {
          context.commit("ADD_NEW_USAGE_SERVICE", res.data);
          resolve(res.data);
        },
        function(error) {
          reject(error);
        }
      );
    });
  },
  UPDATE_USAGE_SERVICE: (context, payload) => {
    return new Promise((resolve, reject) => {
      common.putRequest(
        `/api/v1/${utils.getProjectId()}/serviceusage/${payload.id}/`,
        payload,
        function(res) {
          resolve(res.data);
        },
        function(error) {
          reject(error);
        }
      );
    });
  },
  GET_USAGE_SERVICE_INSTALLMENT: (context, payload) => {
    return new Promise((resolve, reject) => {
      common.getRequest(
        `/api/v1/${utils.getProjectId()}/serviceusagebyservicetype/?serviceid=${
          payload.serviceid
        }&userid=${payload.userid}`,
        {},
        function(res) {
          resolve(res);
        },
        function(error) {
          reject(error);
        }
      );
    });
  },
  ADD_CUSTOMER: (context, payload) => {
    return new Promise((resolve, reject) => {
      common.postRequest(
        `/api/v1/${utils.getProjectId()}/customers/`,
        payload,
        function(res) {
          resolve(res.data);
        },
        function(error) {
          reject(error);
        },
        8000
      );
    });
  },
  GET_CUSTOMER_DETAIL: (context, payload) => {
    return new Promise((resolve, reject) => {
      common.getRequest(
        `/api/v1/${utils.getProjectId()}/customers/${payload.id}/`,
        payload,
        function(res) {
          context.commit("GET_CUSTOMER_DETAIL", res.data);
          resolve(res.data);
        },

        function(error) {
          reject(error);
        }
      );
    });
  },
  UPDATE_CUSTOMER: (context, payload) => {
    return new Promise((resolve, reject) => {
      common.putRequest(
        `/api/v1/${utils.getProjectId()}/customers/${payload.id}/`,
        payload,
        function(res) {
          resolve(res.data);
        },
        function(error) {
          reject(error);
        }
      );
    });
  },
  GET_CUSTOMER_LIST: (context, payload) => {
    return new Promise((resolve, reject) => {
      common.getRequest(
        `api/v1/${utils.getProjectId()}/customers/`,
        payload,
        function(res) {
          if (
            payload != null &&
            payload.params.page != null &&
            payload.params.hasOwnProperty("page")
          ) {
            res.data["page"] = payload.params.page;
          }
          if ("count" in res.data) {
            //  get by pages
            context.commit("GET_CUSTOMER_LIST", res.data);
          }
          resolve(res);
        },
        function(error) {
          reject(error);
        }
      );
    });
  },
  GET_CUSTOMER_LIST_FOR_MAIL_BOX: (context, payload) => {
    return new Promise((resolve, reject) => {
      common.getRequest(
        `api/v1/${utils.getProjectId()}/customers/get_customer_list_for_mail_box/`,
        payload,
        function(res) {
          resolve(res);
        },
        function(error) {
          reject(error);
        },
        60000
      );
    });
  },
  DELETE_CUSTOMER: (context, payload) => {
    return new Promise((resolve, reject) => {
      common.deleteRequest(
        `api/v1/${utils.getProjectId()}/customers/${payload.id}/`,
        {data: payload},
        function(res) {
          resolve(res);
        },
        function(error) {
          reject(error);
        }
      );
    });
  },
  SAVE_USER_FILE_INFO: (context, payload) => {
    return new Promise((resolve, reject) => {
      common.postRequest(
        `/api/v1/${utils.getProjectId()}/customers/save_user_file_info/`,
        payload,
        function(res) {
          resolve(res);
        },
        function(error) {
          reject(error);
        }
      );
    });
  },
  DELETE_FILE_URL_USER: (context, payload) => {
    return new Promise((resolve, reject) => {
      common.deleteRequest(
        `/api/v1/${utils.getProjectId()}/customers/${payload.id}/delete_file_upload_user/`,
        {},
        function(res) {
          resolve(res);
        },
        function(error) {
          reject(error);
        }
      );
    });
  },
  GET_UPLOAD_USER_DATA: (context, payload) => {
    return new Promise((resolve, reject) => {
      common.getRequest(
        `/api/v1/${utils.getProjectId()}/customers/get_upload_file_user/`,
        payload,
        function(res) {
          context.commit("GET_UPLOAD_USER_DATA", res.data);
          resolve(res);
        },
        function(error) {
          reject(error);
        }
      );
    });
  },
  IMPORT_CUSTOMER: (context, payload) => {
    return new Promise((resolve, reject) => {
      common.postRequest(
        `/api/v1/${utils.getProjectId()}/customerimport/`,
        payload,
        function(res) {
          resolve(res.data);
        },
        function(error) {
          reject(error);
        },
        600000
      );
    });
  },
  IMPORT_ACCOUNTING_HOME_LIABILITY: (context, payload) => {
    return new Promise((resolve, reject) => {
      common.postRequest(
        `/api/v1/${utils.getProjectId()}/accountinghomeliability/import_accounting_home_liability/`,
        payload,
        function(res) {
          resolve(res.data);
        },
        function(error) {
          reject(error);
        },
        60000
      );
    });
  },
  CREATE_ACCOUNTING_HOME_LIABILITY_FROM_INVOICE: (context, payload) => {
    return new Promise((resolve, reject) => {
      common.postRequest(
        `/api/v1/${utils.getProjectId()}/accountinghomeliability/create_accounting_home_liability_from_invoice/`,
        payload,
        function(res) {
          resolve(res.data);
        },
        function(error) {
          reject(error);
        },
        120000
      );
    });
  },
  GET_USER_DESC: (context, payload) => {
    return new Promise((resolve, reject) => {
      common.getRequest(
        `/api/v1/${utils.getProjectId()}/customers/${payload.id}/get_description/`,
        {},
        function(res) {
          resolve(res.data);
        },
        function(error) {
          reject(error);
        }
      );
    });
  },
  SET_USER_DESC: (context, payload) => {
    return new Promise((resolve, reject) => {
      common.postRequest(
        `/api/v1/${utils.getProjectId()}/customers/${payload.id}/set_description/`,
        payload.data,
        function(res) {
          resolve(res.data);
        },
        function(error) {
          reject(error);
        }
      );
    });
  },
  GET_CARDS_LIST: (context, payload) => {
    return new Promise((resolve, reject) => {
      common.getRequest(
        `api/v1/${utils.getProjectId()}/cards/`,
        payload,
        function(res) {
          context.commit("GET_CARDS_LIST", res.data);
          resolve(res);
        },
        function(error) {
          reject(error);
        }
      );
    });
  },
  GET_CARD_DETAIL: (context, payload) => {
    return new Promise((resolve, reject) => {
      common.getRequest(
        `/api/v1/${utils.getProjectId()}/cards/${payload.id}/`,
        {},
        function(res) {
          resolve(res.data);
        },

        function(error) {
          reject(error);
        }
      );
    });
  },
  ADD_CARD: (context, payload) => {
    return new Promise((resolve, reject) => {
      common.postRequest(
        `/api/v1/${utils.getProjectId()}/cards/`,
        payload.data,
        function(res) {
          resolve(res.data);
        },
        function(error) {
          reject(error);
        }
      );
    });
  },
  UPDATE_CARD: (context, payload) => {
    return new Promise((resolve, reject) => {
      common.putRequest(
        `/api/v1/${utils.getProjectId()}/cards/${payload.id}/`,
        payload.data,
        function(res) {
          resolve(res.data);
        },
        function(error) {
          reject(error);
        }
      );
    });
  },
  GET_RELATIVE_LIST: (context, payload) => {
    return new Promise((resolve, reject) => {
      common.getRequest(
        `api/v1/${utils.getProjectId()}/relatives/`,
        payload,
        function(res) {
          context.commit("GET_RELATIVE_LIST", res.data);
          resolve(res);
        },
        function(error) {
          reject(error);
        }
      );
    });
  },
  ADD_RELATIVE: (context, payload) => {
    return new Promise((resolve, reject) => {
      common.postRequest(
        `/api/v1/${utils.getProjectId()}/relatives/`,
        payload.data,
        function(res) {
          resolve(res.data);
        },
        function(error) {
          reject(error);
        }
      );
    });
  },
  GET_RELATIVE_DETAIL: (context, payload) => {
    return new Promise((resolve, reject) => {
      common.getRequest(
        `/api/v1/${utils.getProjectId()}/relatives/${payload.id}/`,
        {},
        function(res) {
          context.commit("GET_RELATIVE_DETAIL", res.data);
          resolve(res.data);
        },

        function(error) {
          reject(error);
        }
      );
    });
  },
  UPDATE_RELATIVE: (context, payload) => {
    return new Promise((resolve, reject) => {
      common.putRequest(
        `/api/v1/${utils.getProjectId()}/relatives/${payload.id}/`,
        payload.data,
        function(res) {
          resolve(res.data);
        },
        function(error) {
          reject(error);
        }
      );
    });
  },
  DELETE_RELATIVE: (context, payload) => {
    return new Promise((resolve, reject) => {
      common.deleteRequest(
        `api/v1/${utils.getProjectId()}/relatives/${payload.id}/`,
        {},
        function(res) {
          resolve(res);
        },
        function(error) {
          reject(error);
        }
      );
    });
  },
  IMPORT_APARTMENT: (context, payload) => {
    return new Promise((resolve, reject) => {
      common.postRequest(
        `/api/v1/${utils.getProjectId()}/apartmentimport/`,
        payload,
        function(res) {
          context.commit("IMPORT_APARTMENT", res.data);
          resolve(res.data);
        },
        function(error) {
          reject(error);
        },
        600000
      );
    });
  },
  CHANGE_RESIDENT_TO_SERVICE_APARTMENT: (context, payload) => {
    return new Promise((resolve, reject) => {
      common.postRequest(
        `/api/v1/${utils.getProjectId()}/apartment/update_resident_apartment/${
          payload.apartment_type
        }/`,
        payload,
        function(res) {
          context.commit("CHANGE_RESIDENT_TO_SERVICE_APARTMENT", res.data);
          resolve(res.data);
        },
        function(error) {
          reject(error);
        },
        60000
      );
    });
  },
  GET_INVOICE_CUSTOMER_LIST: (context, payload) => {
    return new Promise((resolve, reject) => {
      common.getRequest(
        `api/v1/${utils.getProjectId()}/invoicecustomer/`,
        payload,
        function(res) {
          if (payload != null) {
            res.data["page"] = payload.params.page;
          }
          context.commit("GET_INVOICE_CUSTOMER_LIST", res.data);
          resolve(res);
        },
        function(error) {
          reject(error);
        }
      );
    });
  },
  IMPORT_INVOICE_FROM_EXCEL: (context, payload) => {
    return new Promise((resolve, reject) => {
      common.postRequest(
        `/api/v1/${utils.getProjectId()}/invoicev2/import_invoice_from_excel_file/`,
        payload,
        function(res) {
          resolve(res.data);
        },
        function(error) {
          reject(error);
        }
      );
    });
  },
  GET_INVOICE_HISTORY: (context, payload) => {
    return new Promise((resolve, reject) => {
      common.getRequest(
        `/api/v1/${utils.getProjectId()}/invoicev2/get_invoice_history/`,
        payload,
        function(res) {
          if(res.data["page"] !== undefined){
            context.commit('GET_INVOICE_HISTORY', res.data)
          }
          resolve(res.data);
        },
        function(error) {
          reject(error);
        }
      );
    });
  },
  ADD_USER: (context, payload) => {
    return new Promise((resolve, reject) => {
      common.postRequest(
        `/api/v1/${utils.getProjectId()}/users/`,
        payload,
        function(res) {
          resolve(res.data);
        },
        function(error) {
          reject(error);
        },
        8000
      );
    });
  },
  GET_USER_DETAIL: (context, payload) => {
    return new Promise((resolve, reject) => {
      common.getRequest(
        `/api/v1/${utils.getProjectId()}/users/${payload.id}/`,
        payload,
        function(res) {
          context.commit("GET_USER_DETAIL", res.data);
          resolve(res.data);
        },

        function(error) {
          reject(error);
        }
      );
    });
  },
  UPDATE_USER: (context, payload) => {
    return new Promise((resolve, reject) => {
      common.putRequest(
        `/api/v1/${utils.getProjectId()}/users/${payload.id}/`,
        payload,
        function(res) {
          resolve(res.data);
        },
        function(error) {
          reject(error);
        }
      );
    });
  },
  POST_LOCK_OR_UNLOCK_USER: (context, payload) => {
    return new Promise((resolve, reject) => {
      common.postRequest(
        `/api/v1/${utils.getProjectId()}/users/post_lock_or_unlock_user/`,
        payload,
        function(res) {
          resolve(res.data);
        },
        function(error) {
          reject(error);
        },
        8000
      );
    });
  },
  UPDATE_USER_EMAIL: (context, payload) => {
    return new Promise((resolve, reject) => {
      common.putRequest(
        `/api/v1/${utils.getProjectId()}/users/${payload.id}/update_email_user/`,
        payload,
        function(res) {
          resolve(res.data);
        },
        function(error) {
          reject(error);
        },
        60000
      );
    });
  },
  FORCE_ACTIVE_EMAIL: (context, payload) => {
    return new Promise((resolve, reject) => {
      common.putRequest(
        `/api/v1/${utils.getProjectId()}/users/${payload.id}/activate_email/`,
        payload,
        function(res) {
          resolve(res.data);
        },
        function(error) {
          reject(error);
        },
        60000
      );
    });
  },
  RESEND_ACTIVE_EMAIL: (context, payload) => {
    return new Promise((resolve, reject) => {
      common.postRequest(
        `/api/v1/${utils.getProjectId()}/users/${payload.id}/re_send_activate_email/`,
        payload,
        function(res) {
          resolve(res.data);
        },
        function(error) {
          reject(error);
        },
        60000
      );
    });
  },
  UPDATE_CUSTOMER_EMAIL: (context, payload) => {
    return new Promise((resolve, reject) => {
      common.putRequest(
        `/api/v1/${utils.getProjectId()}/customers/${payload.id}/update_email_customer/`,
        payload,
        function(res) {
          resolve(res.data);
        },
        function(error) {
          reject(error);
        },
        60000
      );
    });
  },
  GET_USER_LIST: (context, payload) => {
    return new Promise((resolve, reject) => {
      common.getRequest(
        `api/v1/${utils.getProjectId()}/users/`,
        payload,
        function(res) {
          if (payload != null) {
            res.data["page"] = payload.params.page;
          }
          context.commit("GET_USER_LIST", res.data);
          resolve(res);
        },
        function(error) {
          reject(error);
        }
      );
    });
  },
  DELETE_USER: (context, payload) => {
    return new Promise((resolve, reject) => {
      common.deleteRequest(
        `api/v1/${utils.getProjectId()}/users/${payload.id}/`,
        {data: payload},
        function(res) {
          resolve(res);
        },
        function(error) {
          reject(error);
        }
      );
    });
  },
  GET_NUMBER_USER_IN_PERMISSION: (context, payload) => {
    return new Promise((resolve, reject) => {
      common.getRequest(
        `api/v1/${utils.getProjectId()}/users/get_number_user_in_permission/`,
        payload,
        function(res) {
          resolve(res);
        },
        function(error) {
          reject(error);
        }
      );
    });
  },
  IMPORT_USER: (context, payload) => {
    return new Promise((resolve, reject) => {
      common.postRequest(
        `/api/v1/${utils.getProjectId()}/users/import_user/`,
        payload,
        function(res) {
          resolve(res.data);
        },
        function(error) {
          reject(error);
        },
        600000 // 10 min
      );
    });
  },
  ADD_PROFILE: (context, payload) => {
    return new Promise((resolve, reject) => {
      common.postRequest(
        "/api/v1/profile/",
        {
          age: 0,
          phone: 0,
          gender: 0,
          user: payload.id
        },
        function(res) {
          resolve(res);
        },
        function(error) {
          reject(error);
        }
      );
    });
  },
  GET_STAFF_LIST: (context, payload) => {
    return new Promise((resolve, reject) => {
      common.getRequest(
        `api/v1/${utils.getProjectId()}/staffs/`,
        payload,
        function(res) {
          context.commit("GET_STAFF_LIST", res.data);
          resolve(res);
        },
        function(error) {
          reject(error);
        }
      );
    });
  },
  GET_APARTMENT_LIST: (context, payload) => {
    return new Promise((resolve, reject) => {
      common.getRequest(
        `/api/v1/${utils.getProjectId()}/apartment/`,
        payload,
        function(res) {
          if (
            payload != null &&
            payload.params.page != null &&
            payload.params.hasOwnProperty("page")
          ) {
            res.data["page"] = payload.params.page;
          }
          if(res.data["page"] !== undefined){
            context.commit("GET_APARTMENT_LIST", res.data);
          } else {
            context.commit("GET_APARTMENT_LIST_NO_PAGE", res.data);
          }
          resolve(res);
        },
        function(error) {
          reject(error);
        }
      );
    });
  },
  GET_APARTMENT_REALESTATE_LIST: (context, payload) => {
    return new Promise((resolve, reject) => {
      common.getRequest(
        `/api/v1/${utils.getProjectId()}/apartmentrealestate/`,
        payload,
        function(res) {
          if (
            payload != null &&
            payload.params.page != null &&
            payload.params.hasOwnProperty("page")
          ) {
            res.data["page"] = payload.params.page;
          }
          context.commit("GET_APARTMENT_REALESTATE_LIST", res.data);
          resolve(res);
        },
        function(error) {
          reject(error);
        }
      );
    });
  },
  GET_APARTMENT_SCHEDULE_PROGRESS_LIST: (context, payload) => {
    return new Promise((resolve, reject) => {
      common.getRequest(
        `/api/v1/${utils.getProjectId()}/apartmentscheduleprogress/`,
        payload,
        function(res) {
          if (
            payload != null &&
            payload.params.page != null &&
            payload.params.hasOwnProperty("page")
          ) {
            res.data["page"] = payload.params.page;
          }
          context.commit("GET_APARTMENT_SCHEDULE_PROGRESS_LIST", res.data);
          resolve(res);
        },
        function(error) {
          reject(error);
        }
      );
    });
  },
  GET_AVAILABLE_APARTMENT_LIST: (context, payload) => {
    return new Promise((resolve, reject) => {
      common.getRequest(
        `/api/v1/${utils.getProjectId()}/apartment/available_apartment_list/?checkin=${
          payload.params.checkin_datetime
        }&checkout=${payload.params.checkout_datetime}&absc=${
          payload.params.absc
        }`,
        payload,
        function(res) {
          if (payload != null) {
            res.data["page"] = payload.params.page;
          }

          context.commit("GET_AVAILABLE_APARTMENT_LIST", res.data);
          resolve(res);
        },
        function(error) {
          reject(error);
        }
      );
    });
  },
  GET_APARTMENT_USAGE_LIST: (context, payload) => {
    return new Promise((resolve, reject) => {
      common.getRequest(
        `/api/v1/${utils.getProjectId()}/apartmentusage/`,
        payload,
        function(res) {
          if (payload != null) {
            res.data["page"] = payload.params.page;
          }

          context.commit("GET_APARTMENT_USAGE_LIST", res.data);
          resolve(res);
        },
        function(error) {
          reject(error);
        }
      );
    });
  },
  GET_APARTMENT_SCHEDULE_PROGRESS_DETAIL: (context, payload) => {
    return new Promise((resolve, reject) => {
      common.getRequest(
        `/api/v1/${utils.getProjectId()}/apartmentscheduleprogress/${payload.id}/`,
        {},
        function(res) {
          context.commit("GET_APARTMENT_SCHEDULE_PROGRESS_DETAIL", res.data);
          resolve(res.data);
        },

        function(error) {
          reject(error);
        }
      );
    });
  },
  GET_APARTMENT_REALESTATE_DETAIL: (context, payload) => {
    return new Promise((resolve, reject) => {
      common.getRequest(
        `/api/v1/${utils.getProjectId()}/apartmentrealestate/${payload.id}/`,
        {},
        function(res) {
          context.commit("GET_APARTMENT_REALESTATE_DETAIL", res.data);
          resolve(res.data);
        },

        function(error) {
          reject(error);
        }
      );
    });
  },
  GET_APARTMENT_DETAIL: (context, payload) => {
    return new Promise((resolve, reject) => {
      common.getRequest(
        `/api/v1/${utils.getProjectId()}/apartment/${payload.id}/`,
        {},
        function(res) {
          context.commit("GET_APARTMENT_DETAIL", res.data);
          resolve(res.data);
        },

        function(error) {
          reject(error);
        }
      );
    });
  },
  ADD_APARTMENT_SCHEDULE_PROGRESS: (context, payload) => {
    return new Promise((resolve, reject) => {
      common.postRequest(
        `/api/v1/${utils.getProjectId()}/apartmentscheduleprogress/`,
        payload.data,
        function(res) {
          //context.commit("ADD_APARTMENT_SCHEDULE_PROGRESS", res.data);
          resolve(res.data);
        },
        function(error) {
          reject(error);
        }
      );
    });
  },
  ADD_APARTMENT_REALESTATE: (context, payload) => {
    return new Promise((resolve, reject) => {
      common.postRequest(
        `/api/v1/${utils.getProjectId()}/apartmentrealestate/`,
        payload.data,
        function(res) {
          //context.commit("ADD_APARTMENT_REALESTATE", res.data);
          resolve(res.data);
        },
        function(error) {
          reject(error);
        }
      );
    });
  },
  ADD_APARTMENT: (context, payload) => {
    return new Promise((resolve, reject) => {
      common.postRequest(
        `/api/v1/${utils.getProjectId()}/apartment/`,
        payload.data,
        function(res) {
          //context.commit("ADD_APARTMENT", res.data);
          resolve(res.data);
        },
        function(error) {
          reject(error);
        }
      );
    });
  },
  UPDATE_APARTMENT_SCHEDULE_PROGRESS: (context, payload) => {
    return new Promise((resolve, reject) => {
      common.putRequest(
        `/api/v1/${utils.getProjectId()}/apartmentscheduleprogress/${payload.id}/`,
        payload.data,
        function(res) {
          //context.commit("UPDATE_APARTMENT_SCHEDULE_PROGRESS", res.data);
          resolve(res.data);
        },
        function(error) {
          reject(error);
        }
      );
    });
  },
  UPDATE_APARTMENT_REALESTATE: (context, payload) => {
    return new Promise((resolve, reject) => {
      common.putRequest(
        `/api/v1/${utils.getProjectId()}/apartmentrealestate/${payload.id}/`,
        payload.data,
        function(res) {
          //context.commit("UPDATE_APARTMENT_REALESTATE", res.data);
          resolve(res.data);
        },
        function(error) {
          reject(error);
        }
      );
    });
  },
  UPDATE_APARTMENT: (context, payload) => {
    return new Promise((resolve, reject) => {
      common.putRequest(
        `/api/v1/${utils.getProjectId()}/apartment/${payload.id}/`,
        payload.data,
        function(res) {
          //context.commit("UPDATE_APARTMENT", res.data);
          resolve(res.data);
        },
        function(error) {
          reject(error);
        }
      );
    });
  },
  GET_APARTMENT_REPORT: (context, payload) => {
    return new Promise((resolve, reject) => {
      common.getRequest(
        `/api/v1/${utils.getProjectId()}/apartment/get_apartment_report/`,
        payload,
        function(res) {
          resolve(res.data);
        },
        function(error) {
          reject(error);
        }
      );
    });
  },
  GET_APARTMENT_HA_PER_REPORT: (context, payload) => {
    return new Promise((resolve, reject) => {
      common.getRequest(
        `/api/v1/${utils.getProjectId()}/apartment/get_ha_perc_report/`,
        payload,
        function(res) {
          resolve(res.data);
        },
        function(error) {
          reject(error);
        }
      );
    });
  },
  GET_APARTMENT_RA_PER_REPORT: (context, payload) => {
    return new Promise((resolve, reject) => {
      common.getRequest(
        `/api/v1/${utils.getProjectId()}/apartment/get_ra_perc_report/`,
        payload,
        function(res) {
          resolve(res.data);
        },
        function(error) {
          reject(error);
        }
      );
    });
  },
  GET_APARTMENT_METERDEVICES: (context, payload) => {
    return new Promise((resolve, reject) => {
      common.getRequest(
        `/api/v1/${utils.getProjectId()}/apartment/${payload.id}/get_apartment_meterdevices/`,
        {},
        function(res) {
          resolve(res.data);
        },
        function(error) {
          reject(error);
        }
      );
    });
  },
  SET_APARTMENT_METERDEVICES: (context, payload) => {
    return new Promise((resolve, reject) => {
      common.postRequest(
        `/api/v1/${utils.getProjectId()}/apartment/${payload.id}/set_apartment_meterdevices/`,
        payload.data,
        function(res) {
          resolve(res.data);
        },
        function(error) {
          reject(error);
        }
      );
    });
  },
  GET_PROPERTY_LIST: (context, payload) => {
    return new Promise((resolve, reject) => {
      common.getRequest(
        `/api/v1/${utils.getProjectId()}/property/`,
        payload,
        function(res) {
          res.data["page"] = payload.params.page;
          context.commit("GET_PROPERTY_LIST", res.data);
          resolve(res);
        },
        function(error) {
          reject(error);
        }
      );
    });
  },
  ADD_PROPERTY: (context, payload) => {
    return new Promise((resolve, reject) => {
      common.postRequest(
        `/api/v1/${utils.getProjectId()}/property/`,
        payload,
        function(res) {
          context.commit("ADD_PROPERTY", res.data);
          resolve(res.data);
        },
        function(error) {
          reject(error);
        }
      );
    });
  },
  GET_PROPERTY_DETAIL: (context, payload) => {
    return new Promise((resolve, reject) => {
      common.getRequest(
        `/api/v1/${utils.getProjectId()}/property/${payload.id}/`,
        {},
        function(res) {
          context.commit("GET_PROPERTY_DETAIL", res.data);
          resolve(res.data);
        },

        function(error) {
          reject(error);
        }
      );
    });
  },
  UPDATE_PROPERTY: (context, payload) => {
    return new Promise((resolve, reject) => {
      common.putRequest(
        `/api/v1/${utils.getProjectId()}/property/${payload.id}/`,
        payload,
        function(res) {
          context.commit("UPDATE_PROPERTY", res.data);
          resolve(res.data);
        },
        function(error) {
          reject(error);
        }
      );
    });
  },
  DELETE_PROPERTY: (context, payload) => {
    return new Promise((resolve, reject) => {
      common.deleteRequest(
        `api/v1/${utils.getProjectId()}/property/${payload.id}/`,
        {},
        function(res) {
          context.commit("DELETE_PROPERTY", res.data);
          resolve(res);
        },
        function(error) {
          reject(error);
        }
      );
    });
  },
  GET_LAST_THIS_W_E_MONTH_VALUE: (context, payload) => {
    return new Promise((resolve, reject) => {
      common.getRequest(
        `api/v1/${utils.getProjectId()}/apartmentmonthlyusage/get_last_this_w_e_month_value/`,
        payload,
        function(res) {
          context.commit("GET_LAST_THIS_W_E_MONTH_VALUE", res.data);
          resolve(res);
        },
        function(error) {
          reject(error);
        }
      );
    });
  },
  GET_VEHICLE_TYPE_LIST: (context, payload) => {
    return new Promise((resolve, reject) => {
      common.getRequest(
        `/api/v1/${utils.getProjectId()}/vehicletype/`,
        {},
        function(res) {
          context.commit("GET_VEHICLE_TYPE_LIST", res.data);
          resolve(res.data);
        },
        function(error) {
          reject(error);
        }
      );
    });
  },
  GET_VEHICLE_MANUFACTURER_LIST: (context, payload) => {
    return new Promise((resolve, reject) => {
      common.getRequest(
        `/api/v1/${utils.getProjectId()}/vehiclemanufacturer/`,
        {},
        function(res) {
          context.commit("GET_VEHICLE_MANUFACTURER_LIST", res.data);
          resolve(res.data);
        },
        function(error) {
          reject(error);
        }
      );
    });
  },
  GET_VEHICLE_LIST: (context, payload) => {
    return new Promise((resolve, reject) => {
      common.getRequest(
        `/api/v1/${utils.getProjectId()}/vehicle/`,
        payload,
        function(res) {
          if (payload != null) {
            res.data["page"] = payload.params.page;
          }
          context.commit("GET_VEHICLE_LIST", res.data);
          resolve(res);
        },
        function(error) {
          reject(error);
        }
      );
    });
  },
  GET_VEHICLE_DETAIL: (context, payload) => {
    return new Promise((resolve, reject) => {
      common.getRequest(
        `/api/v1/${utils.getProjectId()}/vehicle/${payload.id}/`,
        {},
        function(res) {
          context.commit("GET_VEHICLE_DETAIL", res.data);
          resolve(res);
        },

        function(error) {
          reject(error);
        }
      );
    });
  },
  ADD_VEHICLE: (context, payload) => {
    return new Promise((resolve, reject) => {
      common.postRequest(
        `/api/v1/${utils.getProjectId()}/vehicle/`,
        payload.data,
        function(res) {
          resolve(res.data);
        },
        function(error) {
          reject(error);
        }
      );
    });
  },
  UPDATE_VEHICLE: (context, payload) => {
    return new Promise((resolve, reject) => {
      common.putRequest(
        `/api/v1/${utils.getProjectId()}/vehicle/${payload.id}/`,
        payload.data,
        function(res) {
          resolve(res.data);
        },
        function(error) {
          reject(error);
        }
      );
    });
  },
  DELETE_VEHICLE: (context, payload) => {
    return new Promise((resolve, reject) => {
      common.deleteRequest(
        `api/v1/${utils.getProjectId()}/vehicle/${payload.id}/`,
        {},
        function(res) {
          resolve(res);
        },
        function(error) {
          reject(error);
        }
      );
    });
  },
  GET_CASE_LIST: (context, payload) => {
    return new Promise((resolve, reject) => {
      common.getRequest(
        `/api/v1/${utils.getProjectId()}/case/`,
        payload,
        function(res) {
          if (payload != null) {
            res.data["page"] = payload.params.page;
          }

          context.commit("GET_CASE_LIST", res.data);
          resolve(res);
        },
        function(error) {
          reject(error);
        }
      );
    });
  },
  GET_CASE_DETAIL: (context, payload) => {
    return new Promise((resolve, reject) => {
      common.getRequest(
        `/api/v1/${utils.getProjectId()}/case/${payload.id}/`,
        {},
        function(res) {
          context.commit("GET_CASE_DETAIL", res.data);
          resolve(res);
        },

        function(error) {
          reject(error);
        }
      );
    });
  },
  ADD_CASE: (context, payload) => {
    return new Promise((resolve, reject) => {
      common.postRequest(
        `/api/v1/${utils.getProjectId()}/case/`,
        payload.data,
        function(res) {
          //context.commit("ADD_CASE", res.data);
          resolve(res.data);
        },
        function(error) {
          reject(error);
        }
      );
    });
  },
  UPDATE_CASE: (context, payload) => {
    return new Promise((resolve, reject) => {
      common.putRequest(
        `/api/v1/${utils.getProjectId()}/case/${payload.id}/`,
        payload.data,
        function(res) {
          context.commit("GET_CASE_DETAIL", res.data);
          resolve(res.data);
        },
        function(error) {
          reject(error);
        }
      );
    });
  },
  FORCE_ESCALATE_CASE: (context, payload) => {
    return new Promise((resolve, reject) => {
      common.putRequest(
        `/api/v1/${utils.getProjectId()}/forceescalationprocess/${payload.id}/`,
        {},
        function(res) {
          resolve(res.data);
        },
        function(error) {
          reject(error);
        },
        10000
      );
    });
  },
  DELETE_CASE: (context, payload) => {
    return new Promise((resolve, reject) => {
      common.deleteRequest(
        `api/v1/${utils.getProjectId()}/case/${payload.id}/`,
        {},
        function(res) {
          //context.commit("DELETE_CASE", res.data);
          resolve(res);
        },
        function(error) {
          reject(error);
        }
      );
    });
  },
  GET_CASE_TYPE_LIST: (context, payload) => {
    return new Promise((resolve, reject) => {
      common.getRequest(
        `/api/v1/${utils.getProjectId()}/casetype/`,
        payload,
        function(res) {
          //context.commit("GET_CASE_TYPE_LIST", res.data);
          resolve(res);
        },
        function(error) {
          reject(error);
        }
      );
    });
  },
  GET_CASE_SUB_TYPE_LIST: (context, payload) => {
    return new Promise((resolve, reject) => {
      common.getRequest(
        `/api/v1/${utils.getProjectId()}/casesubtype/?casetype=${payload.typeid}`,
        payload,
        function(res) {
          //context.commit("GET_CASE_SUB_TYPE_LIST", res.data);
          resolve(res);
        },
        function(error) {
          reject(error);
        }
      );
    });
  },
  GET_ESCALATION_PROCESS_LIST: (context, payload) => {
    return new Promise((resolve, reject) => {
      common.getRequest(
        `/api/v1/${utils.getProjectId()}/escalationprocess/`,
        {},
        function(res) {
          context.commit("GET_ESCALATION_PROCESS_LIST", res.data);
          resolve(res);
        },
        function(error) {
          reject(error);
        }
      );
    });
  },
  ADD_ESCALATION_PROCESS: (context, payload) => {
    return new Promise((resolve, reject) => {
      common.postRequest(
        `/api/v1/${utils.getProjectId()}/escalationprocess/`,
        payload.data,
        function(res) {
          //context.commit("ADD_ESCALATION_PROCESS", res.data);
          resolve(res.data);
        },
        function(error) {
          reject(error);
        }
      );
    });
  },
  GET_ESCALATION_PROCESS: (context, payload) => {
    return new Promise((resolve, reject) => {
      common.getRequest(
        `/api/v1/${utils.getProjectId()}/escalationprocess/${payload.id}/`,
        {},
        function(res) {
          //context.commit("GET_ESCALATION_PROCESS", res.data);
          resolve(res.data);
        },
        function(error) {
          reject(error);
        }
      );
    });
  },
  UPDATE_ESCALATION_PROCESS: (context, payload) => {
    return new Promise((resolve, reject) => {
      common.putRequest(
        `/api/v1/${utils.getProjectId()}/escalationprocess/${payload.id}/`,
        payload.data,
        function(res) {
          //context.commit("UPDATE_ESCALATION_PROCESS", res.data);
          resolve(res.data);
        },
        function(error) {
          reject(error);
        }
      );
    });
  },
  DELETE_ESCALATION_PROCESS: (context, payload) => {
    return new Promise((resolve, reject) => {
      common.deleteRequest(
        `api/v1/${utils.getProjectId()}/escalationprocess/${payload.id}/`,
        {},
        function(res) {
          //context.commit("DELETE_ESCALATION_PROCESS", res.data);
          resolve(res);
        },
        function(error) {
          reject(error);
        }
      );
    });
  },
  GET_ESCALATION_STAGE_LIST: (context, payload) => {
    return new Promise((resolve, reject) => {
      common.getRequest(
        `/api/v1/${utils.getProjectId()}/escalationstage/`,
        payload,
        function(res) {
          context.commit("GET_ESCALATION_STAGE_LIST", res.data);
          resolve(res);
        },
        function(error) {
          reject(error);
        }
      );
    });
  },
  ADD_ESCALATION_STAGE: (context, payload) => {
    return new Promise((resolve, reject) => {
      common.postRequest(
        `/api/v1/${utils.getProjectId()}/escalationstage/`,
        payload.data,
        function(res) {
          //context.commit("ADD_ESCALATION_STAGE", res.data);
          resolve(res.data);
        },
        function(error) {
          reject(error);
        }
      );
    });
  },
  UPDATE_ESCALATION_STAGE: (context, payload) => {
    return new Promise((resolve, reject) => {
      common.putRequest(
        `/api/v1/${utils.getProjectId()}/escalationstage/${payload.id}/`,
        payload.data,
        function(res) {
          //context.commit("UPDATE_ESCALATION_STAGE", res.data);
          resolve(res.data);
        },
        function(error) {
          reject(error);
        }
      );
    });
  },
  DELETE_ESCALATION_STAGE: (context, payload) => {
    return new Promise((resolve, reject) => {
      common.deleteRequest(
        `api/v1/${utils.getProjectId()}/escalationstage/${payload.id}/`,
        {},
        function(res) {
          //context.commit("DELETE_ESCALATION_STAGE", res.data);
          resolve(res);
        },
        function(error) {
          reject(error);
        }
      );
    });
  },
  GET_TODO_LIST: (context, payload) => {
    return new Promise((resolve, reject) => {
      common.getRequest(
        `/api/v1/${utils.getProjectId()}/todolist/`,
        payload,
        function(res) {
          if (payload != null) {
            res.data["page"] = payload.params.page;
          }
          context.commit("GET_TODO_LIST", res.data);
          resolve(res);
        },
        function(error) {
          reject(error);
        }
      );
    });
  },
  DELETE_TODO: (context, payload) => {
    return new Promise((resolve, reject) => {
      common.deleteRequest(
        `api/v1/${utils.getProjectId()}/todolist/${payload.id}/`,
        {},
        function(res) {
          resolve(res);
        },
        function(error) {
          reject(error);
        }
      );
    });
  },
  GET_PROPERTY_TYPE_LIST: (context, payload) => {
    return new Promise((resolve, reject) => {
      common.getRequest(
        "/api/v1/propertytype/",
        payload,
        function(res) {
          context.commit("GET_PROPERTY_TYPE_LIST", res.data);
          resolve(res);
        },
        function(error) {
          reject(error);
        }
      );
    });
  },
  GET_USERS_BY_SERVICE: (context, payload) => {
    return new Promise((resolve, reject) => {
      common.getRequest(
        `api/v1/${utils.getProjectId()}/userbyservice/?serviceid=${payload.id}`,
        {},
        function(res) {
          context.commit("GET_USERS_BY_SERVICE", res.data);
          resolve(res);
        },
        function(error) {
          reject(error);
        }
      );
    });
  },
  GET_COUNTRY_LIST: (context, payload) => {
    return new Promise((resolve, reject) => {
      common.getRequest(
        "/api/v1/countrylist/",
        {},
        function(res) {
          resolve(res);
        },
        function(error) {
          reject(error);
        }
      );
    });
  },
  GET_COLOR_LIST: (context, payload) => {
    return new Promise((resolve, reject) => {
      common.getRequest(
        "/api/v1/colorlist/",
        {},
        function(res) {
          resolve(res);
        },
        function(error) {
          reject(error);
        }
      );
    });
  },
  GET_APARTMENT_RESIDENT_SEARCH: (context, payload) => {
    return new Promise((resolve, reject) => {
      common.getRequest(
        `/api/v1/${utils.getProjectId()}/apartmentresidentsearch/`,
        payload,
        function(res) {
          resolve(res.data);
        },
        function(error) {
          reject(error);
        }
      );
    });
  },

  ADD_RESIDENT: (context, payload) => {
    return new Promise((resolve, reject) => {
      common.postRequest(
        `api/v1/${utils.getProjectId()}/apartmentresidents/`,
        payload.data,
        function(res) {
          resolve(res.data);
        },
        function(error) {
          reject(error);
        }
      );
    });
  },
  DELETE_RESIDENT: (context, payload) => {
    return new Promise((resolve, reject) => {
      common.deleteRequest(
        `api/v1/${utils.getProjectId()}/apartmentresidents/${payload.id}/`,
        {},
        function(res) {
          //context.commit("DELETE_RESIDENT", res.data);
          resolve(res);
        },
        function(error) {
          reject(error);
        }
      );
    });
  },
  GET_RESIDENT_LIST: (context, payload) => {
    return new Promise((resolve, reject) => {
      common.getRequest(
        `api/v1/${utils.getProjectId()}/apartmentresidents/`,
        payload,
        function(res) {
          context.commit("GET_RESIDENT_LIST", res.data);
          resolve(res);
        },
        function(error) {
          reject(error);
        }
      );
    });
  },
  GET_RESIDENT_DETAIL: (context, payload) => {
    return new Promise((resolve, reject) => {
      common.getRequest(
        `api/v1/${utils.getProjectId()}/apartmentresidents/${payload.id}/`,
        {},
        function(res) {
          context.commit("GET_RESIDENT_DETAIL", res.data);
          resolve(res);
        },
        function(error) {
          reject(error);
        }
      );
    });
  },
  UPDATE_RESIDENT: (context, payload) => {
    return new Promise((resolve, reject) => {
      common.putRequest(
        `api/v1/${utils.getProjectId()}/apartmentresidents/${payload.id}/`,
        payload.data,
        function(res) {
          // context.commit("GET_RESIDENT_DETAIL", res.data);
          resolve(res.data);
        },
        function(error) {
          reject(error);
        }
      );
    });
  },
  // =======================================
  // BEGIN - TABLE INVOICE_INVOICE
  // =======================================
  GET_INVOICE_LIST: (context, payload) => {
    return new Promise((resolve, reject) => {
      common.getRequest(
        `/api/v1/${utils.getProjectId()}/invoice/`,
        payload,
        function(res) {
          res.data["page"] = payload.params.page;
          if (payload.params.hasOwnProperty("filter") != null) {
            res.data["filter"] = payload.params.filter;
          }
          // [Need_remove]
          // res.data["results"] = [{"id":1,"invoice_number":"INV1010101","invoice_user":1,"user_name":"guy","invoice_status":1,"status_name":"open","date_issued":"2019-03-21T16:35:00.727889Z","date_paid":"2019-03-21T16:35:00.727889Z","total_fees":0,"other_details":"description 1"},{"id":2,"invoice_number":"INV1010101","invoice_user":1,"user_name":"Gre","invoice_status":2,"status_name":"paid","date_issued":"2019-03-21T16:35:00.727889Z","date_paid":"2019-03-21T16:35:00.727889Z","total_fees":0,"other_details":"description 2"}]

          context.commit("GET_INVOICE_LIST", res.data);
          resolve(res);
        },
        function(error) {
          reject(error);
        }
      );
    });
  },
  GET_INVOICE_LIST_PERFORMANCE_VS2: (context, payload) => {
    return new Promise((resolve, reject) => {
      common.getRequest(
        `/api/v1/${utils.getProjectId()}/invoice/get_invoice_list_performance/`,
        payload,
        function(res) {
          res.data["page"] = payload.params.page;
          if (payload.params.hasOwnProperty("filter") != null) {
            res.data["filter"] = payload.params.filter;
          }
          // [Need_remove]
          // res.data["results"] = [{"id":1,"invoice_number":"INV1010101","invoice_user":1,"user_name":"guy","invoice_status":1,"status_name":"open","date_issued":"2019-03-21T16:35:00.727889Z","date_paid":"2019-03-21T16:35:00.727889Z","total_fees":0,"other_details":"description 1"},{"id":2,"invoice_number":"INV1010101","invoice_user":1,"user_name":"Gre","invoice_status":2,"status_name":"paid","date_issued":"2019-03-21T16:35:00.727889Z","date_paid":"2019-03-21T16:35:00.727889Z","total_fees":0,"other_details":"description 2"}]
          context.commit("GET_INVOICE_LIST_PERFORMANCE_VS2", res.data);
          resolve(res);
        },
        function(error) {
          reject(error);
        },
        60000
      );
    });
  },

  GET_INVOICE_RECEIPT_LIST_PERFORMANCE: (context, payload) => {
    return new Promise((resolve, reject) => {
      common.getRequest(
        `/api/v1/${utils.getProjectId()}/invoice/get_invoice_receipt_list/`,
        payload,
        function(res) {
          res.data["page"] = payload.params.page;
          if (payload.params.hasOwnProperty("filter") != null) {
            res.data["filter"] = payload.params.filter;
          }
          // [Need_remove]
          // res.data["results"] = [{"id":1,"invoice_number":"INV1010101","invoice_user":1,"user_name":"guy","invoice_status":1,"status_name":"open","date_issued":"2019-03-21T16:35:00.727889Z","date_paid":"2019-03-21T16:35:00.727889Z","total_fees":0,"other_details":"description 1"},{"id":2,"invoice_number":"INV1010101","invoice_user":1,"user_name":"Gre","invoice_status":2,"status_name":"paid","date_issued":"2019-03-21T16:35:00.727889Z","date_paid":"2019-03-21T16:35:00.727889Z","total_fees":0,"other_details":"description 2"}]

          context.commit("GET_INVOICE_RECEIPT_LIST_PERFORMANCE", res.data);
          resolve(res);
        },
        function(error) {
          reject(error);
        },
        60000
      );
    });
  },
  GET_FILTER_INVOICE_LIST: (context, payload) => {
    return new Promise((resolve, reject) => {
      common.getRequest(
        `/api/v1/${utils.getProjectId()}/invoice/`,
        payload,
        function(res) {
          if (payload.params.hasOwnProperty("filter_no_page") != null) {
            res.data["filter_no_page"] = payload.params.filter_no_page;
          }
          if (payload.params.hasOwnProperty("period") != null) {
            res.data["period"] = payload.params.period;
          }
          // [Need_remove]
          // res.data["results"] = [{"id":1,"invoice_number":"INV1010101","invoice_user":1,"user_name":"guy","invoice_status":1,"status_name":"open","date_issued":"2019-03-21T16:35:00.727889Z","date_paid":"2019-03-21T16:35:00.727889Z","total_fees":0,"other_details":"description 1"},{"id":2,"invoice_number":"INV1010101","invoice_user":1,"user_name":"Gre","invoice_status":2,"status_name":"paid","date_issued":"2019-03-21T16:35:00.727889Z","date_paid":"2019-03-21T16:35:00.727889Z","total_fees":0,"other_details":"description 2"}]

          context.commit("GET_FILTER_INVOICE_LIST", res.data);
          resolve(res);
        },
        function(error) {
          reject(error);
        }
      );
    });
  },
  CHECK_INVOICE_VS_HOMEACCOUNTINGLIABILITY: (context, payload) => {
    return new Promise((resolve, reject) => {
      common.putRequest(
        `/api/v1/${utils.getProjectId()}/invoice/${payload.id}/check_invoice_vs_homeaccounting/`,
        {},
        function(res) {
          resolve(res.data);
        },
        function(error) {
          reject(error);
        }
      );
    });
  },
  HIDE_LIABILITY: (context, payload) => {
    return new Promise((resolve, reject) => {
      common.putRequest(
        `/api/v1/${utils.getProjectId()}/invoice/${payload.id}/hide_liability/`,
        { payload },
        function(res) {
          resolve(res.data);
        },
        function(error) {
          reject(error);
        }
      );
    });
  },
  GET_INVOICE_DETAIL: (context, payload) => {
    return new Promise((resolve, reject) => {
      common.getRequest(
        `/api/v1/${utils.getProjectId()}/invoice/${payload.id}/`,
        payload, // [Need_remove] `/api/v1/${utils.getProjectId()}/invoice/${payload.id}/`
        function(res) {
          // [Need_remove]
          // res.data = {"id":2,"invoice_number":"INV1010101","invoice_user":1,"user_name":"Gre","invoice_status":2,"status_name":"paid","date_issued":"2019-03-21T16:35:00.727889Z","date_paid":"2019-03-21T16:35:00.727889Z","total_fees":0,"other_details":"description 2"}

          context.commit("GET_INVOICE_DETAIL", res.data);
          resolve(res.data);
        },
        function(error) {
          reject(error);
        }
      );
    });
  },
  ADD_INVOICE: (context, payload) => {
    return new Promise((resolve, reject) => {
      common.postRequest(
        `/api/v1/${utils.getProjectId()}/invoice/`,
        payload,
        function(res) {
          context.commit("ADD_INVOICE", res.data);
          resolve(res.data);
        },
        function(error) {
          reject(error);
        }
      );
    });
  },
  UPDATE_INVOICE: (context, payload) => {
    return new Promise((resolve, reject) => {
      common.putRequest(
        `/api/v1/${utils.getProjectId()}/invoice/${payload.id}/`,
        payload,
        function(res) {
          context.commit("UPDATE_INVOICE", res.data);
          resolve(res.data);
        },
        function(error) {
          reject(error);
        }
      );
    });
  },
  DELETE_INVOICE: (context, payload) => {
    return new Promise((resolve, reject) => {
      common.deleteRequest(
        `api/v1/${utils.getProjectId()}/invoice/${payload.id}/`,
        {data: payload},
        function(res) {
          context.commit("DELETE_INVOICE", res.data);
          resolve(res);
        },
        function(error) {
          reject(error);
        }
      );
    });
  },
  // =======================================
  // END - TABLE INVOICE_INVOICE
  // =======================================

  // =======================================
  // BEGIN - TABLE INVOICE_STATUS
  // =======================================

  GET_INVOICE_STATUS_LIST: (context, payload) => {
    return new Promise((resolve, reject) => {
      common.getRequest(
        `/api/v1/${utils.getProjectId()}/invoicestatus/`,
        payload,
        function(res) {
          if (payload != null) {
            res.data["page"] = payload.params.page;
          }
          context.commit("GET_INVOICE_STATUS_LIST", res.data);
          resolve(res);
        },
        function(error) {
          reject(error);
        }
      );
    });
  },
  GET_INVOICE_STATUS_DETAIL: (context, payload) => {
    return new Promise((resolve, reject) => {
      common.getRequest(
        `/api/v1/${utils.getProjectId()}/invoicestatus/${payload.id}/`,
        {},
        function(res) {
          context.commit("GET_INVOICE_STATUS_DETAIL", res.data);
          resolve(res.data);
        },
        function(error) {
          reject(error);
        }
      );
    });
  },
  ADD_INVOICE_STATUS: (context, payload) => {
    return new Promise((resolve, reject) => {
      common.postRequest(
        `/api/v1/${utils.getProjectId()}/invoicestatus/`,
        payload,
        function(res) {
          context.commit("ADD_INVOICE_STATUS", res.data);
          resolve(res.data);
        },
        function(error) {
          reject(error);
        }
      );
    });
  },
  UPDATE_INVOICE_STATUS: (context, payload) => {
    return new Promise((resolve, reject) => {
      common.putRequest(
        `/api/v1/${utils.getProjectId()}/invoicestatus/${payload.id}/`,
        payload,
        function(res) {
          context.commit("UPDATE_INVOICE_STATUS", res.data);
          resolve(res.data);
        },
        function(error) {
          reject(error);
        }
      );
    });
  },
  DELETE_INVOICE_STATUS: (context, payload) => {
    return new Promise((resolve, reject) => {
      common.deleteRequest(
        `api/v1/${utils.getProjectId()}/invoicestatus/${payload.id}/`,
        {},
        function(res) {
          context.commit("DELETE_INVOICE_STATUS", res.data);
          resolve(res);
        },
        function(error) {
          reject(error);
        }
      );
    });
  },
  // =======================================
  // END - TABLE INVOICE_STATUS
  // =======================================

  // =======================================
  // BEGIN - TABLE ApartmentService
  // =======================================
  ADD_APARTMENT_SERVICE: (context, payload) => {
    return new Promise((resolve, reject) => {
      common.postRequest(
        `/api/v1/${utils.getProjectId()}/apartmentservice/`,
        payload,
        function(res) {
          resolve(res.data);
        },
        function(error) {
          reject(error);
        }
      );
    });
  },
  UPDATE_APARTMENT_SERVICE: (context, payload) => {
    return new Promise((resolve, reject) => {
      common.putRequest(
        `/api/v1/${utils.getProjectId()}/apartmentservice/${payload.apartmentservice_id}/`,
        payload,
        function(res) {
          //context.commit("UPDATE_APARTMENT_SERVICE", res.data);
          resolve(res.data);
        },
        function(error) {
          reject(error);
        }
      );
    });
  },
  // =======================================
  // END - TABLE ApartmentService
  // =======================================

  // [TABLE]
  // GET_[TABLE]_STATUS_LIST
  // GET_[TABLE]_STATUS_DETAIL
  // ADD_[TABLE]_STATUS
  // UPDATE_[TABLE]_STATUS
  // DELETE_[TABLE]_STATUS
  GET_APARTMENT_MONTHLY_USAGE: (context, payload) => {
    return new Promise((resolve, reject) => {
      common.getRequest(
        `/api/v1/${utils.getProjectId()}/apartmentmonthlyusage/?apartmentid=${
          payload.params.apartmentid
        }`,
        payload,
        function(res) {
          if (payload != null) {
            res.data["page"] = payload.params.page;
          }
          context.commit("GET_APARTMENT_MONTHLY_USAGE", res.data);
          resolve(res);
        },
        function(error) {
          reject(error);
        },
        600000
      );
    });
  },

  GET_CURRENT_USAGE: (context, payload) => {
    return new Promise((resolve, reject) => {
      common.getRequest(
        `/api/v1/${utils.getProjectId()}/serviceusage/get_current_usage/?`,
        payload,
        function(res) {
          if (payload != null) {
            res.data["page"] = payload.params.page;
          }
          context.commit("GET_CURRENT_USAGE", res.data);
          resolve(res);
        },
        function(error) {
          reject(error);
        },
        600000
      );
    });
  },

  ADD_APARTMENT_MONTHLY_USAGE: (context, payload) => {
    return new Promise((resolve, reject) => {
      common.postRequest(
        `/api/v1/${utils.getProjectId()}/apartmentmonthlyusage/`,
        payload,
        function(res) {
          context.commit("ADD_APARTMENT_MONTHLY_USAGE", res.data);
          resolve(res.data);
        },
        function(error) {
          reject(error);
        },
        600000
      );
    });
  },
  GET_APARTMENT_MONTHLY_USAGE_LIST: (context, payload) => {
    return new Promise((resolve, reject) => {
      let api = "";
      if (payload != null) {
        api = `/api/v1/${utils.getProjectId()}/serviceusage/?page=${payload.params.page}`;
      } else {
        api = `/api/v1/${utils.getProjectId()}/apartmentmonthlyusage/`;
      }
      common.getRequest(
        api,
        payload,
        function(res) {
          if (payload != null) {
            res.data["page"] = payload.params.page;
          }
          context.commit("GET_APARTMENT_MONTHLY_USAGE_LIST", res.data);
          resolve(res);
        },
        function(error) {
          reject(error);
        }
      );
    });
  },
  COUNT_LIABILITIES_APARTMENT_MONTHLY_USAGE: (context, payload) => {
    return new Promise((resolve, reject) => {
      common.getRequest(
        `/api/v1/${utils.getProjectId()}/apartmentmonthlyusage/`,
        payload,
        function(res) {
          context.commit("COUNT_LIABILITIES_APARTMENT_MONTHLY_USAGE", res.data);
          resolve(res);
        },
        function(error) {
          reject(error);
        }
      );
    });
  },
  //Asset
  GET_ASSET_DROPDOWN_LIST: (context, payload) => {
    return new Promise((resolve, reject) => {
      common.getRequest(
        `/api/v1/${utils.getProjectId()}/asset/`,
        payload,
        function(res) {
          resolve(res);
        },
        function(error) {
          reject(error);
        }
      );
    });
  },
  GET_ASSET_LIST: (context, payload) => {
    return new Promise((resolve, reject) => {
      common.getRequest(
        `/api/v1/${utils.getProjectId()}/asset/`,
        payload,
        function(res) {
          res.data["page"] = payload.params.page;
          context.commit("GET_ASSET_LIST", res.data);
          resolve(res);
        },
        function(error) {
          reject(error);
        }
      );
    });
  },
  GET_ASSET_LIST_V2: (context, payload) => {
    return new Promise((resolve, reject) => {
      common.getRequest(
        `/api/v1/${utils.getProjectId()}/assetV2/`,
        payload,
        function(res) {
          // res.data["page"] = payload.params.page;
          if(res.data["page"] !== undefined){
            context.commit("GET_ASSET_LIST_V2", res.data);
          } else {
            context.commit("GET_ASSET_LIST_V2_NO_PAGE", res.data);
          }
          resolve(res);
        },
        function(error) {
          reject(error);
        }
      );
    });
  },
  GET_ASSET_SUB_TYPE_LIST: (context, payload) => {
    return new Promise((resolve, reject) => {
      common.getRequest(
        `/api/v1/${utils.getProjectId()}/assetsubtype/?assettype=${payload.typeid}`,
        payload,
        function(res) {
          resolve(res);
        },
        function(error) {
          reject(error);
        }
      );
    });
  },
  ADD_ASSET_SUB_TYPE: (context, payload) => {
    return new Promise((resolve, reject) => {
      common.postRequest(
        `/api/v1/${utils.getProjectId()}/assetsubtype/`,
        payload,
        function(res) {
          context.commit("ADD_ASSET_SUB_TYPE", res.data);
          resolve(res.data);
        },
        function(error) {
          reject(error);
        }
      );
    });
  },
  ADD_ASSET: (context, payload) => {
    return new Promise((resolve, reject) => {
      common.postRequest(
        `/api/v1/${utils.getProjectId()}/asset/`,
        payload,
        function(res) {
          context.commit("ADD_ASSET", res.data);
          resolve(res.data);
        },
        function(error) {
          reject(error);
        }
      );
    });
  },
  ADD_ASSET_V2: (context, payload) => {
    return new Promise((resolve, reject) => {
      common.postRequest(
        `/api/v1/${utils.getProjectId()}/assetV2/`,
        payload,
        function(res) {
          resolve(res.data);
        },
        function(error) {
          reject(error);
        }
      );
    });
  },
  IMPORT_ASSET_EXCEL: (context, payload) => {
    return new Promise((resolve, reject) => {
      common.postRequest(
        `/api/v1/${utils.getProjectId()}/assetimportexcel/`,
        payload,
        function(res) {
          // context.commit("ADD_ASSET", res.data);
          resolve(res.data);
        },
        function(error) {
          reject(error);
        },
        600000
      );
    });
  },
  GET_ASSET_DETAIL: (context, payload) => {
    return new Promise((resolve, reject) => {
      common.getRequest(
        `/api/v1/${utils.getProjectId()}/assetV2/${payload.id}/`,
        payload,
        function(res) {
          context.commit("GET_ASSET_DETAIL", res.data);
          resolve(res.data);
        },

        function(error) {
          reject(error);
        }
      );
    });
  },
  UPDATE_ASSET: (context, payload) => {
    return new Promise((resolve, reject) => {
      common.putRequest(
        `/api/v1/${utils.getProjectId()}/asset/${payload.id}/`,
        payload,
        function(res) {
          context.commit("UPDATE_ASSET", res.data);
          resolve(res.data);
        },
        function(error) {
          reject(error);
        }
      );
    });
  },
  UPDATE_ASSET_V2: (context, payload) => {
    return new Promise((resolve, reject) => {
      common.putRequest(
        `/api/v1/${utils.getProjectId()}/assetV2/${payload.id}/`,
        payload,
        function(res) {
          resolve(res.data);
        },
        function(error) {
          reject(error);
        }
      );
    });
  },
  DELETE_ASSET: (context, payload) => {
    return new Promise((resolve, reject) => {
      common.deleteRequest(
        `api/v1/${utils.getProjectId()}/assetV2/${payload.id}/`,
        {},
        function(res) {
          context.commit("DELETE_ASSET", res.data);
          resolve(res);
        },
        function(error) {
          reject(error);
        }
      );
    });
  },
  UPDATE_ASSET_STATUS: (context, payload) => {
    return new Promise((resolve, reject) => {
      common.putRequest(
        `/api/v1/${utils.getProjectId()}/asset/${payload.id}/update_asset_status/`,
        payload,
        function(res) {
          resolve(res.data);
        },
        function(error) {
          reject(error);
        }
      );
    });
  },

  GET_ASSET_TYPE_LIST: (context, payload) => {
    return new Promise((resolve, reject) => {
      common.getRequest(
        `/api/v1/${utils.getProjectId()}/assettype/`,
        payload,
        function(res) {
          context.commit("GET_ASSET_TYPE_LIST", res.data);
          resolve(res);
        },
        function(error) {
          reject(error);
        }
      );
    });
  },
  UPDATE_ASSET_TYPE: (context, payload) => {
    return new Promise((resolve, reject) => {
      common.putRequest(
        `/api/v1/${utils.getProjectId()}/assettype/${payload.id}/`,
        payload,
        function(res) {
          resolve(res.data);
        },
        function(error) {
          reject(error);
        }
      );
    });
  },
  ADD_ASSET_TYPE: (context, payload) => {
    return new Promise((resolve, reject) => {
      common.postRequest(
        `/api/v1/${utils.getProjectId()}/assettype/`,
        payload,
        function(res) {
          context.commit("ADD_ASSET_TYPE", res.data);
          resolve(res.data);
        },
        function(error) {
          reject(error);
        }
      );
    });
  },
  DELETE_ASSET_TYPE: (context, payload) => {
    return new Promise((resolve, reject) => {
      common.deleteRequest(
        `/api/v1/${utils.getProjectId()}/assettype/${payload.id}/`,
        payload,
        function(res) {
          resolve(res.data);
        },
        function(error) {
          reject(error);
        }
      );
    });
  },
  ADD_CASE_TYPE: (context, payload) => {
    return new Promise((resolve, reject) => {
      common.postRequest(
        `/api/v1/${utils.getProjectId()}/casetype/`,
        payload,
        function(res) {
          context.commit("ADD_CASE_TYPE", res.data);
          resolve(res.data);
        },
        function(error) {
          reject(error);
        }
      );
    });
  },
  ADD_CASE_SUB_TYPE: (context, payload) => {
    return new Promise((resolve, reject) => {
      common.postRequest(
        `/api/v1/${utils.getProjectId()}/casesubtype/`,
        payload,
        function(res) {
          context.commit("ADD_CASE_SUB_TYPE", res.data);
          resolve(res.data);
        },
        function(error) {
          reject(error);
        }
      );
    });
  },
  GET_ASSET_STATUS_LIST: (context, payload) => {
    return new Promise((resolve, reject) => {
      common.getRequest(
        `/api/v1/${utils.getProjectId()}/assetstatus/`,
        {},
        function(res) {
          resolve(res);
        },
        function(error) {
          reject(error);
        }
      );
    });
  },
  GET_REPORT_MONTHLY_USAGE_LIST: (context, payload) => {
    return new Promise((resolve, reject) => {
      common.getRequest(
        `/api/v1/${utils.getProjectId()}/reportmonthlyusage/`,
        payload,
        function(res) {
          if (payload.params.hasOwnProperty("month") != null) {
            res.data["month"] = payload.params.month;
          }
          if (payload.params.hasOwnProperty("year") != null) {
            res.data["year"] = payload.params.year;
          }
          // res.data["month"] = payload.params.month;
          // res.data["year"] = payload.params.year;
          res.data["serviceid"] = payload.params.serviceid;
          context.commit("GET_REPORT_MONTHLY_USAGE_LIST", res.data);
          resolve(res);
        },
        function(error) {
          reject(error);
        }
      );
    });
  },
  GET_FLOOR_APARTMENT: (context, payload) => {
    return new Promise((resolve, reject) => {
      common.getRequest(
        `/api/v1/${utils.getProjectId()}/floorapartment/`,
        payload,
        function(res) {
          context.commit("GET_FLOOR_APARTMENT", res.data);
          resolve(res.data);
        },
        function(error) {
          reject(error);
        }
      );
    });
  },
  GET_SERVICE_MONTHLY_USAGE_LIST: (context, payload) => {
    return new Promise((resolve, reject) => {
      common.getRequest(
        `/api/v1/${utils.getProjectId()}/countapartment/`,
        payload,
        function(res) {
          res.data["month"] = payload.params.month;
          res.data["year"] = payload.params.year;
          res.data["serviceid"] = payload.params.serviceid;
          context.commit("GET_SERVICE_MONTHLY_USAGE_LIST", res.data);
          resolve(res.data);
        },
        function(error) {
          reject(error);
        }
      );
    });
  },
  GET_INVOICE_LIST_BY_SEARCH_TEMPLATE: (context, payload) => {
    return new Promise((resolve, reject) => {
      common.postRequest(
        `api/v1/${utils.getProjectId()}/invoice/get_invoice_list_by_template/`,
        payload,
        function(res) {
          context.commit("GET_INVOICE_LIST_BY_SEARCH_TEMPLATE", res.data);
          resolve(res.data);
        },
        function(error) {
          reject(error);
        },
        600000 // Report data is too large, have to wait more
      );
    });
  },
  GENERATE_INVOICE_ID: (context, payload) => {
    return new Promise((resolve, reject) => {
      common.getRequest(
        `/api/v1/${utils.getProjectId()}/invoiceid/`,
        payload,
        function(res) {
          resolve(res);
        },
        function(error) {
          reject(error);
        }
      );
    });
  },
  ACCOUNT_EMAIL_ACTIVATED: (context, payload) => {
    return new Promise((resolve, reject) => {
      common.postRequest(
        "/api/v1/accounts/activated/",
        payload,
        function(res) {
          context.commit("ACCOUNT_EMAIL_ACTIVATED", res.data);
          resolve(res.data);
        },
        function(error) {
          reject(error);
        }
      );
    });
  },
  CHANGE_ISSUED_TO_PAID: (context, payload) => {
    return new Promise((resolve, reject) => {
      common.postRequest(
        "/api/v1/changeissuedtopaid/",
        payload,
        function(res) {
          context.commit("CHANGE_ISSUED_TO_PAID", res.data);
          resolve(res.data);
        },
        function(error) {
          reject(error);
        },
        60000
      );
    });
  },
  SAVE_CUSTOMIZE_TABLE_PERSONAL_CONFIG: (context, payload) => {
    return new Promise((resolve, reject) => {
      common.postRequest(
        "/api/v1/savecustomizetable/",
        payload,
        function(res) {
          context.commit("SAVE_CUSTOMIZE_TABLE_PERSONAL_CONFIG", res.data);
          resolve(res.data);
        },
        function(error) {
          reject(error);
        }
      );
    });
  },
  GET_CUSTOMIZE_TABLE_PERSONAL_CONFIG: (context, payload) => {
    return new Promise((resolve, reject) => {
      common.getRequest(
        "/api/v1/getcustomizetable/",
        payload,
        function(res) {
          let res_data = res.data;
          res_data["params"] = payload.params;
          context.commit("GET_CUSTOMIZE_TABLE_PERSONAL_CONFIG", res_data);
          resolve(res_data);
        },
        function(error) {
          reject(error);
        },
        10000
      );
    });
  },
  ADD_USERGROUP: (context, payload) => {
    return new Promise((resolve, reject) => {
      common.postRequest(
        "",
        payload,
        function(res) {
          // context.commit("ADD_ASSET", res.data);
          resolve(res.data);
        },
        function(error) {
          reject(error);
        }
      );
    });
  },
  GET_MEMBERROLECODES: (context, payload) => {
    return new Promise((resolve, reject) => {
      common.getRequest(
        "/api/v1/projectmemberrolecode/",
        payload,
        function(res) {
          let result = {
            data: []
          };
          res.data.forEach(item => {
            let code = {
              id: item.id,
              name: item.project_member_role_code
            };
            result.data.push(code);
          });
          context.commit("SET_MEMBERROLECODE", result);
          resolve(result);
        },
        function(error) {
          reject(error);
        }
      );
    });
  },
  GET_MODULES: (context, payload) => {
    return new Promise((resolve, reject) => {
      common.getRequest(
        `/api/v1/${utils.getProjectId()}/projectallmodules/`,
        payload,
        function(res) {
          context.commit("SET_ALLMODULES", res);
          resolve(res);
        },
        function(error) {
          reject(error);
        }
      ),
        10000;
    });
  },
  GET_ALL_MODULES_PROJECT: (context, payload) => {
    return new Promise((resolve, reject) => {
      common.getRequest(
        "/api/v1/newproject/get_project_all_module/",
        payload,
        function(res) {
          context.commit("GET_ALL_MODULES_PROJECT", res);
          resolve(res);
        },
        function(error) {
          reject(error);
        }
      ),
        10000;
    });
  },
  GET_ROLEPERMISSION: (context, payload) => {
    return new Promise((resolve, reject) => {
      common.getRequest(
        `/api/v1/${utils.getProjectId()}/projectrolepermission/`,
        payload,
        function(res) {
          context.commit("SET_ROLEPERMISSION", res.data);
          resolve(res.data);
        },
        function(error) {
          reject(error);
        }
      );
    });
  },
  GET_FUNCTION: (context, payload) => {
    return new Promise((resolve, reject) => {
      common.getRequest(
        "/api/v1/projectfunction/",
        payload,
        function(res) {
          context.commit("SET_FUNCTIONS", res.data);
          resolve(res.data);
        },
        function(error) {
          reject(error);
        }
      );
    });
  },
  GET_FUNCTIONPERMISSION: (context, payload) => {
    return new Promise((resolve, reject) => {
      common.getRequest(
        `/api/v1/${utils.getProjectId()}/projectpermission/`,
        payload,
        function(res) {
          context.commit("SET_FUNCTIONPERMISSIONS", res.data);
          resolve(res.data);
        },
        function(error) {
          reject(error);
        }
      );
    });
  },
  SAVE_PERMISSIONS: (context, payload) => {
    return new Promise((resolve, reject) => {
      common.postRequest(
        `/api/v1/${utils.getProjectId()}/projectrolepermission/`,
        payload,
        function(res) {
          resolve(res);
        },
        function(error) {
          reject(error);
        },
        60000
      );
    });
  },
  SAVE_DEADLINESCONFIG: (context, payload) => {
    return new Promise((resolve, reject) => {
      common.putRequest(
        `/api/v1/projectperiod/${payload.id}/`,
        payload.data,
        function(res) {
          resolve(res);
        },
        function(error) {
          reject(error);
        }
      );
    });
  },
  SAVE_PROJECTBANKCONFIG: (context, payload) => {
    return new Promise((resolve, reject) => {
      common.putRequest(
        `/api/v1/${utils.getProjectId()}/projectbanktransfer/${payload.id}/`,
        payload,
        function(res) {
          resolve(res);
        },
        function(error) {
          reject(error);
        }
      );
    });
  },
  CREATE_PROJECT_BANK_TRANSFER: (context, payload) => {
    return new Promise((resolve, reject) => {
      common.postRequest(
        `/api/v1/${utils.getProjectId()}/projectbanktransfer/`,
        payload,
        function(res) {
          resolve(res);
        },
        function(error) {
          reject(error);
        }
      );
    });
  },
  GET_PROJECT_BANK_TRANSFER: (context, payload) => {
    return new Promise((resolve, reject) => {
      common.getRequest(
        `/api/v1/${utils.getProjectId()}/projectbanktransfer/`,
        payload,
        function(res) {
          context.commit("GET_PROJECT_BANK_TRANSFER", res.data);
          resolve(res);
        },
        function(error) {
          reject(error);
        }
      );
    });
  },
  GET_PROJECT_HISTORY_LIST: (context, payload) => {
    return new Promise((resolve, reject) => {
      common.getRequest(
        `/api/v1/${utils.getProjectId()}/projecthistory/`,
        payload,
        function(res) {
          if (payload != null) {
            res.data["page"] = payload.params.page;
          }

          context.commit("GET_PROJECT_HISTORY_LIST", res.data);
          resolve(res);
        },
        function(error) {
          reject(error);
        }
      );
    });
  },
  GET_PERMISSIONS_BYMODULE: (context, payload) => {
    return new Promise((resolve, reject) => {
      common.getRequest(
        `/api/v1/${utils.getProjectId()}/projectpermissionbymodule/`,
        payload,
        function(res) {
          context.commit("SET_APARTMENTPERMISSIONS", res.data);
          resolve(res);
        },
        function(error) {
          reject(error);
        }
      );
    });
  },
  GET_PROJECT_ALL_ALL_MODULE: (context, payload) => {
    return new Promise((resolve, reject) => {
      common.getRequest(
        `/api/v1/${utils.getProjectId()}/projectallmodules/`,
        payload,
        function(res) {
          context.commit("GET_PROJECT_ALL_ALL_MODULE", res.data);
          resolve(res);
        },
        function(error) {
          reject(error);
        }
      );
    });
  },
  GET_SEARCH_LIST: (context, payload) => {
    return new Promise((resolve, reject) => {
      common.getRequest(
        `/api/v1/${utils.getProjectId()}/search/`,
        payload,
        function(res) {
          res.data["page"] = payload.params.page;
          context.commit("GET_SEARCH_LIST", res.data);
          resolve(res);
        },
        function(error) {
          reject(error);
        }
      );
    });
  },
  GET_BATCH_JOB_LIST: (context, payload) => {
    return new Promise((resolve, reject) => {
      common.getRequest(
        "/api/v1/batchjob/",
        payload,
        function(res) {
          res.data["page"] = payload.params.page;
          context.commit("GET_BATCH_JOB_LIST", res.data);
          resolve(res);
        },
        function(error) {
          reject(error);
        }
      );
    });
  },
  GET_BATCH_JOB_DETAIL: (context, payload) => {
    return new Promise((resolve, reject) => {
      common.getRequest(
        `/api/v1/batchjob/${payload.id}/`,
        {},
        function(res) {
          context.commit("SET_BATCH_JOB_DETAIL", res.data);
          resolve(res.data);
        },
        function(error) {
          reject(error);
        }
      );
    });
  },
  GET_BATCH_JOB_HISTORY: (context, payload) => {
    return new Promise((resolve, reject) => {
      common.getRequest(
        "/api/v1/batchjobhistory/",
        payload,
        function(res) {
          res.data["page"] = payload.params.page;
          context.commit("GET_BATCH_JOB_HISTORY", res.data);
          resolve(res);
        },
        function(error) {
          reject(error);
        }
      );
    });
  },
  GET_RECEIPT_LIST: (context, payload) => {
    return new Promise((resolve, reject) => {
      common.getRequest(
        `/api/v1/${utils.getProjectId()}/receipt/`,
        payload,
        function(res) {
          res.data["page"] = payload.params.page;
          context.commit("GET_RECEIPT_LIST", res.data);
          resolve(res);
        },
        function(error) {
          reject(error);
        }
      );
    });
  },
  GET_RECEIPT_DETAIL: (context, payload) => {
    return new Promise((resolve, reject) => {
      common.getRequest(
        `/api/v1/${utils.getProjectId()}/receipt/${payload.id}/`,
        payload,
        function(res) {
          context.commit("GET_RECEIPT_DETAIL", res.data);
          resolve(res.data);
        },
        function(error) {
          reject(error);
        }
      );
    });
  },
  ADD_RECEIPT: (context, payload) => {
    return new Promise((resolve, reject) => {
      common.postRequest(
        `/api/v1/${utils.getProjectId()}/receipt/`,
        payload,
        function(res) {
          context.commit("ADD_RECEIPT", res.data);
          resolve(res.data);
        },
        function(error) {
          reject(error);
        }
      );
    });
  },
  GET_LIST_AVAILABLE_BANKS: (context, payload) => {
    return new Promise((resolve, reject) => {
      common.getRequest(
        `/api/v1/${utils.getProjectId()}/utilsbanks/`,
        payload,
        function(res) {
          context.commit("GET_LIST_AVAILABLE_BANKS", res.data);
          resolve(res);
        },
        function(error) {
          reject(error);
        }
      );
    });
  },
  ADD_RECEIPT_FOR_INVOICE: (context, payload) => {
    return new Promise((resolve, reject) => {
      common.postRequest(
        `/api/v1/${utils.getProjectId()}/receipt/add_receipt_for_invoice/`,
        payload,
        function(res) {
          resolve(res.data);
        },
        function(error) {
          reject(error);
        }
      );
    });
  },
  IMPORT_RECEIPT_FROM_EXCEL_FILE: (context, payload) => {
    return new Promise((resolve, reject) => {
      common.postRequest(
        `/api/v1/${utils.getProjectId()}/receipt/import_receipt_from_excel_file/`,
        payload,
        function(res) {
          resolve(res.data);
        },
        function(error) {
          reject(error);
        }
      );
    });
  },
  SEND_EMAIL_OR_NOTIFICATION_INVOICE: (context, payload) => {
    return new Promise((resolve, reject) => {
      common.postRequest(
        `/api/v1/${utils.getProjectId()}/invoicev2/send_email_or_notification_invoice/`,
        payload,
        function(res) {
          resolve(res.data);
        },
        function(error) {
          reject(error);
        }
      );
    });
  },
  DELETE_RECEIPT: (context, payload) => {
    return new Promise((resolve, reject) => {
      common.deleteRequest(
        `api/v1/${utils.getProjectId()}/receipt/${payload.id}/`,
        {},
        function(res) {
          resolve(res);
        },
        function(error) {
          reject(error);
        }
      );
    });
  },
  DELETE_RECEIPT_SELECT_LIST: (context, payload) => {
    return new Promise((resolve, reject) => {
      common.postRequest(
        `/api/v1/${utils.getProjectId()}/receipt/delete_receipt_select_list/`,
        payload,
        function(res) {
          resolve(res.data);
        },
        function(error) {
          reject(error);
        }
      );
    });
  },
  // --------------- MOBILE APPLICATION ---------------

  ADD_MOBILE_APPLICATION: (context, payload) => {
    return new Promise((resolve, reject) => {
      common.postRequest(
        "api/v1/mobileapplication/",
        payload,
        function(res) {
          resolve(res);
        },
        function(error) {
          reject(error);
        }
      );
    });
  },

  UPDATE_MOBILE_APPLICATION: (context, payload) => {
    return new Promise((resolve, reject) => {
      common.putRequest(
        `api/v1/mobileapplication/${payload.id}/`,
        payload,
        function(res) {
          resolve(res);
        },
        function(error) {
          reject(error);
        }
      );
    });
  },

  UPDATE_BATCH_JOB: (context, payload) => {
    return new Promise((resolve, reject) => {
      common.putRequest(
        `api/v1/batchjob/${payload.id}/`,
        payload,
        function(res) {
          resolve(res);
        },
        function(error) {
          reject(error);
        }
      );
    });
  },

  GET_MOBILE_APPLICATION_LIST: (context, payload) => {
    return new Promise((resolve, reject) => {
      common.getRequest(
        "api/v1/mobileapplication/",
        {},
        function(res) {
          context.commit("GET_MOBILE_APPLICATION_LIST", res.data);
          resolve(res);
        },
        function(error) {
          reject(error);
        }
      );
    });
  },

  GET_MOBILE_APPLICATION_DETAIL: (context, payload) => {
    return new Promise((resolve, reject) => {
      common.getRequest(
        `api/v1/mobileapplication/${payload.id}/`,
        {},
        function(res) {
          context.commit("GET_MOBILE_APPLICATION_DETAIL", res.data);
          resolve(res);
        },
        function(error) {
          reject(error);
        }
      );
    });
  },

  DELETE_MOBILE_APPLICATION: (context, payload) => {
    return new Promise((resolve, reject) => {
      common.deleteRequest(
        `api/v1/mobileapplication/${payload.id}/`,
        {},
        function(res) {
          resolve(res);
        },
        function(error) {
          reject(error);
        }
      );
    });
  },

  // --------------- MOBILE OPERATION SYSTEM ---------------

  ADD_MOBILE_OS: (context, payload) => {
    return new Promise((resolve, reject) => {
      common.postRequest(
        "api/v1/mobileoperationsystem/",
        payload,
        function(res) {
          resolve(res);
        },
        function(error) {
          reject(error);
        }
      );
    });
  },

  UPDATE_MOBILE_OS: (context, payload) => {
    return new Promise((resolve, reject) => {
      common.putRequest(
        `api/v1/mobileoperationsystem/${payload.id}/`,
        payload,
        function(res) {
          resolve(res);
        },
        function(error) {
          reject(error);
        }
      );
    });
  },

  GET_MOBILE_OS_LIST: (context, payload) => {
    return new Promise((resolve, reject) => {
      common.getRequest(
        "api/v1/mobileoperationsystem/",
        payload,
        function(res) {
          context.commit("GET_MOBILE_OS_LIST", res.data);
          resolve(res);
        },
        function(error) {
          reject(error);
        }
      );
    });
  },

  GET_MOBILE_OS_DETAIL: (context, payload) => {
    return new Promise((resolve, reject) => {
      common.getRequest(
        `api/v1/mobileoperationsystem/${payload.id}/`,
        {},
        function(res) {
          context.commit("GET_MOBILE_OS_DETAIL", res.data);
          resolve(res);
        },
        function(error) {
          reject(error);
        }
      );
    });
  },

  DELETE_MOBILE_OS: (context, payload) => {
    return new Promise((resolve, reject) => {
      common.deleteRequest(
        `api/v1/mobileoperationsystem/${payload.id}/`,
        {},
        function(res) {
          resolve(res);
        },
        function(error) {
          reject(error);
        }
      );
    });
  },

  // --------------- MOBILE OS VERSION DETAIL ---------------

  ADD_MOBILE_OS_VERSION: (context, payload) => {
    return new Promise((resolve, reject) => {
      common.postRequest(
        "api/v1/mobileosversiondetail/",
        payload,
        function(res) {
          resolve(res);
        },
        function(error) {
          reject(error);
        }
      );
    });
  },

  UPDATE_MOBILE_OS_VERSION: (context, payload) => {
    return new Promise((resolve, reject) => {
      common.putRequest(
        `api/v1/mobileosversiondetail/${payload.id}/`,
        payload,
        function(res) {
          resolve(res);
        },
        function(error) {
          reject(error);
        }
      );
    });
  },

  GET_MOBILE_OS_VERSION_LIST: (context, payload) => {
    return new Promise((resolve, reject) => {
      common.getRequest(
        "api/v1/mobileosversiondetail/",
        payload,
        function(res) {
          context.commit("GET_MOBILE_OS_VERSION_LIST", res.data);
          resolve(res);
        },
        function(error) {
          reject(error);
        }
      );
    });
  },

  GET_MOBILE_OS_VERSION_DETAIL: (context, payload) => {
    return new Promise((resolve, reject) => {
      common.getRequest(
        `api/v1/mobileosversiondetail/${payload.id}/`,
        {},
        function(res) {
          context.commit("GET_MOBILE_OS_VERSION_DETAIL", res.data);
          resolve(res);
        },
        function(error) {
          reject(error);
        }
      );
    });
  },

  DELETE_MOBILE_OS_VERSION: (context, payload) => {
    return new Promise((resolve, reject) => {
      common.deleteRequest(
        `api/v1/mobileosversiondetail/${payload.id}/`,
        {},
        function(res) {
          resolve(res);
        },
        function(error) {
          reject(error);
        }
      );
    });
  },
  GET_LIST_DEBT_PAYMENT: (context, payload) => {
    return new Promise((resolve, reject) => {
      common.getRequest(
        `/api/v1/${utils.getProjectId()}/invoice/get_list_invoice_debt_payment/`,
        payload,
        function(res) {
          resolve(res.data);
        },
        function(error) {
          reject(error);
        }
      );
    });
  },
  GET_REPAIR_LIST: (context, payload) => {
    return new Promise((resolve, reject) => {
      common.postRequest(
        `/api/v1/${utils.getProjectId()}/case/get_repair_list/`,
        payload,
        function(res) {
          context.commit("GET_REPAIR_LIST", res.data);
          resolve(res.data);
        },
        function(error) {
          reject(error);
        },
        600000
      );
    });
  },
  GET_RECEIPT_LIST_BY_ID: (context, payload) => {
    return new Promise((resolve, reject) => {
      common.getRequest(
        `/api/v1/${utils.getProjectId()}/receipt/get_receipt_list_by_id/?ids=${payload.ids}`,
        payload,
        function(res) {
          context.commit("GET_RECEIPT_LIST_BY_ID", res.data);
          resolve(res);
        },

        function(error) {
          reject(error);
        }
      );
    });
  },
  GET_STATISTICAL_EXPORT_INVOICE: (context, payload) => {
    return new Promise((resolve, reject) => {
      common.postRequest(
        `/api/v1/${utils.getProjectId()}/invoice/get_statistical_invoice/`,
        payload,
        function(res) {
          context.commit("GET_STATISTICAL_EXPORT_INVOICE", res.data);
          resolve(res.data);
        },
        function(error) {
          reject(error);
        },
        600000
      );
    });
  },
  GET_STATISTICAL_APARTMENT_PAYMENT_LATE: (context, payload) => {
    return new Promise((resolve, reject) => {
      common.postRequest(
        `/api/v1/${utils.getProjectId()}/apartment/get_statistical_apartment_payment_late/`,
        payload,
        function(res) {
          context.commit("GET_STATISTICAL_APARTMENT_PAYMENT_LATE", res.data);
          resolve(res.data);
        },
        function(error) {
          reject(error);
        },
        600000
      );
    });
  },
  GET_COUPONS_LIST: (context, payload) => {
    return new Promise((resolve, reject) => {
      common.getRequest(
        `api/v1/${utils.getProjectId()}/servicecoupons/`,
        payload,
        function(res) {
          context.commit("GET_COUPONS_LIST", res.data);
          resolve(res);
        },
        function(error) {
          reject(error);
        }
      );
    });
  },
  ADD_COUPON: (context, payload) => {
    return new Promise((resolve, reject) => {
      common.postRequest(
        `/api/v1/${utils.getProjectId()}/servicecoupons/`,
        payload.data,
        function(res) {
          resolve(res.data);
        },
        function(error) {
          reject(error);
        },
        60000000
      );
    });
  },
  GET_APARTMENT_RESERVATION_LIST: (context, payload) => {
    return new Promise((resolve, reject) => {
      common.getRequest(
        `/api/v1/${utils.getProjectId()}/apartmentreservation/`,
        payload,
        function(res) {
          context.commit("GET_APARTMENT_RESERVATION_LIST", res.data);
        },
        function(error) {
          reject(error);
        }
      );
    });
  },
  SEND_INVOICE_INFORMATION_TO_USER: (context, payload) => {
    return new Promise((resolve, reject) => {
      common.postRequest(
        `/api/v1/${utils.getProjectId()}/invoice/send_invoice_information_to_user/`,
        payload,
        function(res) {
          context.commit("SEND_INVOICE_INFORMATION_TO_USER", res.data);
          resolve(res.data);
        },
        function(error) {
          reject(error);
        },
        6000000
      );
    });
  },
  DELETE_APARTMENT_REALESTATE_LIST: (context, payload) => {
    return new Promise((resolve, reject) => {
      common.postRequest(
        `/api/v1/${utils.getProjectId()}/apartmentrealestate/delete_apartment_realestate_list/`,
        payload,
        function(res) {
          context.commit("DELETE_APARTMENT_REALESTATE_LIST", res.data);
          resolve(res.data);
        },
        function(error) {
          reject(error);
        },
        6000000
      );
    });
  },
  GET_LIST_EMAIL_HISTORY_AGENT: (context, payload) => {
    return new Promise((resolve, reject) => {
      common.getRequest(
        `/api/v1/${utils.getProjectId()}/managementemails/get_list_email_history_agent/`,
        payload,
        function(res) {
          context.commit("GET_LIST_EMAIL_HISTORY_AGENT", res.data);
          resolve(res.data);
        },
        function(error) {
          reject(error);
        }
      );
    });
  },
  GET_EXPORT_EMAIL_HISTORY: (context, payload) => {
    return new Promise((resolve, reject) => {
      common.getRequest(
        `/api/v1/${utils.getProjectId()}/managementemails/get_export_email_history/`,
        payload,
        function(res) {
          resolve(res.data);
        },
        function(error) {
          reject(error);
        }
      );
    });
  },
  DELETE_INVOICE_LIST: (context, payload) => {
    return new Promise((resolve, reject) => {
      common.postRequest(
        `/api/v1/${utils.getProjectId()}/invoice/delete_invoice_list/`,
        payload,
        function(res) {
          context.commit("DELETE_INVOICE_LIST", res.data);
          resolve(res.data);
        },
        function(error) {
          reject(error);
        },
        6000000
      );
    });
  },
  GET_COUPON_DETAIL: (context, payload) => {
    return new Promise((resolve, reject) => {
      common.getRequest(
        `/api/v1/${utils.getProjectId()}/servicecoupons/${payload.id}/`,
        {},
        function(res) {
          context.commit("GET_COUPON_DETAIL", res.data);
          resolve(res.data);
        },

        function(error) {
          reject(error);
        }
      );
    });
  },
  UPDATE_COUPON: (context, payload) => {
    return new Promise((resolve, reject) => {
      common.putRequest(
        `/api/v1/${utils.getProjectId()}/servicecoupons/${payload.id}/`,
        payload.data,
        function(res) {
          resolve(res.data);
        },
        function(error) {
          reject(error);
        }
      );
    });
  },
  UPDATE_APARTMENT_RESERVATION: (context, payload) => {
    return new Promise((resolve, reject) => {
      common.putRequest(
        `/api/v1/${utils.getProjectId()}/apartmentreservation/${payload.id}/`,
        payload,
        function(res) {
          resolve(res.data);
        },
        function(error) {
          reject(error);
        },
        6000000
      );
    });
  },
  DELETE_COUPON: (context, payload) => {
    return new Promise((resolve, reject) => {
      common.deleteRequest(
        `api/v1/${utils.getProjectId()}/servicecoupons/${payload.id}/`,
        {},
        function(res) {
          resolve(res);
        },
        function(error) {
          reject(error);
        }
      );
    });
  },
  DELETE_LIABILITY_ALL: (context, payload) => {
    return new Promise((resolve, reject) => {
      common.deleteRequest(
        `api/v1/${utils.getProjectId()}/accountinghomeliability/delete_liability_all/`,
        {},
        function(res) {
          resolve(res);
        },
        function(error) {
          reject(error);
        }
      );
    });
  },
  DELETE_LIABILITY_RECORD: (context, payload) => {
    return new Promise((resolve, reject) => {
      common.postRequest(
        `/api/v1/${utils.getProjectId()}/apartmentcodefromaccoutinghomebalace/delete_liabilities_record/`,
        payload,
        function(res) {
          resolve(res);
        },
        function(error) {
          reject(error);
        }
      );
    });
  },
  GET_CODE_COUPON: (context, payload) => {
    return new Promise((resolve, reject) => {
      common.getRequest(
        `/api/v1/${utils.getProjectId()}/servicecoupons/get_code/`,
        {},
        function(res) {
          context.commit("GET_CODE_COUPON", res.data);
          resolve(res);
        },

        function(error) {
          reject(error);
        }
      );
    });
  },
  GET_LEASEBACK_APARTMENT_CLIENT_BOOKING: (context, payload) => {
    return new Promise((resolve, reject) => {
      common.getRequest(
        `/api/v1/${utils.getProjectId()}/apartmentbookings/get_lease_back_apartment_client_booking/`,
        payload,
        function(res) {
          resolve(res.data);
        },
        function(error) {
          reject(error);
        }
      );
    });
  },
  ADD_APARTMENT_BOOKINGS: (context, payload) => {
    return new Promise((resolve, reject) => {
      common.postRequest(
        `/api/v1/${utils.getProjectId()}/apartmentbookings/`,
        payload,
        function(res) {
          resolve(res.data);
        },
        function(error) {
          reject(error);
        },
        600000
      );
    });
  },
  UPDATE_APARTMENT_BOOKINGS: (context, payload) => {
    return new Promise((resolve, reject) => {
      common.putRequest(
        `/api/v1/${utils.getProjectId()}/apartmentbookings/${payload.id}/`,
        payload.data,
        function(res) {
          resolve(res.data);
        },
        function(error) {
          reject(error);
        }
      );
    });
  },
  ADD_APARTMENT_GROUP_BOOKINGS: (context, payload) => {
    return new Promise((resolve, reject) => {
      common.postRequest(
        `/api/v1/${utils.getProjectId()}/apartmentgroupbookings/`,
        payload,
        function(res) {
          resolve(res.data);
        },
        function(error) {
          reject(error);
        },
        10000
      );
    });
  },
  UPDATE_APARTMENT_GROUP_BOOKINGS: (context, payload) => {
    return new Promise((resolve, reject) => {
      common.putRequest(
        `/api/v1/${utils.getProjectId()}/apartmentgroupbookings/${payload.id}/`,
        payload.data,
        function(res) {
          resolve(res.data);
        },
        function(error) {
          reject(error);
        },
        10000
      );
    });
  },
  GET_GROUP_BOOKING_DETAIL: (context, payload) => {
    return new Promise((resolve, reject) => {
      common.getRequest(
        `/api/v1/${utils.getProjectId()}/apartmentgroupbookings/${payload.id}/`,
        payload,
        function(res) {
          context.commit("GET_GROUP_BOOKING_DETAIL", res.data);
          resolve(res.data);
        },
        function(error) {
          reject(error);
        }
      );
    });
  },
  SEND_MAIL: (context, payload) => {
    return new Promise((resolve, reject) => {
      common.postRequest(
        `/api/v1/${utils.getProjectId()}/managementemails/`,
        payload,
        function(res) {
          resolve(res);
        },
        function(error) {
          reject(error);
        },
        120000
      );
    });
  },
  GET_BOOKING_DETAIL: (context, payload) => {
    return new Promise((resolve, reject) => {
      common.getRequest(
        `/api/v1/${utils.getProjectId()}/apartmentbookings/${payload.id}/`,
        payload,
        function(res) {
          context.commit("GET_BOOKING_DETAIL", res.data);
          resolve(res.data);
        },
        function(error) {
          reject(error);
        }
      );
    });
  },
  GET_BOOKING_DETAIL_BY_BOOKING_CODE: (context, payload) => {
    return new Promise((resolve, reject) => {
      common.getRequest(
        `/api/v1/${utils.getProjectId()}/apartmentbookings/apartment_booking_detail_by_booking_code/?booking_code=${
          payload.booking_code
        }`,
        payload,
        function(res) {
          context.commit("GET_BOOKING_DETAIL_BY_BOOKING_CODE", res.data);
          resolve(res.data);
        },
        function(error) {
          reject(error);
        }
      );
    });
  },
  GET_BOOKING_APARTMENT_DETAIL: (context, payload) => {
    return new Promise((resolve, reject) => {
      common.getRequest(
        `/api/v1/${utils.getProjectId()}/apartmentbookings/${payload.id}/booking_apartment_details/`,
        payload,
        function(res) {
          resolve(res.data);
        },
        function(error) {
          reject(error);
        }
      );
    });
  },
  GET_ALL_BOOKING_BY_APARTMENT: (context, payload) => {
    return new Promise((resolve, reject) => {
      common.getRequest(
        `/api/v1/${utils.getProjectId()}/apartment/get_all_bookings_by_apartment/?apartmentid=${
          payload.params.apartmentid
        }`,
        {},
        function(res) {
          context.commit("GET_ALL_BOOKING_BY_APARTMENT", res.data);
          resolve(res.data);
        },

        function(error) {
          reject(error);
        }
      );
    });
  },
  GET_APARTMENT_CUSTOMER_INFORMATION_BOOKING_DETAIL: (context, payload) => {
    return new Promise((resolve, reject) => {
      common.getRequest(
        `/api/v1/${utils.getProjectId()}/apartmentbookings/${payload.id}/apartment_customer_information_booking_detail/`,
        payload,
        function(res) {
          context.commit(
            "GET_APARTMENT_CUSTOMER_INFORMATION_BOOKING_DETAIL",
            res.data
          );
          resolve(res.data);
        },

        function(error) {
          reject(error);
        }
      );
    });
  },
  GET_INVOICE_BOOKING_PAYMENT_DETAIL: (context, payload) => {
    return new Promise((resolve, reject) => {
      common.getRequest(
        `/api/v1/${utils.getProjectId()}/bookingpayment/${payload.id}/`,
        payload,
        function(res) {
          context.commit("GET_INVOICE_BOOKING_PAYMENT_DETAIL", res.data);
          resolve(res.data);
        },

        function(error) {
          reject(error);
        }
      );
    });
  },
  GET_BOOKINGS_BY_APARTMENT_BEFORE_MOVING: (context, payload) => {
    return new Promise((resolve, reject) => {
      common.postRequest(
        `/api/v1/${utils.getProjectId()}/apartment/check_bookings_by_apartment_before_moving/`,
        payload,
        function(res) {
          context.commit("GET_BOOKINGS_BY_APARTMENT_BEFORE_MOVING", res.data);
          resolve(res.data);
        },

        function(error) {
          reject(error);
        }
      );
    });
  },
  //Documentation
  GET_DOCUMENT_LIST: (context, payload) => {
    return new Promise((resolve, reject) => {
      common.getRequest(
        `api/v1/${utils.getProjectId()}/documents/`,
        payload,
        function(res) {
          context.commit("GET_DOCUMENT_LIST", res.data);
          resolve(res);
        },
        function(error) {
          reject(error);
        }
      );
    });
  },
  GET_DOCUMENT_DETAIL: (context, payload) => {
    return new Promise((resolve, reject) => {
      common.getRequest(
        `api/v1/${utils.getProjectId()}/documents/${payload.id}/`,
        payload,
        function(res) {
          context.commit("GET_DOCUMENT_DETAIL", res.data);
          resolve(res);
        },
        function(error) {
          reject(error);
        }
      );
    });
  },
  ADD_DOCUMENT: (context, payload) => {
    return new Promise((resolve, reject) => {
      common.postRequest(
        `api/v1/${utils.getProjectId()}/documents/`,
        payload,
        function(res) {
          resolve(res);
        },
        function(error) {
          reject(error);
        }
      );
    });
  },
  UPDATE_DOCUMENT: (context, payload) => {
    return new Promise((resolve, reject) => {
      common.putRequest(
        `api/v1/${utils.getProjectId()}/documents/${payload.id}/`,
        payload,
        function(res) {
          resolve(res);
        },
        function(error) {
          reject(error);
        }
      );
    });
  },
  DELETE_DOCUMENT: (context, payload) => {
    return new Promise((resolve, reject) => {
      common.deleteRequest(
        `api/v1/${utils.getProjectId()}/documents/${payload.id}/`,
        {},
        function(res) {
          resolve(res);
        },
        function(error) {
          reject(error);
        }
      );
    });
  },
  RESEND_ACTIVE_EMAIL_CUSTOMER: (context, payload) => {
    return new Promise((resolve, reject) => {
      common.postRequest(
        `/api/v1/${utils.getProjectId()}/customers/${payload.id}/re_send_activate_email_customer/`,
        payload,
        function(res) {
          resolve(res.data);
        },
        function(error) {
          reject(error);
        },
        60000
      );
    });
  },
  FORCE_ACTIVE_EMAIL_CUSTOMER: (context, payload) => {
    return new Promise((resolve, reject) => {
      common.putRequest(
        `/api/v1/${utils.getProjectId()}/customers/${payload.id}/activate_email_customer/`,
        payload,
        function(res) {
          resolve(res.data);
        },
        function(error) {
          reject(error);
        },
        60000
      );
    });
  },
  GET_LEASEBACK_COMPANY_LIST: (context, payload) => {
    return new Promise((resolve, reject) => {
      common.getRequest(
        `/api/v1/${utils.getProjectId()}/apartmentleasebackcompany/`,
        payload,
        function(res) {
          context.commit("GET_LEASEBACK_COMPANY_LIST", res.data);
          resolve(res);
        },
        function(error) {
          reject(error);
        }
      );
    });
  },
  ADD_LEASEBACK_COMPANY: (context, payload) => {
    return new Promise((resolve, reject) => {
      common.postRequest(
        `/api/v1/${utils.getProjectId()}/apartmentleasebackcompany/`,
        payload,
        function(res) {
          resolve(res);
        },
        function(error) {
          reject(error);
        }
      );
    });
  },
  UPDATE_LEASEBACK_COMPANY: (context, payload) => {
    return new Promise((resolve, reject) => {
      common.putRequest(
        `/api/v1/${utils.getProjectId()}/apartmentleasebackcompany/${payload.id}/`,
        payload,
        function(res) {
          resolve(res);
        },
        function(error) {
          reject(error);
        }
      );
    });
  },
  DELETE_LEASEBACK_COMPANY: (context, payload) => {
    return new Promise((resolve, reject) => {
      common.deleteRequest(
        `/api/v1/${utils.getProjectId()}/apartmentleasebackcompany/${payload.id}/`,
        payload,
        function(res) {
          resolve(res);
        },
        function(error) {
          reject(error);
        }
      );
    });
  },
  GET_DETAIL_LEASEBACK_COMPANY: (context, payload) => {
    return new Promise((resolve, reject) => {
      common.getRequest(
        `/api/v1/${utils.getProjectId()}/apartmentleasebackcompany/${payload.id}/`,
        payload,
        function(res) {
          resolve(res);
        },
        function(error) {
          reject(error);
        }
      );
    });
  },
  ADD_APARTMENT_LEASEBACK_CLIENTS: (context, payload) => {
    return new Promise((resolve, reject) => {
      common.postRequest(
        `/api/v1/${utils.getProjectId()}/apartmentleasebackclients/`,
        payload,
        function(res) {
          resolve(res.data);
        },
        function(error) {
          reject(error);
        }
      );
    });
  },
  UPDATE_APARTMENT_LEASEBACK_CLIENTS: (context, payload) => {
    return new Promise((resolve, reject) => {
      common.putRequest(
        `/api/v1/${utils.getProjectId()}/apartmentleasebackclients/${payload.id}/`,
        payload,
        function(res) {
          resolve(res);
        },
        function(error) {
          reject(error);
        },
        6000000
      );
    });
  },
  GET_APARTMENT_LEASEBACK_CLIENTS_LIST: (context, payload) => {
    return new Promise((resolve, reject) => {
      common.getRequest(
        `/api/v1/${utils.getProjectId()}/apartmentleasebackclients/`,
        {},
        function(res) {
          context.commit("GET_APARTMENT_LEASEBACK_CLIENTS_LIST", res.data);
          resolve(res);
        },
        function(error) {
          reject(error);
        }
      );
    });
  },
  ADD_APARTMENT_LEASEBACK_STAY_POLICY: (context, payload) => {
    return new Promise((resolve, reject) => {
      common.postRequest(
        `/api/v1/${utils.getProjectId()}/apartmentleasebackstaypolicy/`,
        payload,
        function(res) {
          resolve(res.data);
        },
        function(error) {
          reject(error);
        }
      );
    });
  },
  UPDATE_APARTMENT_LEASEBACK_STAY_POLICY: (context, payload) => {
    return new Promise((resolve, reject) => {
      common.putRequest(
        `/api/v1/${utils.getProjectId()}/apartmentleasebackstaypolicy/${payload.id}/`,
        payload,
        function(res) {
          resolve(res.data);
        },
        function(error) {
          reject(error);
        }
      );
    });
  },
  GET_DETAIL_APARTMENT_LEASEBACK_STAY_POLICY: (context, payload) => {
    return new Promise((resolve, reject) => {
      common.getRequest(
        `/api/v1/${utils.getProjectId()}/apartmentleasebackstaypolicy/${payload.id}/`,
        payload,
        function(res) {
          resolve(res.data);
        },
        function(error) {
          reject(error);
        }
      );
    });
  },
  GET_ROOM_POLICY_WITH_BED_ROOM: (context, payload) => {
    return new Promise((resolve, reject) => {
      common.getRequest(
        `/api/v1/${utils.getProjectId()}/apartmentleasebackstaypolicy/get_room_policy_with_bed_rooms/`,
        payload,
        function(res) {
          resolve(res.data);
        },
        function(error) {
          reject(error);
        }
      );
    });
  },
  GET_APARTMENT_LEASEBACK_STAY_POLICY: (context, payload) => {
    return new Promise((resolve, reject) => {
      common.getRequest(
        `/api/v1/${utils.getProjectId()}/apartmentleasebackstaypolicy/`,
        payload,
        function(res) {
          resolve(res.data);
        },
        function(error) {
          reject(error);
        }
      );
    });
  },
  DELETE_APARTMENT_LEASEBACK_STAY_POLICY: (context, payload) => {
    return new Promise((resolve, reject) => {
      common.deleteRequest(
        `/api/v1/${utils.getProjectId()}/apartmentleasebackstaypolicy/${payload.id}/`,
        payload,
        function(res) {
          resolve(res.data);
        },
        function(error) {
          reject(error);
        }
      );
    });
  },
  DETAILED_REPORT_BY_EACH_MONTH: (context, payload) => {
    return new Promise((resolve, reject) => {
      common.getRequest(
        `/api/v1/${utils.getProjectId()}/apartmentmonthlyusage/get_detailed_report_by_each_month/`,
        payload,
        function(res) {
          context.commit("DETAILED_REPORT_BY_EACH_MONTH", res.data);
          resolve(res);
        },
        function(error) {
          reject(error);
        }
      );
    });
  },
  GET_DETAILED_REPORT_A_MONTH: (context, payload) => {
    return new Promise((resolve, reject) => {
      common.getRequest(
        `/api/v1/${utils.getProjectId()}/apartmentmonthlyusage/get_detailed_report_a_month/`,
        payload,
        function(res) {
          context.commit("GET_DETAILED_REPORT_A_MONTH", res.data);
          resolve(res);
        },
        function(error) {
          reject(error);
        }
      );
    });
  },
  CHECKOUT_APARTMENT_BOOKING: (context, payload) => {
    return new Promise((resolve, reject) => {
      common.postRequest(
        `/api/v1/${utils.getProjectId()}/apartmentbookings/${payload.id}/checkout_apartment_booking/`,
        payload,
        function(res) {
          // context.commit("GET_DETAILED_REPORT_A_MONTH", res.data);
          resolve(res);
        },
        function(error) {
          reject(error);
        }
      );
    });
  },
  CANCEL_APARTMENT_BOOKING: (context, payload) => {
    return new Promise((resolve, reject) => {
      common.postRequest(
        `/api/v1/${utils.getProjectId()}/apartmentbookings/${payload.id}/cancel_apartment_booking/`,
        payload,
        function(res) {
          resolve(res);
        },
        function(error) {
          reject(error);
        }
      );
    });
  },
  CANCEL_APARTMENT_BOOKING_GROUP: (context, payload) => {
    return new Promise((resolve, reject) => {
      common.postRequest(
        `/api/v1/${utils.getProjectId()}/apartmentgroupbookings/${payload.id}/cancel_apartment_booking_group/`,
        payload,
        function(res) {
          resolve(res);
        },
        function(error) {
          reject(error);
        }
      );
    });
  },
  CONVERT_TO_EINVOICE_BKAV: (context, payload) => {
    return new Promise((resolve, reject) => {
      common.postRequest(
        `/api/v1/${utils.getProjectId()}/invoiceeinvoicebkav/convert_to_bkav_booking/`,
        payload,
        function(res) {
          resolve(res.data);
        },
        function(error) {
          reject(error);
        },
        60000
      );
    });
  },
  FILTER_BKAV_LIST: (context, payload) => {
    return new Promise((resolve, reject) => {
      common.getRequest(
        `/api/v1/${utils.getProjectId()}/invoiceeinvoicebkav/filter_list/`,
        payload,
        function(res) {
          resolve(res.data);
        },
        function(error) {
          reject(error);
        },
        60000
      );
    });
  },
  ADD_EINVOICE_BKAV: (context, payload) => {
    return new Promise((resolve, reject) => {
      common.postRequest(
        `/api/v1/${utils.getProjectId()}/invoiceeinvoicebkav/`,
        payload,
        function(res) {
          resolve(res.data);
        },
        function(error) {
          reject(error);
        }
      );
    });
  },
  UPDATE_EINVOICE_BKAV: (context, payload) => {
    return new Promise((resolve, reject) => {
      common.putRequest(
        `/api/v1/${utils.getProjectId()}/invoiceeinvoicebkav/${payload.id}/`,
        payload,
        function(res) {
          resolve(res);
        },
        function(error) {
          reject(error);
        }
      );
    });
  },
  GET_EINVOICE_BKAV_LIST: (context, payload) => {
    return new Promise((resolve, reject) => {
      common.getRequest(
        `/api/v1/${utils.getProjectId()}/invoiceeinvoicebkav/`,
        payload,
        function(res) {
          if (payload != null) {
            res.data["page"] = payload.params.page;
          }
          context.commit("GET_EINVOICE_BKAV_LIST", res.data);
          resolve(res);
        },
        function(error) {
          reject(error);
        }
      );
    });
  },
  DELETE_EINVOICE_BKAV: (context, payload) => {
    return new Promise((resolve, reject) => {
      common.deleteRequest(
        `/api/v1/${utils.getProjectId()}/invoiceeinvoicebkav/${payload.id}/`,
        {},
        function(res) {
          resolve(res);
        },
        function(error) {
          reject(error);
        }
      );
    });
  },
  GET_BOOKING_PAYMENT_LIST: (context, payload) => {
    return new Promise((resolve, reject) => {
      common.getRequest(
        `/api/v1/${utils.getProjectId()}/bookingpayment/`,
        {},
        function(res) {
          context.commit("GET_BOOKING_PAYMENT_LIST", res.data);
          resolve(res.data);
        },
        function(error) {
          reject(error);
        }
      );
    });
  },
  ADD_INVOICE_GENERAL_INVOICE: (context, payload) => {
    return new Promise((resolve, reject) => {
      common.postRequest(
        `/api/v1/${utils.getProjectId()}/invoicegeneralinvoice/`,
        payload,
        function(res) {
          resolve(res.data);
        },
        function(error) {
          reject(error);
        }
      );
    });
  },
  UPDATE_INVOICE_GENERAL_INVOICE: (context, payload) => {
    return new Promise((resolve, reject) => {
      common.putRequest(
        `/api/v1/${utils.getProjectId()}/invoicegeneralinvoice/${payload.id}/`,
        payload,
        function(res) {
          resolve(res.data);
        },
        function(error) {
          reject(error);
        }
      );
    });
  },
  DELETE_INVOICE_GENERAL_INVOICE: (context, payload) => {
    return new Promise((resolve, reject) => {
      common.deleteRequest(
        `api/v1/${utils.getProjectId()}/invoicegeneralinvoice/${payload.id}/`,
        {},
        function(res) {
          resolve(res);
        },
        function(error) {
          reject(error);
        }
      );
    });
  },
  GET_INVOICE_GENERAL_INVOICE_LIST: (context, payload) => {
    return new Promise((resolve, reject) => {
      common.getRequest(
        `/api/v1/${utils.getProjectId()}/invoicegeneralinvoice/`,
        payload,
        function(res) {
          if (payload != null) {
            res.data["page"] = payload.params.page;
          }
          context.commit("GET_INVOICE_GENERAL_INVOICE_LIST", res.data);
          resolve(res);
        },
        function(error) {
          reject(error);
        }
      );
    });
  },
  GET_INVOICE_GENERAL_INVOICE_DETAIL: (context, payload) => {
    return new Promise((resolve, reject) => {
      common.getRequest(
        `/api/v1/${utils.getProjectId()}/invoicegeneralinvoice/${payload.id}/`,
        {},
        function(res) {
          context.commit("GET_INVOICE_GENERAL_INVOICE_DETAIL", res.data);
          resolve(res);
        },

        function(error) {
          reject(error);
        }
      );
    });
  },
  UPDATE_INVOICE_TOTAL_LEFT_FEES: (context, payload) => {
    return new Promise((resolve, reject) => {
      common.postRequest(
        `/api/v1/${utils.getProjectId()}/invoice/update_total_left_fees/`,
        payload,
        function(res) {
          resolve(res.data);
        },
        function(error) {
          reject(error);
        }
      );
    });
  },
  ADD_RECEIPT_EXPLAINATION: (context, payload) => {
    return new Promise((resolve, reject) => {
      common.postRequest(
        `/api/v1/receiptexplaination/`,
        payload,
        function(res) {
          resolve(res.data);
        },
        function(error) {
          reject(error);
        },
        60000
      );
    });
  },
  SET_SERVICE_DEFAULT_FEE_PROJECT: (context, payload) => {
    return new Promise((resolve, reject) => {
      common.postRequest(
        `/api/v1/project/${payload.id}/set_service_default_fee/`,
        payload,
        function(res) {
          resolve(res.data);
        },
        function(error) {
          reject(error);
        }
      );
    });
  },
  SET_LEASE_BACK_TIME_PROJECT: (context, payload) => {
    return new Promise((resolve, reject) => {
      common.postRequest(
        `/api/v1/project/${payload.id}/set_lease_back_time/`,
        payload,
        function(res) {
          resolve(res.data);
        },
        function(error) {
          reject(error);
        }
      );
    });
  },
  GET_ACCOUNTING_HOME_BALANCE_APARTMENT: (context, payload) => {
    return new Promise((resolve, reject) => {
      common.getRequest(
        `/api/v1/${utils.getProjectId()}/apartment/get_accounting_home_balance_by_apartment/?apartment_code=${
          payload.apartment_code
        }`,
        payload,
        function(res) {
          resolve(res.data);
        },
        function(error) {
          reject(error);
        }
      );
    });
  },
  CREATE_USER_EXPORT_INFO: (context, payload) => {
    return new Promise((resolve, reject) => {
      common.postRequest(
        `/api/v1/${utils.getProjectId()}/userexportinfo/`,
        payload,
        function(res) {
          resolve(res.data);
        },
        function(error) {
          reject(error);
        }
      );
    });
  },
  GET_USER_EXPORT_INFO_LIST: (context, payload) => {
    return new Promise((resolve, reject) => {
      common.getRequest(
        `/api/v1/${utils.getProjectId()}/userexportinfo/`,
        payload,
        function(res) {
          resolve(res.data);
        },
        function(error) {
          reject(error);
        }
      );
    });
  },
  UPDATE_USER_EXPORT_INFO: (context, payload) => {
    return new Promise((resolve, reject) => {
      common.putRequest(
        `/api/v1/${utils.getProjectId()}/userexportinfo/${payload.id}/`,
        payload,
        function(res) {
          resolve(res.data);
        },
        function(error) {
          reject(error);
        }
      );
    });
  },
  DELETE_USER_EXPORT_INFO: (context, payload) => {
    return new Promise((resolve, reject) => {
      common.deleteRequest(
        `/api/v1/${utils.getProjectId()}/userexportinfo/${payload.id}/`,
        payload,
        function(res) {
          resolve(res.data);
        },
        function(error) {
          reject(error);
        }
      );
    });
  },
  GET_THE_LATEST_RECEIPT: (context, payload) => {
    return new Promise((resolve, reject) => {
      common.getRequest(
        `/api/v1/${utils.getProjectId()}/receipt/get_the_latest_receipt/`,
        {},
        function(res) {
          resolve(res.data);
        },
        function(error) {
          reject(error);
        }
      );
    });
  },
  GET_RECEIPT_EXPLAINATION_BY_RECEIPT_ID: (context, payload) => {
    return new Promise((resolve, reject) => {
      common.getRequest(
        `/api/v1/receiptexplaination/get_receipt_explaination_by_receipt_id/?id=${
          payload.id
        }`,
        {},
        function(res) {
          resolve(res.data);
        },
        function(error) {
          reject(error);
        }
      );
    });
  },
  STATISTICS_HAS_BREAKFAST_RESIDENT_CLIENTS: (context, payload) => {
    return new Promise((resolve, reject) => {
      common.getRequest(
        `/api/v1/${utils.getProjectId()}/apartmentbookings/statistics_has_breakfast_resident_clients/`,
        payload,
        function(res) {
          resolve(res.data);
          context.commit("STATISTICS_HAS_BREAKFAST_RESIDENT_CLIENTS", res.data);
        },
        function(error) {
          reject(error);
        }
      );
    });
  },
  GET_APARTMENT_CLEANING_SERVICE: (context, payload) => {
    return new Promise((resolve, reject) => {
      common.getRequest(
        `/api/v1/${utils.getProjectId()}/apartment/cleaning_services_apartment_list/?start_time=${
          payload.params.start_time
        }`,
        payload.data,
        function(res) {
          context.commit("GET_APARTMENT_CLEANING_SERVICE", res.data);
          resolve(res.data);
        },
        function(error) {
          reject(error);
        }
      );
    });
  },
  GET_APARTMENT_CLEANING_SERVICE_START_END_TIME: (context, payload) => {
    return new Promise((resolve, reject) => {
      common.getRequest(
        `/api/v1/${utils.getProjectId()}/apartment/cleaning_services_apartment_list_start_end_time/?start_time=${payload.params.start_time}&end_time=${payload.params.end_time}`,
        payload.data,
        function(res) {
          context.commit(
            "GET_APARTMENT_CLEANING_SERVICE_START_END_TIME",
            res.data
          );
          resolve(res.data);
        },
        function(error) {
          reject(error);
        }
      );
    });
  },
  GET_APARTMENT_CLEANING_SERVICE_BY_ID: (context, payload) => {
    return new Promise((resolve, reject) => {
      common.getRequest(
        `/api/v1/${utils.getProjectId()}/apartmentcleaningservice/${payload.id}/`,
        {},
        function(res) {
          resolve(res.data);
        },
        function(error) {
          reject(error);
        }
      );
    });
  },
  GET_MOBILE_NOTIFICATION: (context, payload) => {
    return new Promise((resolve, reject) => {
      common.getRequest(
        `/api/v1/${utils.getProjectId()}/listnotification/`,
        payload,
        function(res) {
          context.commit("GET_MOBILE_NOTIFICATION", res.data);
          resolve(res.data);
        },
        function(error) {
          reject(error);
        }
      );
    });
  },
  UPDATE_NOTIFICATION: (context, payload) => {
    return new Promise((resolve, reject) => {
      common.putRequest(
        `/api/v1/${utils.getProjectId()}/todolist/${payload.id}/`,
        {},
        function(res) {
          resolve(res.data);
        },
        function(error) {
          reject(error);
        }
      );
    });
  },

  //server setting
  GET_SMTP_PROJECT: (context, payload) => {
    return new Promise((resolve, reject) => {
      common.getRequest(
        `/api/v1/${utils.getProjectId()}/projectserversetting/get_smtp_project/`,
        payload,
        function(res) {
          context.commit("GET_SMTP_PROJECT", res.data), resolve(res);
        },
        function(error) {
          reject(error);
        }
      );
    });
  },
  PUSH_SMTP_PROJECT: (context, payload) => {
    return new Promise((resolve, reject) => {
      common.postRequest(
        `/api/v1/${utils.getProjectId()}/projectserversetting/put_smtp_project/`,
        payload,
        function(res) {
          resolve(res);
        },
        function(error) {
          reject(error);
        }
      );
    });
  },
  GET_SMTP_PROJECT_LIST: (context, payload) => {
    return new Promise((resolve, reject) => {
      common.getRequest(
            `api/v1/${utils.getProjectId()}/projectserversetting/get_smtp_project_list/`,
            payload,
            function (res) {
                context.commit("GET_SMTP_PROJECT_LIST", res.data)
                resolve(res)
            },
            function (error) {
                reject(error)
            }
        )
    })
  },
  GET_SETTING_PROJECT_SMTP: (context, payload) => {
    return new Promise((resolve, reject) => {
      common.getRequest(
        `/api/v1/${utils.getProjectId()}/projectserversetting/get_setting_project_smtp/`,
        payload,
        function(res) {
          context.commit("GET_SETTING_PROJECT_SMTP", res.data);
          resolve(res);
        },
        function(error) {
          reject(error);
        }
      );
    });
  },
  USING_PRIVATE_SMTP_CONFIG(context, payload) {
    return new Promise((resolve, reject) => {
      common.putRequest(
            `api/v1/${utils.getProjectId()}/projectserversetting/using_private_smtp_config/`,
            payload,
            function (res) {
                resolve(res)
            },
            function (error) {
                reject(error)
            }
        )
    })
  },
  GET_CONFIG_SMTP_EMAIL_SERVER: (context, payload) => {
    return new Promise((resolve, reject) => {
      common.getRequest(
        `/api/v1/${utils.getProjectId()}/projectserversetting/get_config_smtp_email_server/`,
        payload,
        function(res) {
          context.commit("GET_CONFIG_SMTP_EMAIL_SERVER", res.data),
            resolve(res);
        },
        function(error) {
          reject(error);
        }
      );
    });
  },
  PUSH_CONFIG_SMTP_EMAIL_SERVER: (context, payload) => {
    return new Promise((resolve, reject) => {
      common.putRequest(
        `/api/v1/${utils.getProjectId()}/projectserversetting/put_config_smtp_email_server/`,
        payload,
        function(res) {
            resolve(res);
        },
        function(error) {
          reject(error);
        }
      );
    });
  },
  PUSH_SMTP_PASWORD: (context, payload) => {
    return new Promise((resolve, reject) => {
      common.putRequest(
        `/api/v1/${utils.getProjectId()}/projectserversetting/put_smtp_password/`,
        payload,
        function(res) {
            resolve(res);
        },
        function(error) {
          reject(error);
        }
      );
    });
  },
  SET_PROJECT_SMTP_SETTING: (context, payload) => {
    return new Promise((resolve, reject) => {
      common.postRequest(
        `/api/v1/${utils.getProjectId()}/projectserversetting/set_project_smtp_setting/`,
        payload,
        function(res) {
          resolve(res);
        },
        function(error) {
          reject(error);
        }
      );
    });
  },
  SEND_EMAIL_FOR_TESTINNG: (context, payload) => {
    return new Promise((resolve, reject) => {
      common.postRequest(
        `/api/v1/${utils.getProjectId()}/projectserversetting/send_test_mail/`,
        payload,
        function(res) {
          resolve(res);
        },
        function(error) {
          reject(error);
        }
      );
    });
  },
  GET_APARTMENT_FROM_ACCOUTINGHOMEBALANCE: (context, payload) => {
    return new Promise((resolve, reject) => {
      common.getRequest(
        `/api/v1/${utils.getProjectId()}/apartmentcodefromaccoutinghomebalace/`,
        payload,
        function(res) {
          context.commit("GET_APARTMENT_FROM_ACCOUTINGHOMEBALANCE", res.data);
        },
        function(error) {
          reject(error);
        }
      );
    });
  },
  GET_TEMPLATE_EMAIL_OBJECT: (context, payload) => {
    return new Promise((resolve, reject) => {
      common.getRequest(
        "/api/v1/templateobjemail/",
        payload,
        function(res) {
          context.commit("GET_TEMPLATE_EMAIL_OBJECT", res.data);
        },
        function(error) {
          reject(error);
        }
      );
    });
  },
  ADD_TEMPLATE_EMAIL: (context, payload) => {
    return new Promise((resolve, reject) => {
      common.postRequest(
        `/api/v1/${utils.getProjectId()}/templateemail/`,
        payload,
        function(res) {
          resolve(res);
        },
        function(error) {
          reject(error);
        }
      );
    });
  },
  GET_TEMPLATE_DATA: (context, payload) => {
    return new Promise((resolve, reject) => {
      common.getRequest(
        `/api/v1/${utils.getProjectId()}/templateemail/`,
        payload,
        function(res) {
          if (payload != null) {
            res.data["page"] = payload.params.page;
          }
          context.commit("GET_TEMPLATE_DATA", res.data);
        },
        function(err) {
          reject(err);
        }
      );
    });
  },
  GET_TEMPLATE_DETAIL: (context, payload) => {
    return new Promise((resolve, reject) => {
      common.getRequest(
        `/api/v1/${utils.getProjectId()}/templateemail/${payload.id}/`,
        payload,
        function(res) {
          context.commit("GET_TEMPLATE_DETAIL", res.data);
        },
        function(error) {
          reject(error);
        }
      );
    });
  },
  UPDATE_TEMPLATE_EMAIL: (context, payload) => {
    return new Promise((resolve, reject) => {
      common.putRequest(
        `/api/v1/${utils.getProjectId()}/templateemail/${payload.id}/`,
        payload,
        function(res) {
          resolve(res);
        },
        function(err) {
          reject(err);
        }
      );
    });
  },
  DELETE_FORM_EMAIL: (context, payload) => {
    return new Promise((resolve, reject) => {
      common.deleteRequest(
        `api/v1/${utils.getProjectId()}/templateemail/${payload.id}/`,
        {},
        function(res) {
          context.commit("DELETE_FORM_EMAIL", res.data);
          resolve(res);
        },
        function(error) {
          reject(error);
        }
      );
    });
  },
  GET_EMAIL_TEMPLATE_CATEGORY: (context, payload) => {
    return new Promise((resolve, reject) => {
      common.getRequest(
        `/api/v1/${utils.getProjectId()}/templateemail/get_email_template_category/`,
        payload,
        function(res) {
          if (payload != null) {
            res.data["page"] = payload.params.page;
            context.commit("GET_EMAIL_TEMPLATE_CATEGORY", res.data);
          }
        },
        function(err) {
          reject(err);
        }
      );
    });
  },
  ENABLE_EMAIL_TEMPLATE: (context, payload) => {
    return new Promise((resolve, reject) => {
      common.putRequest(
        `/api/v1/${utils.getProjectId()}/templateemail/${payload.id}/enable_template_email/`,
        payload,
        function(res) {
          resolve(res.data);
        },
        function(error) {
          reject(error);
        },
      );
    });
  },
  GET_PROJECT_TEMPLATE: (context, payload) => {
    return new Promise((resolve, reject) => {
      common.getRequest(
        `/api/v1/${utils.getProjectId()}/projectemailtemplatesetting/`,
        payload,
        function(res) {
          context.commit("GET_PROJECT_TEMPLATE", res.data);
        },
        function(error) {
          reject(error);
        }
      );
    });
  },
  UPDATE_PROJECT_EMAIL_TEMPLATE: (context, payload) => {
    return new Promise((resolve, reject) => {
      common.putRequest(
        `/api/v1/${utils.getProjectId()}/projectemailtemplatesetting/${payload.id}/`,
        payload,
        function(res) {
          resolve(res);
        },
        function(err) {
          reject(err);
        }
      );
    });
  },
  DELETE_APARTMENT_SCHEDULE_PROGRESS_LIST: (context, payload) => {
    return new Promise((resolve, reject) => {
      common.postRequest(
        `/api/v1/${utils.getProjectId()}/apartmentscheduleprogress/delete_apartment_schedule_progress_list/`,
        payload,
        function(res) {
          context.commit("DELETE_APARTMENT_SCHEDULE_PROGRESS_LIST", res.data);
          resolve(res.data);
        },
        function(error) {
          reject(error);
        },
        6000000
      );
    });
  },
  GET_PROJECT_TEMPLATE_USED: (context, payload) => {
    return new Promise((resolve, reject) => {
      common.getRequest(
        `/api/v1/${utils.getProjectId()}/projectemailtemplatesetting/get_project_template_email/`,
        payload,
        function(res) {
          context.commit("GET_PROJECT_TEMPLATE_USED", res.data);
        },
        function(error) {
          reject(error);
        }
      );
    });
  },
  ADD_ADVERTISE: (context, payload) => {
    return new Promise((resolve, reject) => {
      common.postRequest(
        `/api/v1/${utils.getProjectId()}/advertise/`,
        payload,
        function(res) {
          resolve(res);
        },
        function(error) {
          reject(error);
        }
      );
    });
  },
  DELETE_ADVERTISE: (context, payload) => {
    return new Promise((resolve, reject) => {
      common.deleteRequest(
        `/api/v1/${utils.getProjectId()}/advertise/${payload.id}/`,
        {},
        function(res) {
          resolve(res);
        },
        function(error) {
          reject(error);
        }
      );
    });
  },
  GET_REWARD_POINT: (context, payload) => {
    return new Promise((resolve, reject) => {
      common.getRequest(
        `/api/v1/${utils.getProjectId()}/rewardpoint/`,
        payload,
        function(res) {
          context.commit("GET_REWARD_POINT", res.data);
        },
        function(error) {
          reject(error);
        }
      );
    });
  },
  UPDATE_ADVERTISE: (context, payload) => {
    return new Promise((resolve, reject) => {
      common.putRequest(
        `/api/v1/${utils.getProjectId()}/advertise/${payload.id}/`,
        payload,
        function(res) {
          resolve(res);
        },
        function(error) {
          reject(error);
        }
      );
    });
  },
  UPDATE_REWARD_POINT: (context, payload) => {
    return new Promise((resolve, reject) => {
      common.postRequest(
        `/api/v1/${utils.getProjectId()}/rewardpoint/`,
        payload,
        function(res) {
          resolve(res);
        },
        function(error) {
          reject(error);
        }
      );
    });
  },
  GET_ADVERTISE_DATA: (context, payload) => {
    return new Promise((resolve, reject) => {
      common.getRequest(
        `/api/v1/${utils.getProjectId()}/advertise/`,
        payload,
        function(res) {
          context.commit("GET_ADVERTISE_DATA", res.data);
          resolve(res.data);
        },
        function(error) {
          reject(error);
        }
      );
    });
  },
  GET_ADVERTISE_DETAIL: (context, payload) => {
    return new Promise((resolve, reject) => {
      common.getRequest(
        `/api/v1/${utils.getProjectId()}/advertise/${payload.id}/`,
        payload,
        function(res) {
          context.commit("GET_ADVERTISE_DETAIL", res.data);
          resolve(res.data);
        },

        function(error) {
          reject(error);
        }
      );
    });
  },
  SEND_MAIL_REWARD_POINT: (context, payload) => {
    return new Promise((resolve, reject) => {
      common.postRequest(
        `/api/v1/${utils.getProjectId()}/managementemails/send_mail_reward_point/`,
        payload,
        function(res) {
          resolve(res);
        },
        function(error) {
          reject(error);
        }
      );
    });
  },
  GET_CUSTOMER_LIST_REWARD_POINT: (context, payload) => {
    return new Promise((resolve, reject) => {
      common.getRequest(
        `api/v1/${utils.getProjectId()}/customers/`,
        payload,
        function(res) {
          context.commit("GET_CUSTOMER_LIST_REWARD_POINT", res.data);
          resolve(res);
        },
        function(error) {
          reject(error);
        }
      );
    });
  },
  ADD_CONTRACT: (context, payload) => {
    return new Promise((resolve, reject) => {
      common.postRequest(
        `/api/v1/${utils.getProjectId()}/apartmentcontract/`,
        payload,
        function(res) {
          resolve(res);
        },
        function(error) {
          reject(error);
        }
      );
    });
  },
  UPDATE_CONTRACT: (context, payload) => {
    return new Promise((resolve, reject) => {
      common.putRequest(
        `/api/v1/${utils.getProjectId()}/apartmentcontract/${payload.id}/`,
        payload,
        function(res) {
          resolve(res);
        },
        function(error) {
          reject(error);
        }
      );
    });
  },
  SAVE_CASE_FILE_INFO: (context, payload) => {
    return new Promise((resolve, reject) => {
      common.postRequest(
        `/api/v1/${utils.getProjectId()}/case/save_case_file_info/`,
        payload,
        function(res) {
          resolve(res);
        },
        function(error) {
          reject(error);
        }
      );
    });
  },
  GET_UPLOAD_CASE_DATA: (context, payload) => {
    return new Promise((resolve, reject) => {
      common.getRequest(
        `/api/v1/${utils.getProjectId()}/case/get_upload_file_case/`,
        payload,
        function(res) {
          context.commit("GET_UPLOAD_CASE_DATA", res.data);
          resolve(res);
        },
        function(error) {
          reject(error);
        }
      );
    });
  },
  DELETE_CASE_FILES_URL: (context, payload) => {
    return new Promise((resolve, reject) => {
      common.deleteRequest(
        `/api/v1/${utils.getProjectId()}/case/${payload}/delete_file_upload_case/`,
        {},
        function(res) {
          resolve(res);
        },
        function(error) {
          reject(error);
        }
      );
    });
  },
  SAVE_CONTRACT_FILE_INFO: (context, payload) => {
    return new Promise((resolve, reject) => {
      common.postRequest(
        `/api/v1/${utils.getProjectId()}/apartmentcontract/save_contract_file_info/`,
        payload,
        function(res) {
          resolve(res);
        },
        function(error) {
          reject(error);
        }
      );
    });
  },
  GET_UPLOAD_CONTRACT_DATA: (context, payload) => {
    return new Promise((resolve, reject) => {
      common.getRequest(
        `/api/v1/${utils.getProjectId()}/apartmentcontract/get_upload_file_contract/`,
        payload,
        function(res) {
          context.commit("GET_UPLOAD_CONTRACT_DATA", res.data);
          resolve(res);
        },
        function(error) {
          reject(error);
        }
      );
    });
  },
  DELETE_FILE_URL: (context, payload) => {
    return new Promise((resolve, reject) => {
      common.deleteRequest(
        `/api/v1/${utils.getProjectId()}/apartmentcontract/${payload}/delete_file_upload_contract/`,
        {},
        function(res) {
          resolve(res);
        },
        function(error) {
          reject(error);
        }
      );
    });
  },
  GET_CONTRACT_DETAIL: (context, payload) => {
    return new Promise((resolve, reject) => {
      common.getRequest(
        `/api/v1/${utils.getProjectId()}/apartmentcontract/${payload.id}/`,
        {},
        function(res) {
          context.commit("GET_CONTRACT_DETAIL", res.data);
          resolve(res);
        },
        function(error) {
          reject(error);
        }
      );
    });
  },
  GET_CONTRACT_LIST: (context, payload) => {
    return new Promise((resolve, reject) => {
      common.getRequest(
        `/api/v1/${utils.getProjectId()}/apartmentcontract/`,
        payload,
        function(res) {
          if (
            payload != null &&
            payload.params.page != null &&
            payload.params.hasOwnProperty("page")
          ) {
            res.data["page"] = payload.params.page;
          }
          context.commit("GET_CONTRACT_LIST", res.data);
          resolve(res);
        },
        function(error) {
          reject(error);
        }
      );
    });
  },
  DELETE_CONTRACT: (context, payload) => {
    return new Promise((resolve, reject) => {
      common.postRequest(
        `/api/v1/${utils.getProjectId()}/apartmentcontract/delete_contract/`,
        payload,
        function(res) {
          context.commit("DELETE_CONTRACT", res.data);
          resolve(res);
        },
        function(error) {
          reject(error);
        }
      );
    });
  },
  ADD_PAYMENT_PROGRESS: (context, payload) => {
    return new Promise((resolve, reject) => {
      common.postRequest(
        `/api/v1/${utils.getProjectId()}/apartmentcontract/add_payment_progress/`,
        payload,
        function(res) {
          resolve(res);
        },
        function(error) {
          reject(error);
        }
      );
    });
  },
  PAYMENT_PROGRESS_LIST: (context, payload) => {
    return new Promise((resolve, reject) => {
      common.getRequest(
        `/api/v1/${utils.getProjectId()}/apartmentcontract/get_payment_progress/`,
        payload,
        function(res) {
          context.commit("PAYMENT_PROGRESS_LIST", res.data);
          resolve(res);
        },
        function(error) {
          reject(error);
        }
      );
    });
  },
  GET_PAYMENT_PROGRESS_DETAIL: (context, payload) => {
    return new Promise((resolve, reject) => {
      common.getRequest(
        `/api/v1/${utils.getProjectId()}/apartmentcontract/${payload}/get_payment_progress_detail/`,
        {},
        function(res) {
          context.commit("GET_PAYMENT_PROGRESS_DETAIL", res.data);
          resolve(res);
        },
        function(error) {
          reject(error);
        }
      );
    });
  },
  DELETE_PAYMENT_PROGRESS: (context, payload) => {
    return new Promise((resolve, reject) => {
      common.postRequest(
        `/api/v1/${utils.getProjectId()}/apartmentcontract/delete_payment_progress/`,
        payload,
        function(res) {
          resolve(res);
        },
        function(error) {
          reject(error);
        }
      );
    });
  },
  IMPORT_CONTRACT_EXCEL: (context, payload) => {
    return new Promise((resolve, reject) => {
      common.postRequest(
        `/api/v1/${utils.getProjectId()}/apartmentcontractimportexcel/`,
        payload,
        function(res) {
          resolve(res.data);
        },
        function(error) {
          reject(error);
        },
        600000
      );
    });
  },
  GET_BULK_DATA_IMPORT: (context, payload) => {
    return new Promise((resolve, reject) => {
      common.postRequest(
        `/api/v1/${utils.getProjectId()}/getmonthlyusagebulkdata/get_validation_bulk_data/`,
        payload,
        function(res) {
          context.commit("GET_BULK_DATA_IMPORT", res.data);
          resolve(res);
        },
        function(error) {
          reject(error);
        }
      );
    });
  },
  CONFIRM_IMPORT_BULK: (context, payload) => {
    return new Promise((resolve, reject) => {
      common.postRequest(
        `/api/v1/${utils.getProjectId()}/getmonthlyusagebulkdata/confirm_import_bulk_data/`,
        payload,
        function(res) {
          context.commit("CONFIRM_IMPORT_BULK", res.data);
          resolve(res);
        },
        function(error) {
          reject(error);
        }
      );
    });
  },
  ADD_USER_TO_PROJECT: (context, payload) => {
    return new Promise((resolve, reject) => {
      common.postRequest(
        `/api/v1/${utils.getProjectId()}/users/add_user_to_project/`,
        payload,
        function(res) {
          resolve(res.data);
        },
        function(error) {
          reject(error);
        },
        600000
      );
    });
  },
  REMOVE_USER_OUT_PROJECT: (context, payload) => {
    return new Promise((resolve, reject) => {
      common.putRequest(
        `/api/v1/${utils.getProjectId()}/users/${payload.id}/remove_user_out_project/`,
        payload,
        function(res) {
          resolve(res.data);
        },
        function(error) {
          reject(error);
        },
        600000
      );
    });
  },
  Add_CUSTOMER_TO_PROJECT: (context, payload) => {
    return new Promise((resolve, reject) => {
      common.postRequest(
        `/api/v1/${utils.getProjectId()}/users/add_customer_to_project/`,
        payload,
        function(res) {
          resolve(res.data);
        },
        function(error) {
          reject(error);
        },
        600000
      );
    });
  },
  ADD_NEW_PROJECT: (context, payload) => {
    return new Promise((resolve, reject) => {
      common.postRequest(
        "/api/v1/newproject/",
        payload,
        function(res) {
          resolve(res.data);
        },
        function(error) {
          reject(error);
        },
        600000
      );
    });
  },
  GET_AVAILABLE_MODULE: (context, payload) => {
    return new Promise((resolve, reject) => {
      common.getRequest(
        `/api/v1/newproject/${payload.id}/get_available_module/`,
        payload,
        function(res) {
          context.commit("GET_AVAILABLE_MODULE", res.data);
        },
        function(error) {
          reject(error);
        },
        600000
      );
    });
  },
  ADD_NEW_ADVERTISE_PROJECT_INFORMATION: (context, payload) => {
    return new Promise((resolve, reject) => {
      common.postRequest(
        `api/v1/${utils.getProjectId()}/advertise/add_new_advertise_project_information/`,
        payload,
        function(res) {
          resolve(res.data);
        },
        function(error) {
          reject(error);
        },
        6000000
      );
    });
  },
  UPDATE_ADVERTISE_PROJECT_INFORMATION: (context, payload) => {
    return new Promise((resolve, reject) => {
      common.putRequest(
        `/api/v1/${utils.getProjectId()}/advertise/${payload.id}/update_advertise_project_info/`,
        payload,
        function(res) {
          resolve(res);
        },
        function(error) {
          reject(error);
        }
      );
    });
  },
  DELETE_ADVERTISE_PROJECT_INFORMATION: (context, payload) => {
    return new Promise((resolve, reject) => {
      common.deleteRequest(
        `/api/v1/${utils.getProjectId()}/advertise/${payload.id}/delete_advertise_project_info/`,
        {},
        function(res) {
          resolve(res);
        },
        function(error) {
          reject(error);
        }
      );
    });
  },
  GET_ADVERTISE_DATA_PROJECT_INFO: (context, payload) => {
    return new Promise((resolve, reject) => {
      common.getRequest(
        `/api/v1/${utils.getProjectId()}/advertise/get_advertise_project_information/`,
        payload,
        function(res) {
          context.commit("GET_ADVERTISE_DATA_PROJECT_INFO", res.data);
          resolve(data);
        },
        function(error) {
          reject(error);
        }
      );
    });
  },
  GET_ADVERTISE_PROJECT_INFO_DETAIL: (context, payload) => {
    return new Promise((resolve, reject) => {
      common.putRequest(
        `/api/v1/${utils.getProjectId()}/advertise/${payload.id}/detail_advertise_project_info/`,
        payload,
        function(res) {
          context.commit("GET_ADVERTISE_PROJECT_INFO_DETAIL", res.data);
          resolve(res.data);
        },

        function(error) {
          reject(error);
        }
      );
    });
  },
  // User Guest
  ADD_USER_GUEST: (context, payload) => {
    return new Promise((resolve, reject) => {
      common.postRequest(
        `/api/v1/${utils.getProjectId()}/customers/add_user_guest/`,
        payload,
        function(res) {
          resolve(res.data);
        },
        function(error) {
          reject(error);
        }
      );
    });
  },
  GET_USER_GUEST_DETAIL: (context, payload) => {
    return new Promise((resolve, reject) => {
      common.putRequest(
        `/api/v1/${utils.getProjectId()}/customers/${payload.id}/user_guest_detail/`,
        payload,
        function(res) {
          context.commit("GET_USER_GUEST_DETAIL", res.data);
          resolve(res.data);
        },
        function(error) {
          reject(error);
        }
      );
    });
  },
  GET_USER_GUEST_DETAIL_NAME: (context, payload) => {
    return new Promise((resolve, reject) => {
      common.getRequest(
        `/api/v1/${utils.getProjectId()}/customers/${payload.id}/user_guest_detail_name/`,
        payload,
        function(res) {
          resolve(res.data);
        },
        function(error) {
          reject(error);
        }
      );
    });
  },
  UPDATE_USER_GUEST_STATUS: (context, payload) => {
    return new Promise((resolve, reject) => {
      common.putRequest(
        `/api/v1/${utils.getProjectId()}/customers/${payload.id}/update_user_guest_status/`,
        payload,
        function(res) {
          resolve(res.data);
        },
        function(error) {
          reject(error);
        }
      );
    });
  },
  UPDATE_USER_GUEST: (context, payload) => {
    return new Promise((resolve, reject) => {
      common.putRequest(
        `/api/v1/${utils.getProjectId()}/customers/${payload.id}/update_user_guest/`,
        payload,
        function(res) {
          resolve(res.data);
        },
        function(error) {
          reject(error);
        }
      );
    });
  },
  REMOVE_USER_GUEST: (context, payload) => {
    return new Promise((resolve, reject) => {
      common.putRequest(
        `/api/v1/${utils.getProjectId()}/customers/${payload.id}/remove_user_guest/`,
        payload,
        function(res) {
          resolve(res.data);
        },
        function(error) {
          reject(error);
        },
        600000
      );
    });
  },
  GET_USER_GUEST_LIST: (context, payload) => {
    return new Promise((resolve, reject) => {
      common.getRequest(
        `/api/v1/${utils.getProjectId()}/customers/get_user_guest/`,
        payload,
        function(res) {
          res.data["page"] = payload.params.page;
          context.commit("GET_USER_GUEST_LIST", res.data);
          resolve(res);
        },
        function(error) {
          reject(error);
        }
      );
    });
  },
  GET_CUSTOMER_TYPE_LIST: (context, payload) => {
    return new Promise((resolve, reject) => {
      common.getRequest(
        `/api/v1/${utils.getProjectId()}/customers/get_total_customer_type/`,
        payload,
        function(res) {
          resolve(res);
        },
        function(error) {
          reject(error);
        }
      );
    });
  },
  //permission
  UPDATE_MODULE: (context, payload) => {
    return new Promise((resolve, reject) => {
      common.postRequest(
          "/api/v1/projectmemberrolecode/",
        payload,
        function(res) {
          resolve(res);
        },
        function(error) {
          reject(error);
        }
      );
    });
  },
  CREATE_BANNER: (context, payload) => {
    return new Promise((resolve, reject) => {
      common.postRequest(
          `/api/v1/${utils.getProjectId()}/banner/`,
        payload,
        function(res) {
          resolve(res);
        },
        function(error) {
          reject(error);
        }
      );
    });
  },
  GET_BANNER_LIST: (context, payload) => {
    return new Promise((resolve, reject) => {
      common.getRequest(
          `/api/v1/${utils.getProjectId()}/banner/`,
        payload,
        function(res) {
          if (payload != null) {
            res.data["page"] = payload.params.page;
          }
          context.commit('GET_BANNER_LIST_HANDLER', res.data)
          resolve(res);
        },
        function(error) {
          reject(error);
        }
      );
    });
  },
  GET_BANNER_DETAIL: (context, payload) => {
    return new Promise((resolve, reject) => {
      common.getRequest(
          `/api/v1/${utils.getProjectId()}/banner/${payload.id}/`,
        payload,
        function(res) {
          resolve(res);
        },
        function(error) {
          reject(error);
        }
      );
    });
  },
  UPDATE_BANNER: (context, payload) => {
    return new Promise((resolve, reject) => {
      common.putRequest(
          `/api/v1/${utils.getProjectId()}/banner/${payload.id}/`,
        payload,
        function(res) {
          resolve(res);
        },
        function(error) {
          reject(error);
        }
      );
    });
  },
  DELETE_BANNER: (context, payload) => {
    return new Promise((resolve, reject) => {
      common.deleteRequest(
          `/api/v1/${utils.getProjectId()}/banner/${payload.id}/`,
        payload,
        function(res) {
          resolve(res);
        },
        function(error) {
          reject(error);
        }
      );
    });
  },
  ACTIVE_BANNER: (context, payload) => {
    return new Promise((resolve, reject) => {
      common.postRequest(
          `/api/v1/${utils.getProjectId()}/banner/active/`,
        payload,
        function(res) {
          resolve(res);
        },
        function(error) {
          reject(error);
        }
      );
    });
  },
  //##########################################################
  // config template notification
  //##########################################################
  GET_CATEGORY_NOTIFICATION: (context, payload) => {
    return new Promise((resolve, reject) => {
      common.getRequest(
        `/api/v1/${utils.getProjectId()}/category/`,
        payload,
        function(res) {
          context.commit("GET_CATEGORY_NOTIFICATION_HANDLE", res.data);
          resolve(res);
        },
        function(error) {
          reject(error);
        }
      );
    });
  },
  GET_TEMPLATE_NOTIFICATION_BY_CATEGORY: (context, payload) => {
    return new Promise((resolve, reject) => {
      common.getRequest(
        `/api/v1/${utils.getProjectId()}/category/get_template_notification_by_category/`,
        payload,
        function(res) {
          resolve(res);
        },
        function(error) {
          reject(error);
        }
      );
    });
  },
  GET_FIELD_NOTIFICATION_BY_CATEGORY: (context, payload) => {
    return new Promise((resolve, reject) => {
      common.getRequest(
        `/api/v1/${utils.getProjectId()}/category/get_field_notification_by_category/`,
        payload,
        function(res) {
          resolve(res);
        },
        function(error) {
          reject(error);
        }
      );
    });
  },
  GET_TEMPLATE_NOTIFICATION_DEFAULT: (context, payload) => {
    return new Promise((resolve, reject) => {
      common.getRequest(
        `/api/v1/${utils.getProjectId()}/category/get_template_notification_default/`,
        payload,
        function(res) {
          resolve(res);
        },
        function(error) {
          reject(error);
        }
      );
    });
  },
  CREATE_TEMPLATE_NOTIFICATION: (context, payload) => {
    return new Promise((resolve, reject) => {
      common.postRequest(
          `/api/v1/${utils.getProjectId()}/template_notification/`,
        payload,
        function(res) {
          resolve(res);
        },
        function(error) {
          reject(error);
        }
      );
    });
  },
  UPDATE_TEMPLATE_NOTIFICATION: (context, payload) => {
    return new Promise((resolve, reject) => {
      common.putRequest(
        `/api/v1/${utils.getProjectId()}/template_notification/${payload.id}/`,
        payload,
        function(res) {
          resolve(res.data);
        },
        function(error) {
          reject(error);
        },
        600000
      );
    });
  },
  ENABLE_TEMPLATE_NOTIFICATION: (context, payload) => {
    return new Promise((resolve, reject) => {
      common.putRequest(
        `/api/v1/${utils.getProjectId()}/template_notification/${payload.id}/enable_template_notification/`,
        payload,
        function(res) {
          resolve(res.data);
        },
        function(error) {
          reject(error);
        },
        600000
      );
    });
  },
  DELETE_TEMPLATE_NOTIFICATION: (context, payload) => {
    return new Promise((resolve, reject) => {
      common.deleteRequest(
        `/api/v1/${utils.getProjectId()}/template_notification/${payload.id}/`,
        {},
        function(res) {
          resolve(res);
        },
        function(error) {
          reject(error);
        }
      );
    });
  },
  GET_TEMPLATE_NOTIFICATION_DETAIL: (context, payload) => {
    return new Promise((resolve, reject) => {
      common.getRequest(
        `/api/v1/${utils.getProjectId()}/template_notification/${payload.id}/`,
        payload,
        function(res) {
          resolve(res.data);
        },
        function(error) {
          reject(error);
        }
      );
    });
  },
  GET_RESIDENTS_NEWS_LIST: (context, payload) => {
    return new Promise((resolve, reject) => {
      common.getRequest(
        `/api/v1/${utils.getProjectId()}/news/residents/`,
        payload,
        function(res) {
          context.commit('GET_RESIDENTS_NEWS_LIST', res.data)
          resolve(res.data);
        },
        function(error) {
          reject(error);
        }
      );
    });
  },
  CREATE_RESIDENT_NEWS: (context, payload) => {
    return new Promise((resolve, reject) => {
      common.postRequest(
        `/api/v1/${utils.getProjectId()}/news/residents/`,
        payload,
        function(res) {
          resolve(res.data);
        },
        function(error) {
          reject(error);
        }
      );
    });
  },
  GET_RESIDENT_NEWS_DETAIL: (context, payload) => {
    return new Promise((resolve, reject) => {
      common.getRequest(
        `/api/v1/${utils.getProjectId()}/news/residents/${payload.id}/`,
        payload,
        function(res) {
          resolve(res.data);
        },
        function(error) {
          reject(error);
        }
      );
    });
  },
  UPDATE_RESIDENT_NEWS: (context, payload) => {
    return new Promise((resolve, reject) => {
      common.putRequest(
        `/api/v1/${utils.getProjectId()}/news/residents/${payload.id}/`,
        payload,
        function(res) {
          resolve(res.data);
        },
        function(error) {
          reject(error);
        }
      );
    });
  },
  DELETE_RESIDENT_NEWS: (context, payload) => {
    return new Promise((resolve, reject) => {
      common.deleteRequest(
        `/api/v1/${utils.getProjectId()}/news/residents/${payload.id}/`,
        payload,
        function(res) {
          resolve(res.data);
        },
        function(error) {
          reject(error);
        }
      );
    });
  },
  GET_NEWS_LIST: (context, payload) => {
    return new Promise((resolve, reject) => {
      common.getRequest(
        `/api/v1/${utils.getProjectId()}/news/`,
        payload,
        function(res) {
          context.commit('GET_NEWS_LIST', res.data)
          resolve(res.data);
        },
        function(error) {
          reject(error);
        }
      );
    });
  },
  CREATE_NEWS: (context, payload) => {
    return new Promise((resolve, reject) => {
      common.postRequest(
        `/api/v1/${utils.getProjectId()}/news/`,
        payload,
        function(res) {
          resolve(res.data);
        },
        function(error) {
          reject(error);
        }
      );
    });
  },
  GET_NEWS_CATEGORY_LIST: (context, payload) => {
    return new Promise((resolve, reject) => {
      common.getRequest(
        `/api/v1/${utils.getProjectId()}/news_category/`,
        payload,
        function(res) {
          context.commit('GET_NEWS_CATEGORY_LIST', res.data)
          resolve(res.data);
        },
        function(error) {
          reject(error);
        }
      );
    });
  },
  CREATE_NEWS_CATEGORY: (context, payload) => {
    return new Promise((resolve, reject) => {
      common.postRequest(
        `/api/v1/${utils.getProjectId()}/news_category/`,
        payload,
        function(res) {
          resolve(res.data);
        },
        function(error) {
          reject(error);
        }
      );
    });
  },
  UPDATE_NEWS_CATEGORY: (context, payload) => {
    return new Promise((resolve, reject) => {
      common.putRequest(
        `/api/v1/${utils.getProjectId()}/news_category/${payload.id}/`,
        payload,
        function(res) {
          resolve(res.data);
        },
        function(error) {
          reject(error);
        }
      );
    });
  },
  GET_NEWS_CATEGORY_DETAIL: (context, payload) => {
    return new Promise((resolve, reject) => {
      common.getRequest(
        `/api/v1/${utils.getProjectId()}/news_category/${payload.id}/`,
        payload,
        function(res) {
          resolve(res.data);
        },
        function(error) {
          reject(error);
        }
      );
    });
  },
  DELETE_NEWS_CATEGORY: (context, payload) => {
    return new Promise((resolve, reject) => {
      common.deleteRequest(
        `/api/v1/${utils.getProjectId()}/news_category/${payload.id}/`,
        payload,
        function(res) {
          resolve(res.data);
        },
        function(error) {
          reject(error);
        }
      );
    });
  },
  GET_NEWS_DETAIL: (context, payload) => {
    return new Promise((resolve, reject) => {
      common.getRequest(
        `/api/v1/${utils.getProjectId()}/news/${payload.id}/`,
        payload,
        function(res) {
          resolve(res.data);
        },
        function(error) {
          reject(error);
        }
      );
    });
  },
  UPDATE_NEWS: (context, payload) => {
    return new Promise((resolve, reject) => {
      common.putRequest(
        `/api/v1/${utils.getProjectId()}/news/${payload.id}/`,
        payload,
        function(res) {
          resolve(res.data);
        },
        function(error) {
          reject(error);
        }
      );
    });
  },
  DELETE_NEWS: (context, payload) => {
    return new Promise((resolve, reject) => {
      common.deleteRequest(
        `/api/v1/${utils.getProjectId()}/news/${payload.id}/`,
        payload,
        function(res) {
          resolve(res.data);
        },
        function(error) {
          reject(error);
        }
      );
    });
  },
  // =======================================
  // Register export invoice
  // =======================================
  GET_REGISTER_EXPORT_INVOICE_LIST: (context, payload) => {
    return new Promise((resolve, reject) => {
      common.getRequest(
        `/api/v1/${utils.getProjectId()}/information_register_export_invoice/`,
        payload,
        function(res) {
          if(res.data["page"] !== undefined){
            context.commit('GET_REGISTER_EXPORT_INVOICE_LIST', res.data)
          } else {
            context.commit('GET_REGISTER_EXPORT_INVOICE_LIST_NO_PAGE', res.data)
          }
          resolve(res.data);
        },
        function(error) {
          reject(error);
        }
      );
    });
  },
  CREATE_REGISTER_EXPORT_INVOICE: (context, payload) => {
    return new Promise((resolve, reject) => {
      common.postRequest(
        `/api/v1/${utils.getProjectId()}/information_register_export_invoice/`,
        payload,
        function(res) {
          resolve(res.data);
        },
        function(error) {
          reject(error);
        }
      );
    });
  },
  UPDATE_REGISTER_EXPORT_INVOICE: (context, payload) => {
    return new Promise((resolve, reject) => {
      common.putRequest(
        `/api/v1/${utils.getProjectId()}/information_register_export_invoice/${payload.id}/`,
        payload,
        function(res) {
          resolve(res.data);
        },
        function(error) {
          reject(error);
        }
      );
    });
  },
  GET_REGISTER_EXPORT_INVOICE_DETAIL: (context, payload) => {
    return new Promise((resolve, reject) => {
      common.getRequest(
        `/api/v1/${utils.getProjectId()}/information_register_export_invoice/${payload.id}/`,
        payload,
        function(res) {
          resolve(res.data);
        },
        function(error) {
          reject(error);
        }
      );
    });
  },
  DELETE_REGISTER_EXPORT_INVOICE: (context, payload) => {
    return new Promise((resolve, reject) => {
      common.deleteRequest(
        `/api/v1/${utils.getProjectId()}/information_register_export_invoice/${payload.id}/`,
        {data: payload},
        function(res) {
          resolve(res.data);
        },
        function(error) {
          reject(error);
        },
        600000
      );
    });
  },
  // =======================================
  // Feedback
  // =======================================
  CREATE_FEEDBACK: (context, payload) => {
    return new Promise((resolve, reject) => {
      common.postRequest(
        `/api/v1/${utils.getProjectId()}/feedback/`,
        payload,
        function(res) {
          resolve(res.data);
        },
        function(error) {
          reject(error);
        }
      );
    });
  },
  UPDATE_FEEDBACK: (context, payload) => {
    return new Promise((resolve, reject) => {
      common.putRequest(
        `/api/v1/${utils.getProjectId()}/feedback/${payload.id}/`,
        payload,
        function(res) {
          resolve(res.data);
        },
        function(error) {
          reject(error);
        }
      );
    });
  },
  GET_FEEDBACK_DETAIL: (context, payload) => {
    return new Promise((resolve, reject) => {
      common.getRequest(
        `/api/v1/${utils.getProjectId()}/feedback/${payload.id}/`,
        payload,
        function(res) {
          resolve(res.data);
        },
        function(error) {
          reject(error);
        }
      );
    });
  },
  GET_FEEDBACK_LIST: (context, payload) => {
    return new Promise((resolve, reject) => {
      common.getRequest(
        `/api/v1/${utils.getProjectId()}/feedback/`,
        payload,
        function(res) {
          context.commit('GET_FEEDBACK_LIST', res.data)
          resolve(res.data);
        },
        function(error) {
          reject(error);
        }
      );
    });
  },
  DELETE_FEEDBACK: (context, payload) => {
    return new Promise((resolve, reject) => {
      common.deleteRequest(
        `/api/v1/${utils.getProjectId()}/feedback/${payload.id}/`,
        payload,
        function(res) {
          resolve(res.data);
        },
        function(error) {
          reject(error);
        }
      );
    });
  },
  GET_FEEDBACK_CHAT_LIST: (context, payload) => {
    return new Promise((resolve, reject) => {
      common.getRequest(
        `/api/v1/${utils.getProjectId()}/feedback/get_feedback_chat/`,
        payload,
        function(res) {
          context.commit('GET_FEEDBACK_CHAT_LIST', res.data)
          resolve(res.data);
        },
        function(error) {
          reject(error);
        }
      );
    });
  },
  CREATE_FEEDBACK_CHAT: (context, payload) => {
    return new Promise((resolve, reject) => {
      common.postRequest(
        `/api/v1/${utils.getProjectId()}/feedback/create_feedback_chat/`,
        payload,
        function(res) {
          resolve(res.data);
        },
        function(error) {
          reject(error);
        }
      );
    });
  },
  POST_CANCEL_FEEDBACK: (context, payload) => {
    return new Promise((resolve, reject) => {
      common.postRequest(
        `/api/v1/${utils.getProjectId()}/feedback/post_cancel_feedback/`,
        payload,
        function(res) {
          resolve(res.data);
        },
        function(error) {
          reject(error);
        }
      );
    });
  },
  POST_FEEDBACK_STATUS: (context, payload) => {
    return new Promise((resolve, reject) => {
      common.postRequest(
        `/api/v1/${utils.getProjectId()}/feedback/post_feedback_status/`,
        payload,
        function(res) {
          resolve(res.data);
        },
        function(error) {
          reject(error);
        }
      );
    });
  },
  GET_FEEDBACK_TECHNICAL_COMMENT_LIST: (context, payload) => {
    return new Promise((resolve, reject) => {
      common.getRequest(
        `/api/v1/${utils.getProjectId()}/feedback/get_feedback_technical_comment/`,
        payload,
        function(res) {
          resolve(res.data);
        },
        function(error) {
          reject(error);
        }
      );
    });
  },
  POST_FEEDBACK_TECHNICAL_COMMENT: (context, payload) => {
    return new Promise((resolve, reject) => {
      common.postRequest(
        `/api/v1/${utils.getProjectId()}/feedback/post_feedback_technical_comment/`,
        payload,
        function(res) {
          resolve(res.data);
        },
        function(error) {
          reject(error);
        }
      );
    });
  },
  UPDATE_FEEDBACK_CUSTOMER_CARE_DESCRIPTION: (context, payload) => {
    return new Promise((resolve, reject) => {
      common.postRequest(
        `/api/v1/${utils.getProjectId()}/feedback/update_customer_care_description/`,
        payload,
        function(res) {
          resolve(res.data);
        },
        function(error) {
          reject(error);
        }
      );
    });
  },
  UPDATE_ASSIGNER_AND_PROCESSOR_FEEDBACK: (context, payload) => {
    return new Promise((resolve, reject) => {
      common.postRequest(
        `/api/v1/${utils.getProjectId()}/feedback/update_assigner_and_processor/`,
        payload,
        function(res) {
          resolve(res.data);
        },
        function(error) {
          reject(error);
        }
      );
    });
  },
  GET_FEEDBACK_DETAIL_HISTORY: (context, payload) => {
    return new Promise((resolve, reject) => {
      common.getRequest(
        `/api/v1/${utils.getProjectId()}/feedback/${payload.id}/get_feedback_detail_history/`,
        payload,
        function(res) {
          if(res.data["page"] !== undefined){
            context.commit('GET_FEEDBACK_DETAIL_HISTORY_LIST', res.data)
          }
          resolve(res.data);
        },
        function(error) {
          reject(error);
        }
      );
    });
  },
  // =======================================
  // Department
  // =======================================
  GET_DEPARTMENT_LIST: (context, payload) => {
    return new Promise((resolve, reject) => {
      common.getRequest(
        `/api/v1/${utils.getProjectId()}/department/`,
        payload,
        function(res) {
          if(res.data["page"] !== undefined){
            context.commit('GET_DEPARTMENT_LIST', res.data)
          } else {
            context.commit('GET_DEPARTMENT_LIST_NO_PAGE', res.data)
          }
          resolve(res.data);
        },
        function(error) {
          reject(error);
        }
      );
    });
  },
  CREATE_DEPARTMENT: (context, payload) => {
    return new Promise((resolve, reject) => {
      common.postRequest(
        `/api/v1/${utils.getProjectId()}/department/`,
        payload,
        function(res) {
          resolve(res.data);
        },
        function(error) {
          reject(error);
        }
      );
    });
  },
  UPDATE_DEPARTMENT: (context, payload) => {
    return new Promise((resolve, reject) => {
      common.putRequest(
        `/api/v1/${utils.getProjectId()}/department/${payload.id}/`,
        payload,
        function(res) {
          resolve(res.data);
        },
        function(error) {
          reject(error);
        }
      );
    });
  },
  DELETE_DEPARTMENT: (context, payload) => {
    return new Promise((resolve, reject) => {
      common.deleteRequest(
        `/api/v1/${utils.getProjectId()}/department/${payload.id}/`,
        payload,
        function(res) {
          resolve(res.data);
        },
        function(error) {
          reject(error);
        }
      );
    });
  },
  ADD_USER_IN_DEPARTMENT: (context, payload) => {
    return new Promise((resolve, reject) => {
      common.postRequest(
        `/api/v1/${utils.getProjectId()}/department/add_user_in_department/`,
        payload,
        function(res) {
          resolve(res.data);
        },
        function(error) {
          reject(error);
        }
      );
    });
  },
  GET_USER_IN_DEPARTMENT: (context, payload) => {
    return new Promise((resolve, reject) => {
      common.getRequest(
        `/api/v1/${utils.getProjectId()}/department/get_user_in_department/`,
        payload,
        function(res) {
          resolve(res.data);
        },
        function(error) {
          reject(error);
        }
      );
    });
  },
  // =======================================
  // Subject in department
  // =======================================
  GET_FEEDBACK_SUBJECT_LIST: (context, payload) => {
    return new Promise((resolve, reject) => {
      common.getRequest(
        `/api/v1/${utils.getProjectId()}/feedback_subject/`,
        payload,
        function(res) {
          context.commit('GET_FEEDBACK_SUBJECT_LIST', res.data)
          resolve(res.data);
        },
        function(error) {
          reject(error);
        }
      );
    });
  },
  CREATE_FEEDBACK_SUBJECT: (context, payload) => {
    return new Promise((resolve, reject) => {
      common.postRequest(
        `/api/v1/${utils.getProjectId()}/feedback_subject/`,
        payload,
        function(res) {
          resolve(res.data);
        },
        function(error) {
          reject(error);
        }
      );
    });
  },
  UPDATE_FEEDBACK_SUBJECT: (context, payload) => {
    return new Promise((resolve, reject) => {
      common.putRequest(
        `/api/v1/${utils.getProjectId()}/feedback_subject/${payload.id}/`,
        payload,
        function(res) {
          resolve(res.data);
        },
        function(error) {
          reject(error);
        }
      );
    });
  },
  GET_USER_IN_APARTMENT_LIST: (context, payload) => {
    return new Promise((resolve, reject) => {
      common.getRequest(
        `/api/v1/${utils.getProjectId()}/apartment/get_user_in_apartment/`,
        payload,
        function(res) {
          resolve(res.data);
        },
        function(error) {
          reject(error);
        }
      );
    });
  },
  // =======================================
  // Get enable module and extra info
  // =======================================
  GET_ENABLE_MODULE_AND_EXTRA_INFO: (context, payload) => {
    return new Promise((resolve, reject) => {
      common.getRequest(
        `/api/v1/config_show_module_and_extra_info/`,
        payload,
        function(res) {
          context.commit('GET_ENABLE_MODULE_AND_EXTRA_INFO', res.data)
          resolve(res.data);
        },
        function(error) {
          reject(error);
        }
      );
    });
  },
  // =======================================
  // Apartment Type
  // =======================================
  GET_APARTMENT_TYPE_LIST: (context, payload) => {
    return new Promise((resolve, reject) => {
      common.getRequest(
        `/api/v1/${utils.getProjectId()}/apartment_type/`,
        payload,
        function(res) {
          if(res.data["page"] !== undefined){
            context.commit('GET_APARTMENT_TYPE_LIST', res.data)
          } else {
            context.commit('GET_APARTMENT_TYPE_LIST_NO_PAGE', res.data)
          }
          resolve(res.data);
        },
        function(error) {
          reject(error);
        }
      );
    });
  },
  DELETE_APARTMENT_TYPE: (context, payload) => {
    return new Promise((resolve, reject) => {
      common.deleteRequest(
        `/api/v1/${utils.getProjectId()}/apartment_type/${payload.id}/`,
        payload,
        function(res) {
          resolve(res.data);
        },
        function(error) {
          reject(error);
        }
      );
    });
  },
  CREATE_APARTMENT_TYPE: (context, payload) => {
    return new Promise((resolve, reject) => {
      common.postRequest(
        `/api/v1/${utils.getProjectId()}/apartment_type/`,
        payload,
        function(res) {
          resolve(res.data);
        },
        function(error) {
          reject(error);
        }
      );
    });
  },
  UPDATE_APARTMENT_TYPE: (context, payload) => {
    return new Promise((resolve, reject) => {
      common.putRequest(
        `/api/v1/${utils.getProjectId()}/apartment_type/${payload.id}/`,
        payload,
        function(res) {
          resolve(res.data);
        },
        function(error) {
          reject(error);
        }
      );
    });
  },
  // =======================================
  // Apartment Group
  // =======================================
  GET_APARTMENT_GROUP_LIST: (context, payload) => {
    return new Promise((resolve, reject) => {
      common.getRequest(
        `/api/v1/${utils.getProjectId()}/apartment_group/`,
        payload,
        function(res) {
          context.commit('GET_APARTMENT_GROUP_LIST', res.data)
          resolve(res.data);
        },
        function(error) {
          reject(error);
        }
      );
    });
  },
  DELETE_APARTMENT_GROUP: (context, payload) => {
    return new Promise((resolve, reject) => {
      common.deleteRequest(
        `/api/v1/${utils.getProjectId()}/apartment_group/${payload.id}/`,
        payload,
        function(res) {
          resolve(res.data);
        },
        function(error) {
          reject(error);
        }
      );
    });
  },
  CREATE_APARTMENT_GROUP: (context, payload) => {
    return new Promise((resolve, reject) => {
      common.postRequest(
        `/api/v1/${utils.getProjectId()}/apartment_group/`,
        payload,
        function(res) {
          resolve(res.data);
        },
        function(error) {
          reject(error);
        }
      );
    });
  },
  UPDATE_APARTMENT_GROUP: (context, payload) => {
    return new Promise((resolve, reject) => {
      common.putRequest(
        `/api/v1/${utils.getProjectId()}/apartment_group/${payload.id}/`,
        payload,
        function(res) {
          resolve(res.data);
        },
        function(error) {
          reject(error);
        }
      );
    });
  },
  // =======================================
  // Apartment Image
  // =======================================
  GET_APARTMENT_IMG_LIST: (context, payload) => {
    return new Promise((resolve, reject) => {
      common.getRequest(
        `/api/v1/${utils.getProjectId()}/apartment_img/`,
        payload,
        function(res) {
          if(payload.params.type != undefined){
            if(payload.params.type === Enum.ApartmentImgType.APARTMENT_IMG){
              context.commit('GET_APARTMENT_IMG_LIST', res.data)
            }
            if(payload.params.type === Enum.ApartmentImgType.APARTMENT_MAP_IMG){
              context.commit('GET_APARTMENT_MAP_IMG_LIST', res.data)
            }
            if(payload.params.type === Enum.ApartmentImgType.APARTMENT_CONTRACT_IMG){
              context.commit('GET_APARTMENT_CONTRACT_IMG_LIST', res.data)
            }
          }
          resolve(res.data);
        },
        function(error) {
          reject(error);
        }
      );
    });
  },
  CREATE_APARTMENT_IMG: (context, payload) => {
    return new Promise((resolve, reject) => {
      common.postRequest(
        `/api/v1/${utils.getProjectId()}/apartment_img/`,
        payload,
        function(res) {
          resolve(res.data);
        },
        function(error) {
          reject(error);
        }
      );
    });
  },
  UPDATE_APARTMENT_IMG: (context, payload) => {
    return new Promise((resolve, reject) => {
      common.putRequest(
        `/api/v1/${utils.getProjectId()}/apartment_img/${payload.id}/`,
        payload,
        function(res) {
          resolve(res.data);
        },
        function(error) {
          reject(error);
        }
      );
    });
  },
  DELETE_APARTMENT_IMG: (context, payload) => {
    return new Promise((resolve, reject) => {
      common.deleteRequest(
        `/api/v1/${utils.getProjectId()}/apartment_img/${payload.id}/`,
        payload,
        function(res) {
          resolve(res.data);
        },
        function(error) {
          reject(error);
        }
      );
    });
  },
  // =======================================
  // Product Unit
  // =======================================
  GET_PRODUCT_UNIT_LIST: (context, payload) => {
    return new Promise((resolve, reject) => {
      common.getRequest(
        `/api/v1/${utils.getProjectId()}/product_unit/`,
        payload,
        function(res) {
          if(res.data["page"] !== undefined){
            context.commit('GET_PRODUCT_UNIT_LIST', res.data)
          }else{
            context.commit('GET_PRODUCT_UNIT_LIST_NO_PAGE', res.data)
          }
          resolve(res.data);
        },
        function(error) {
          reject(error);
        }
      );
    });
  },
  CREATE_PRODUCT_UNIT: (context, payload) => {
    return new Promise((resolve, reject) => {
      common.postRequest(
        `/api/v1/${utils.getProjectId()}/product_unit/`,
        payload,
        function(res) {
          resolve(res.data);
        },
        function(error) {
          reject(error);
        }
      );
    });
  },
  UPDATE_PRODUCT_UNIT: (context, payload) => {
    return new Promise((resolve, reject) => {
      common.putRequest(
        `/api/v1/${utils.getProjectId()}/product_unit/${payload.id}/`,
        payload,
        function(res) {
          resolve(res.data);
        },
        function(error) {
          reject(error);
        }
      );
    });
  },
  DELETE_PRODUCT_UNIT: (context, payload) => {
    return new Promise((resolve, reject) => {
      common.deleteRequest(
        `/api/v1/${utils.getProjectId()}/product_unit/${payload.id}/`,
        payload,
        function(res) {
          resolve(res.data);
        },
        function(error) {
          reject(error);
        }
      );
    });
  },
  // =======================================
  // Product Group
  // =======================================
  GET_PRODUCT_GROUP_LIST: (context, payload) => {
    return new Promise((resolve, reject) => {
      common.getRequest(
        `/api/v1/${utils.getProjectId()}/product_group/`,
        payload,
        function(res) {
          if(res.data["page"] !== undefined){
            context.commit('GET_PRODUCT_GROUP_LIST', res.data)
          }else{
            context.commit('GET_PRODUCT_GROUP_LIST_NO_PAGE', res.data)
          }
          resolve(res.data);
        },
        function(error) {
          reject(error);
        }
      );
    });
  },
  CREATE_PRODUCT_GROUP: (context, payload) => {
    return new Promise((resolve, reject) => {
      common.postRequest(
        `/api/v1/${utils.getProjectId()}/product_group/`,
        payload,
        function(res) {
          resolve(res.data);
        },
        function(error) {
          reject(error);
        }
      );
    });
  },
  UPDATE_PRODUCT_GROUP: (context, payload) => {
    return new Promise((resolve, reject) => {
      common.putRequest(
        `/api/v1/${utils.getProjectId()}/product_group/${payload.id}/`,
        payload,
        function(res) {
          resolve(res.data);
        },
        function(error) {
          reject(error);
        }
      );
    });
  },
  DELETE_PRODUCT_GROUP: (context, payload) => {
    return new Promise((resolve, reject) => {
      common.deleteRequest(
        `/api/v1/${utils.getProjectId()}/product_group/${payload.id}/`,
        payload,
        function(res) {
          resolve(res.data);
        },
        function(error) {
          reject(error);
        }
      );
    });
  },
  // =======================================
  // Product
  // =======================================
  GET_PRODUCT_LIST: (context, payload) => {
    return new Promise((resolve, reject) => {
      common.getRequest(
        `/api/v1/${utils.getProjectId()}/product/`,
        payload,
        function(res) {
          if(res.data["page"] !== undefined){
            context.commit('GET_PRODUCT_LIST', res.data)
          } else {
            context.commit('GET_PRODUCT_LIST_NO_PAGE', res.data)
          }
          resolve(res.data);
        },
        function(error) {
          reject(error);
        }
      );
    });
  },
  CREATE_PRODUCT: (context, payload) => {
    return new Promise((resolve, reject) => {
      common.postRequest(
        `/api/v1/${utils.getProjectId()}/product/`,
        payload,
        function(res) {
          resolve(res.data);
        },
        function(error) {
          reject(error);
        }
      );
    });
  },
  UPDATE_PRODUCT: (context, payload) => {
    return new Promise((resolve, reject) => {
      common.putRequest(
        `/api/v1/${utils.getProjectId()}/product/${payload.id}/`,
        payload,
        function(res) {
          resolve(res.data);
        },
        function(error) {
          reject(error);
        }
      );
    });
  },
  DELETE_PRODUCT: (context, payload) => {
    return new Promise((resolve, reject) => {
      common.deleteRequest(
        `/api/v1/${utils.getProjectId()}/product/${payload.id}/`,
        payload,
        function(res) {
          resolve(res.data);
        },
        function(error) {
          reject(error);
        }
      );
    });
  },
  // =======================================
  // Service
  // =======================================
  GET_SERVICE_LIST_V2: (context, payload) => {
    return new Promise((resolve, reject) => {
      common.getRequest(
        `/api/v1/${utils.getProjectId()}/serviceV2/`,
        payload,
        function(res) {
          if(res.data["page"] !== undefined){
            context.commit('GET_SERVICE_LIST_V2', res.data)
          } 
          else {
            context.commit('GET_SERVICE_LIST_V2_NO_PAGE', res.data)
          }
          resolve(res.data);
        },
        function(error) {
          reject(error);
        }
      );
    });
  },
  CREATE_SERVICE_V2: (context, payload) => {
    return new Promise((resolve, reject) => {
      common.postRequest(
        `/api/v1/${utils.getProjectId()}/serviceV2/`,
        payload,
        function(res) {
          resolve(res.data);
        },
        function(error) {
          reject(error);
        }
      );
    });
  },
  UPDATE_SERVICE_V2: (context, payload) => {
    return new Promise((resolve, reject) => {
      common.putRequest(
        `/api/v1/${utils.getProjectId()}/serviceV2/${payload.id}/`,
        payload,
        function(res) {
          resolve(res.data);
        },
        function(error) {
          reject(error);
        }
      );
    });
  },
  DELETE_SERVICE_V2: (context, payload) => {
    return new Promise((resolve, reject) => {
      common.deleteRequest(
        `/api/v1/${utils.getProjectId()}/serviceV2/${payload.id}/`,
        payload,
        function(res) {
          resolve(res.data);
        },
        function(error) {
          reject(error);
        }
      );
    });
  },
  GET_SERVICE_HISTORY: (context, payload) => {
    return new Promise((resolve, reject) => {
      common.getRequest(
        `/api/v1/${utils.getProjectId()}/serviceV2/get_service_history_list/`,
        payload,
        function(res) {
          if(res.data["page"] !== undefined){
            context.commit('GET_SERVICE_HISTORY', res.data)
          } 
          resolve(res.data);
        },
        function(error) {
          reject(error);
        }
      );
    });
  },
  // =======================================
  // Service group
  // =======================================
  GET_SERVICE_GROUP_LIST: (context, payload) => {
    return new Promise((resolve, reject) => {
      common.getRequest(
        `/api/v1/${utils.getProjectId()}/service_group/`,
        payload,
        function(res) {
          if(res.data["page"] !== undefined){
            context.commit('GET_SERVICE_GROUP_LIST', res.data)
          } else {
            context.commit('GET_SERVICE_GROUP_LIST_NO_PAGE', res.data)
          }
          resolve(res.data);
        },
        function(error) {
          reject(error);
        }
      );
    });
  },
  CREATE_SERVICE_GROUP: (context, payload) => {
    return new Promise((resolve, reject) => {
      common.postRequest(
        `/api/v1/${utils.getProjectId()}/service_group/`,
        payload,
        function(res) {
          resolve(res.data);
        },
        function(error) {
          reject(error);
        }
      );
    });
  },
  UPDATE_SERVICE_GROUP: (context, payload) => {
    return new Promise((resolve, reject) => {
      common.putRequest(
        `/api/v1/${utils.getProjectId()}/service_group/${payload.id}/`,
        payload,
        function(res) {
          resolve(res.data);
        },
        function(error) {
          reject(error);
        }
      );
    });
  },
  DELETE_SERVICE_GROUP: (context, payload) => {
    return new Promise((resolve, reject) => {
      common.deleteRequest(
        `/api/v1/${utils.getProjectId()}/service_group/${payload.id}/`,
        payload,
        function(res) {
          resolve(res.data);
        },
        function(error) {
          reject(error);
        }
      );
    });
  },
  // =======================================
  // Service unit
  // =======================================
  GET_SERVICE_UNIT_LIST: (context, payload) => {
    return new Promise((resolve, reject) => {
      common.getRequest(
        `/api/v1/${utils.getProjectId()}/service_unit/`,
        payload,
        function(res) {
          if(res.data["page"] !== undefined){
            context.commit('GET_SERVICE_UNIT_LIST', res.data)
          } else {
            context.commit('GET_SERVICE_UNIT_LIST_NO_PAGE', res.data)
          }
          resolve(res.data);
        },
        function(error) {
          reject(error);
        }
      );
    });
  },
  CREATE_SERVICE_UNIT: (context, payload) => {
    return new Promise((resolve, reject) => {
      common.postRequest(
        `/api/v1/${utils.getProjectId()}/service_unit/`,
        payload,
        function(res) {
          resolve(res.data);
        },
        function(error) {
          reject(error);
        }
      );
    });
  },
  UPDATE_SERVICE_UNIT: (context, payload) => {
    return new Promise((resolve, reject) => {
      common.putRequest(
        `/api/v1/${utils.getProjectId()}/service_unit/${payload.id}/`,
        payload,
        function(res) {
          resolve(res.data);
        },
        function(error) {
          reject(error);
        }
      );
    });
  },
  DELETE_SERVICE_UNIT: (context, payload) => {
    return new Promise((resolve, reject) => {
      common.deleteRequest(
        `/api/v1/${utils.getProjectId()}/service_unit/${payload.id}/`,
        payload,
        function(res) {
          resolve(res.data);
        },
        function(error) {
          reject(error);
        }
      );
    });
  },

  // =======================================
  // Service attribute
  // =======================================
  GET_SERVICE_ATTRIBUTE_LIST: (context, payload) => {
    return new Promise((resolve, reject) => {
      common.getRequest(
        `/api/v1/${utils.getProjectId()}/service_attributeV2/`,
        payload,
        function(res) {
          context.commit('GET_SERVICE_ATTRIBUTE_LIST', res.data)
          resolve(res.data);
        },
        function(error) {
          reject(error);
        }
      );
    });
  },
  CREATE_SERVICE_ATTRIBUTE: (context, payload) => {
    return new Promise((resolve, reject) => {
      common.postRequest(
        `/api/v1/${utils.getProjectId()}/service_attributeV2/`,
        payload,
        function(res) {
          resolve(res.data);
        },
        function(error) {
          reject(error);
        }
      );
    });
  },
  UPDATE_SERVICE_ATTRIBUTE: (context, payload) => {
    return new Promise((resolve, reject) => {
      common.putRequest(
        `/api/v1/${utils.getProjectId()}/service_attributeV2/${payload.id}/`,
        payload,
        function(res) {
          resolve(res.data);
        },
        function(error) {
          reject(error);
        }
      );
    });
  },
  DELETE_SERVICE_ATTRIBUTE: (context, payload) => {
    return new Promise((resolve, reject) => {
      common.deleteRequest(
        `/api/v1/${utils.getProjectId()}/service_attributeV2/${payload.id}/`,
        payload,
        function(res) {
          resolve(res.data);
        },
        function(error) {
          reject(error);
        }
      );
    });
  },
  // =======================================
  // Product in apartment
  // =======================================
  GET_PRODUCT_IN_APARTMENT_LIST: (context, payload) => {
    return new Promise((resolve, reject) => {
      common.getRequest(
        `/api/v1/${utils.getProjectId()}/product_in_apartment/`,
        payload,
        function(res) {
          context.commit('GET_PRODUCT_IN_APARTMENT_LIST', res.data)
          resolve(res.data);
        },
        function(error) {
          reject(error);
        }
      );
    });
  },
  CREATE_PRODUCT_IN_APARTMENT: (context, payload) => {
    return new Promise((resolve, reject) => {
      common.postRequest(
        `/api/v1/${utils.getProjectId()}/product_in_apartment/`,
        payload,
        function(res) {
          resolve(res.data);
        },
        function(error) {
          reject(error);
        }
      );
    });
  },
  UPDATE_PRODUCT_IN_APARTMENT: (context, payload) => {
    return new Promise((resolve, reject) => {
      common.putRequest(
        `/api/v1/${utils.getProjectId()}/product_in_apartment/${payload.id}/`,
        payload,
        function(res) {
          resolve(res.data);
        },
        function(error) {
          reject(error);
        }
      );
    });
  },
  DELETE_PRODUCT_IN_APARTMENT: (context, payload) => {
    return new Promise((resolve, reject) => {
      common.deleteRequest(
        `/api/v1/${utils.getProjectId()}/product_in_apartment/${payload.id}/`,
        payload,
        function(res) {
          resolve(res.data);
        },
        function(error) {
          reject(error);
        }
      );
    });
  },
  // =======================================
  // Service in apartment
  // =======================================
  GET_SERVICE_IN_APARTMENT_LIST: (context, payload) => {
    return new Promise((resolve, reject) => {
      common.getRequest(
        `/api/v1/${utils.getProjectId()}/service_in_apartment/`,
        payload,
        function(res) {
          context.commit('GET_SERVICE_IN_APARTMENT_LIST', res.data)
          resolve(res.data);
        },
        function(error) {
          reject(error);
        }
      );
    });
  },
  CREATE_SERVICE_IN_APARTMENT: (context, payload) => {
    return new Promise((resolve, reject) => {
      common.postRequest(
        `/api/v1/${utils.getProjectId()}/service_in_apartment/`,
        payload,
        function(res) {
          resolve(res.data);
        },
        function(error) {
          reject(error);
        }
      );
    });
  },
  DELETE_SERVICE_IN_APARTMENT: (context, payload) => {
    return new Promise((resolve, reject) => {
      common.deleteRequest(
        `/api/v1/${utils.getProjectId()}/service_in_apartment/${payload.id}/`,
        payload,
        function(res) {
          resolve(res.data);
        },
        function(error) {
          reject(error);
        }
      );
    });
  },
  // =======================================
  // Apartment in group
  // =======================================
  GET_APARTMENT_IN_GROUP_LIST: (context, payload) => {
    return new Promise((resolve, reject) => {
      common.getRequest(
        `/api/v1/${utils.getProjectId()}/apartment_group/get_apartment_in_group/`,
        payload,
        function(res) {
          context.commit('GET_APARTMENT_IN_GROUP_LIST', res.data)
          resolve(res.data);
        },
        function(error) {
          reject(error);
        }
      );
    });
  },
  GET_APARTMENT_IN_GROUP_WITH_GROUP_ID_LIST: (context, payload) => {
    return new Promise((resolve, reject) => {
      common.getRequest(
        `/api/v1/${utils.getProjectId()}/apartment_group/get_apartment_in_group_with_group_id/`,
        payload,
        function(res) {
          context.commit('GET_APARTMENT_IN_GROUP_WITH_GROUP_ID_LIST', res.data)
          resolve(res.data);
        },
        function(error) {
          reject(error);
        }
      );
    });
  },
  POST_APARTMENT_IN_GROUP: (context, payload) => {
    return new Promise((resolve, reject) => {
      common.postRequest(
        `/api/v1/${utils.getProjectId()}/apartment_group/post_apartment_in_group/`,
        payload,
        function(res) {
          resolve(res.data);
        },
        function(error) {
          reject(error);
        }
      );
    });
  },
  DELETE_APARTMENT_LIST_IN_GROUP: (context, payload) => {
    return new Promise((resolve, reject) => {
      common.postRequest(
        `/api/v1/${utils.getProjectId()}/apartment_group/delete_apartment_list_in_group/`,
        payload,
        function(res) {
          resolve(res.data);
        },
        function(error) {
          reject(error);
        }
      );
    });
  },
  DELETE_APARTMENT_IN_GROUP: (context, payload) => {
    return new Promise((resolve, reject) => {
      common.deleteRequest(
        `/api/v1/${utils.getProjectId()}/apartment_group/${payload.id}/delete_apartment_in_group/`,
        {data: payload},
        function(res) {
          resolve(res.data);
        },
        function(error) {
          reject(error);
        }
      );
    });
  },
  // =======================================
  // Apartment booking
  // =======================================
  GET_APARTMENT_TYPE_IN_BOOKING_LIST: (context, payload) => {
    return new Promise((resolve, reject) => {
      common.getRequest(
        `/api/v1/${utils.getProjectId()}/apartment_booking/get_apartment_type_list_for_booking/`,
        payload,
        function(res) {
          // context.commit('GET_APARTMENT_IN_GROUP_LIST', res.data)
          resolve(res.data);
        },
        function(error) {
          reject(error);
        }
      );
    });
  },
  CREATE_APARTMENT_BOOKING: (context, payload) => {
    return new Promise((resolve, reject) => {
      common.postRequest(
        `/api/v1/${utils.getProjectId()}/apartment_booking/`,
        payload,
        function(res) {
          resolve(res.data);
        },
        function(error) {
          reject(error);
        }
      );
    });
  },
  GET_APARTMENT_BOOKING_DETAIL: (context, payload) => {
    return new Promise((resolve, reject) => {
      common.getRequest(
        `/api/v1/${utils.getProjectId()}/apartment_booking/${payload.id}/`,
        payload,
        function(res) {
          context.commit('GET_APARTMENT_BOOKING_DETAIL', res.data)
          resolve(res.data);
        },
        function(error) {
          reject(error);
        }
      );
    });
  },
  GET_APARTMENT_BOOKING_LIST: (context, payload) => {
    return new Promise((resolve, reject) => {
      common.getRequest(
        `/api/v1/${utils.getProjectId()}/apartment_booking/`,
        payload,
        function(res) {
          context.commit('GET_APARTMENT_BOOKING_LIST', res.data)
          resolve(res.data);
        },
        function(error) {
          reject(error);
        }
      );
    });
  },
  CANCEL_APARTMENT_BOOKING_V2: (context, payload) => {
    return new Promise((resolve, reject) => {
      common.deleteRequest(
        `/api/v1/${utils.getProjectId()}/apartment_booking/${payload.id}/`,
        {data: payload},
        function(res) {
          resolve(res.data);
        },
        function(error) {
          reject(error);
        }
      );
    });
  },
  UPDATE_APARTMENT_BOOKING_V2: (context, payload) => {
    return new Promise((resolve, reject) => {
      common.putRequest(
        `/api/v1/${utils.getProjectId()}/apartment_booking/${payload.id}/`,
        payload,
        function(res) {
          resolve(res.data);
        },
        function(error) {
          reject(error);
        }
      );
    });
  },
  GET_APARTMENT_BOOKING_LIST_FOR_TIME_LINE: (context, payload) => {
    return new Promise((resolve, reject) => {
      common.getRequest(
        `/api/v1/${utils.getProjectId()}/apartment_booking/get_apartment_booking_list_for_time_line/`,
        payload,
        function(res) {
          context.commit('GET_APARTMENT_BOOKING_LIST_FOR_TIME_LINE', res.data)
          resolve(res.data);
        },
        function(error) {
          reject(error);
        }
      );
    });
  },
  GET_APARTMENT_LIST_IN_BOOKING: (context, payload) => {
    return new Promise((resolve, reject) => {
      common.getRequest(
        `/api/v1/${utils.getProjectId()}/apartment_booking/get_apartment_list_in_booking/`,
        payload,
        function(res) {
          context.commit('GET_APARTMENT_LIST_IN_BOOKING', res.data)
          resolve(res.data);
        },
        function(error) {
          reject(error);
        }
      );
    });
  },
  GET_USER_LIST_IN_BOOKING: (context, payload) => {
    return new Promise((resolve, reject) => {
      common.getRequest(
        `/api/v1/${utils.getProjectId()}/apartment_booking/get_user_list_in_booking/`,
        payload,
        function(res) {
          context.commit('GET_USER_LIST_IN_BOOKING', res.data)
          resolve(res.data);
        },
        function(error) {
          reject(error);
        }
      );
    });
  },
  GET_USER_BOOKING_IN_APARTMENT: (context, payload) => {
    return new Promise((resolve, reject) => {
      common.getRequest(
        `/api/v1/${utils.getProjectId()}/apartment_booking/get_user_booking_in_apartment/`,
        payload,
        function(res) {
          context.commit('GET_USER_BOOKING_IN_APARTMENT', res.data)
          resolve(res.data);
        },
        function(error) {
          reject(error);
        }
      );
    });
  },
  ADD_USER_BOOKING_IN_APARTMENT: (context, payload) => {
    return new Promise((resolve, reject) => {
      common.postRequest(
        `/api/v1/${utils.getProjectId()}/apartment_booking/add_user_booking_in_apartment/`,
        payload,
        function(res) {
          resolve(res.data);
        },
        function(error) {
          reject(error);
        }
      );
    });
  },
  CHECK_IN_APARTMENT_IN_BOOKING: (context, payload) => {
    return new Promise((resolve, reject) => {
      common.postRequest(
        `/api/v1/${utils.getProjectId()}/apartment_booking/action_check_in_apartment_in_booking/`,
        payload,
        function(res) {
          resolve(res.data);
        },
        function(error) {
          reject(error);
        }
      );
    });
  },
  REMOVE_USER_BOOKING_IN_APARTMENT: (context, payload) => {
    return new Promise((resolve, reject) => {
      common.putRequest(
        `/api/v1/${utils.getProjectId()}/apartment_booking/${payload.id}/remove_user_booking_in_apartment/`,
        payload,
        function(res) {
          resolve(res.data);
        },
        function(error) {
          reject(error);
        }
      );
    });
  },
  CHECK_OUT_APARTMENT_IN_BOOKING: (context, payload) => {
    return new Promise((resolve, reject) => {
      common.postRequest(
        `/api/v1/${utils.getProjectId()}/apartment_booking/action_check_out_apartment_in_booking/`,
        payload,
        function(res) {
          resolve(res.data);
        },
        function(error) {
          reject(error);
        }
      );
    });
  },
  GET_NUMBER_BOOKING_IN_STATUS_LIST: (context, payload) => {
    return new Promise((resolve, reject) => {
      common.getRequest(
        `/api/v1/${utils.getProjectId()}/apartment_booking/get_number_booking_in_status_list/`,
        payload,
        function(res) {
          resolve(res.data);
        },
        function(error) {
          reject(error);
        }
      );
    });
  },
  ACTION_CLEAN_ROOM: (context, payload) => {
    return new Promise((resolve, reject) => {
      common.postRequest(
        `/api/v1/${utils.getProjectId()}/apartment/action_clean_room/`,
        payload,
        function(res) {
          resolve(res.data);
        },
        function(error) {
          reject(error);
        }
      );
    });
  },
  // =======================================
  // Apartment type price
  // =======================================
  CREATE_APARTMENT_TYPE_PRICE: (context, payload) => {
    return new Promise((resolve, reject) => {
      common.postRequest(
        `/api/v1/${utils.getProjectId()}/apartment_type_price/`,
        payload,
        function(res) {
          resolve(res.data);
        },
        function(error) {
          reject(error);
        }
      );
    });
  },
  UPDATE_APARTMENT_TYPE_PRICE: (context, payload) => {
    return new Promise((resolve, reject) => {
      common.putRequest(
        `/api/v1/${utils.getProjectId()}/apartment_type_price/${payload.id}/`,
        payload,
        function(res) {
          resolve(res.data);
        },
        function(error) {
          reject(error);
        }
      );
    });
  },
  CANCEL_APARTMENT_TYPE_PRICE: (context, payload) => {
    return new Promise((resolve, reject) => {
      common.deleteRequest(
        `/api/v1/${utils.getProjectId()}/apartment_type_price/${payload.id}/`,
        {data: payload},
        function(res) {
          resolve(res.data);
        },
        function(error) {
          reject(error);
        }
      );
    });
  },
  GET_APARTMENT_TYPE_PRICE_LIST: (context, payload) => {
    return new Promise((resolve, reject) => {
      common.getRequest(
        `/api/v1/${utils.getProjectId()}/apartment_type_price/`,
        payload,
        function(res) {
          context.commit('GET_APARTMENT_TYPE_PRICE_LIST', res.data)
          resolve(res.data);
        },
        function(error) {
          reject(error);
        }
      );
    });
  },
  GET_APARTMENT_TYPE_PRICE_DETAIL: (context, payload) => {
    return new Promise((resolve, reject) => {
      common.getRequest(
        `/api/v1/${utils.getProjectId()}/apartment_type_price/${payload.id}/`,
        payload,
        function(res) {
          resolve(res.data);
        },
        function(error) {
          reject(error);
        }
      );
    });
  },
  // =======================================
  // Project mobile home info
  // =======================================
  GET_PROJECT_MOBIHOME_LOGO: (context, payload) => {
    return new Promise((resolve, reject) => {
      common.getRequest(
        `/api/v1/${utils.getProjectId()}/project_mobile_home/get_logo_url/`,
        payload,
        function(res) {
          resolve(res.data);
        },
        function(error) {
          reject(error);
        }
      );
    });
  },
  SET_PROJECT_MOBIHOME_LOGO: (context, payload) => {
    return new Promise((resolve, reject) => {
      common.postRequest(
        `/api/v1/${utils.getProjectId()}/project_mobile_home/set_logo_url/`,
        payload,
        function(res) {
          resolve(res.data);
        },
        function(error) {
          reject(error);
        }
      );
    });
  },
  // =======================================
  // Project extra info
  // =======================================
  GET_PROJECT_EXTRA_INFO: (context, payload) => {
    return new Promise((resolve, reject) => {
      common.getRequest(
        `/api/v1/${utils.getProjectId()}/project_extra_info/get_project_extra_info/`,
        payload,
        function(res) {
          context.commit('GET_PROJECT_EXTRA_INFO', res.data)
          resolve(res.data);
        },
        function(error) {
          reject(error);
        }
      );
    });
  },
  POST_PROJECT_EXTRA_INFO: (context, payload) => {
    return new Promise((resolve, reject) => {
      common.postRequest(
        `/api/v1/${utils.getProjectId()}/project_extra_info/post_project_extra_info/`,
        payload,
        function(res) {
          resolve(res.data);
        },
        function(error) {
          reject(error);
        }
      );
    });
  },
  // =======================================
  // Product in apartment type
  // =======================================
  GET_PRODUCT_IN_APARTMENT_TYPE_LIST: (context, payload) => {
    return new Promise((resolve, reject) => {
      common.getRequest(
        `/api/v1/${utils.getProjectId()}/product_in_apartment_type/`,
        payload,
        function(res) {
          if(res.data["page"] !== undefined){
            context.commit('GET_PRODUCT_IN_APARTMENT_TYPE_LIST', res.data)
          } else {
            context.commit('GET_PRODUCT_IN_APARTMENT_TYPE_LIST_NO_PAGE', res.data)
          }
          resolve(res.data);
        },
        function(error) {
          reject(error);
        }
      );
    });
  },
  ADD_PRODUCT_IN_APARTMENT_TYPE: (context, payload) => {
    return new Promise((resolve, reject) => {
      common.postRequest(
        `/api/v1/${utils.getProjectId()}/product_in_apartment_type/`,
        payload,
        function(res) {
          resolve(res.data);
        },
        function(error) {
          reject(error);
        }
      );
    });
  },
  UPDATE_PRODUCT_IN_APARTMENT_TYPE: (context, payload) => {
    return new Promise((resolve, reject) => {
      common.putRequest(
        `/api/v1/${utils.getProjectId()}/product_in_apartment_type/${payload.id}/`,
        payload,
        function(res) {
          resolve(res.data);
        },
        function(error) {
          reject(error);
        }
      );
    });
  },
  DELETE_PRODUCT_IN_APARTMENT_TYPE: (context, payload) => {
    return new Promise((resolve, reject) => {
      common.deleteRequest(
        `/api/v1/${utils.getProjectId()}/product_in_apartment_type/${payload.id}/`,
        payload,
        function(res) {
          resolve(res.data);
        },
        function(error) {
          reject(error);
        }
      );
    });
  },
  // =======================================
  // Product and service used in apartment in booking
  // =======================================
  ADD_PRODUCT_USED_IN_APARTMENT_BOOKING: (context, payload) => {
    return new Promise((resolve, reject) => {
      common.postRequest(
        `/api/v1/${utils.getProjectId()}/product_used_in_apartment_in_booking/`,
        payload,
        function(res) {
          resolve(res.data);
        },
        function(error) {
          reject(error);
        }
      );
    });
  },
  GET_PRODUCT_AND_SERVICE_USED_IN_APARTMENT_IN_BOOKING: (context, payload) => {
    return new Promise((resolve, reject) => {
      common.getRequest(
        `/api/v1/${utils.getProjectId()}/product_used_in_apartment_in_booking/get_user_product_service_in_apartment_in_booking/`,
        payload,
        function(res) {
          context.commit('GET_PRODUCT_AND_SERVICE_USED_IN_APARTMENT_IN_BOOKING', res.data)
          resolve(res.data);
        },
        function(error) {
          reject(error);
        }
      );
    });
  },
  UPDATE_PRODUCT_USED_IN_APARTMENT_BOOKING: (context, payload) => {
    return new Promise((resolve, reject) => {
      common.putRequest(
        `/api/v1/${utils.getProjectId()}/product_used_in_apartment_in_booking/${payload.id}/`,
        payload,
        function(res) {
          resolve(res.data);
        },
        function(error) {
          reject(error);
        }
      );
    });
  },
  UPDATE_DELETE_PRODUCT_USED_OR_CUSTOMER_COMPLAIN: (context, payload) => {
    return new Promise((resolve, reject) => {
      common.putRequest(
        `/api/v1/${utils.getProjectId()}/product_used_in_apartment_in_booking/${payload.id}/update_delete_product_used_or_customer_complain/`,
        payload,
        function(res) {
          resolve(res.data);
        },
        function(error) {
          reject(error);
        }
      );
    });
  },
  // =======================================
  // Service package
  // =======================================
  ADD_SERVICE_PACKAGE: (context, payload) => {
    return new Promise((resolve, reject) => {
      common.postRequest(
        `/api/v1/${utils.getProjectId()}/service_package/`,
        payload,
        function(res) {
          resolve(res.data);
        },
        function(error) {
          reject(error);
        }
      );
    });
  },
  GET_SERVICE_PACKAGE_LIST: (context, payload) => {
    return new Promise((resolve, reject) => {
      common.getRequest(
        `/api/v1/${utils.getProjectId()}/service_package/`,
        payload,
        function(res) {
          if(res.data["page"] !== undefined){
            context.commit('GET_SERVICE_PACKAGE_LIST', res.data)
          }
          resolve(res.data);
        },
        function(error) {
          reject(error);
        }
      );
    });
  },
  UPDATE_SERVICE_PACKAGE: (context, payload) => {
    return new Promise((resolve, reject) => {
      common.putRequest(
        `/api/v1/${utils.getProjectId()}/service_package/${payload.id}/`,
        payload,
        function(res) {
          resolve(res.data);
        },
        function(error) {
          reject(error);
        }
      );
    });
  },
  DELETE_SERVICE_PACKAGE: (context, payload) => {
    return new Promise((resolve, reject) => {
      common.deleteRequest(
        `/api/v1/${utils.getProjectId()}/service_package/${payload.id}/`,
        payload,
        function(res) {
          resolve(res.data);
        },
        function(error) {
          reject(error);
        }
      );
    });
  },
  GET_SERVICE_LIST_ENABLE: (context, payload) => {
    return new Promise((resolve, reject) => {
      common.getRequest(
        `/api/v1/${utils.getProjectId()}/serviceV2/get_service_list_enable/`,
        payload,
        function(res) {
          context.commit('GET_SERVICE_LIST_ENABLE', res.data)
          resolve(res.data);
        },
        function(error) {
          reject(error);
        }
      );
    });
  },
  // =======================================
  // Management Service order
  // =======================================
  GET_SERVICE_ORDER_LIST: (context, payload) => {
    return new Promise((resolve, reject) => {
      common.getRequest(
        `/api/v1/${utils.getProjectId()}/service_order/`,
        payload,
        function(res) {
          if(res.data["page"] !== undefined){
            context.commit('GET_SERVICE_ORDER_LIST', res.data)
          }
          resolve(res.data);
        },
        function(error) {
          reject(error);
        }
      );
    });
  },
  GET_SERVICE_ORDER_DETAIL: (context, payload) => {
    return new Promise((resolve, reject) => {
      common.getRequest(
        `/api/v1/${utils.getProjectId()}/service_order/${payload.id}/`,
        payload,
        function(res) {
          context.commit('GET_SERVICE_ORDER_DETAIL', res.data)
          resolve(res.data);
        },
        function(error) {
          reject(error);
        }
      );
    });
  },
  ADD_SERVICE_ORDER: (context, payload) => {
    return new Promise((resolve, reject) => {
      common.postRequest(
        `/api/v1/${utils.getProjectId()}/service_order/`,
        payload,
        function(res) {
          resolve(res.data);
        },
        function(error) {
          reject(error);
        }
      );
    });
  },
  UPDATE_SERVICE_ORDER: (context, payload) => {
    return new Promise((resolve, reject) => {
      common.putRequest(
        `/api/v1/${utils.getProjectId()}/service_order/${payload.id}/`,
        payload,
        function(res) {
          resolve(res.data);
        },
        function(error) {
          reject(error);
        }
      );
    });
  },
  UPDATE_SERVICE_ORDER_STATUS: (context, payload) => {
    return new Promise((resolve, reject) => {
      common.putRequest(
        `/api/v1/${utils.getProjectId()}/service_order/${payload.id}/update_service_order_status/`,
        payload,
        function(res) {
          resolve(res.data);
        },
        function(error) {
          reject(error);
        }
      );
    });
  },
  GET_NUMBER_SERVICE_ORDER_LIST: (context, payload) => {
    return new Promise((resolve, reject) => {
      common.getRequest(
        `/api/v1/${utils.getProjectId()}/service_order/get_number_service_order/`,
        payload,
        function(res) {
          context.commit('GET_NUMBER_SERVICE_ORDER_LIST', res.data)
          resolve(res.data);
        },
        function(error) {
          reject(error);
        }
      );
    });
  },
  UPDATE_SERVICE_ORDER_SELECT_LIST: (context, payload) => {
    return new Promise((resolve, reject) => {
      common.postRequest(
        `/api/v1/${utils.getProjectId()}/service_order/update_service_order_select_list/`,
        payload,
        function(res) {
          resolve(res.data);
        },
        function(error) {
          reject(error);
        }
      );
    });
  },
  // =======================================
  // Apartment receipt
  // =======================================
  GET_APARTMENT_RECEIPT_INVOICE_REVENUE_LIST: (context, payload) => {
    return new Promise((resolve, reject) => {
      common.getRequest(
        `/api/v1/${utils.getProjectId()}/apartment_receipt/`,
        payload,
        function(res) {
          context.commit('GET_APARTMENT_RECEIPT_INVOICE_REVENUE_LIST', res.data)
          resolve(res.data);
        },
        function(error) {
          reject(error);
        }
      );
    });
  },
  // =======================================
  // Room Performance Report
  // =======================================
  GET_ROOM_PERFORMANCE_REPORT: (context, payload) => {
    return new Promise((resolve, reject) => {
      common.getRequest(
        `/api/v1/${utils.getProjectId()}/room_performance_report/`,
        payload,
        function(res) {
          context.commit('GET_ROOM_PERFORMANCE_REPORT', res.data)
          resolve(res.data);
        },
        function(error) {
          reject(error);
        }
      );
    });
  },
  // =======================================
  // User extra info
  // =======================================
  GET_USER_EXTRA_INFO: (context, payload) => {
    return new Promise((resolve, reject) => {
      common.getRequest(
        `/api/v1/${utils.getProjectId()}/user_extra_info/get_user_extra_info/`,
        payload,
        function(res) {
          context.commit('GET_USER_EXTRA_INFO', res.data)
          resolve(res.data);
        },
        function(error) {
          reject(error);
        }
      );
    });
  },
  ADD_USER_EXTRA_INFO: (context, payload) => {
    return new Promise((resolve, reject) => {
      common.postRequest(
        `/api/v1/${utils.getProjectId()}/user_extra_info/`,
        payload,
        function(res) {
          resolve(res.data);
        },
        function(error) {
          reject(error);
        }
      );
    });
  },
  UPDATE_USER_EXTRA_INFO: (context, payload) => {
    return new Promise((resolve, reject) => {
      common.putRequest(
        `/api/v1/${utils.getProjectId()}/user_extra_info/${payload.id}/`,
        payload,
        function(res) {
          resolve(res.data);
        },
        function(error) {
          reject(error);
        }
      );
    });
  },
  // =======================================
  // Position
  // =======================================
  GET_POSITION_LIST: (context, payload) => {
    return new Promise((resolve, reject) => {
      common.getRequest(
        `/api/v1/${utils.getProjectId()}/position/`,
        payload,
        function(res) {
          context.commit('GET_POSITION_LIST', res.data)
          resolve(res.data);
        },
        function(error) {
          reject(error);
        }
      );
    });
  },
  CREATE_POSITION: (context, payload) => {
    return new Promise((resolve, reject) => {
      common.postRequest(
        `/api/v1/${utils.getProjectId()}/position/`,
        payload,
        function(res) {
          resolve(res.data);
        },
        function(error) {
          reject(error);
        }
      );
    });
  },
  UPDATE_POSITION: (context, payload) => {
    return new Promise((resolve, reject) => {
      common.putRequest(
        `/api/v1/${utils.getProjectId()}/position/${payload.id}/`,
        payload,
        function(res) {
          resolve(res.data);
        },
        function(error) {
          reject(error);
        }
      );
    });
  },
  // =======================================
  // Event management
  // =======================================
  GET_EVENT_LIST: (context, payload) => {
    return new Promise((resolve, reject) => {
      common.getRequest(
        `/api/v1/${utils.getProjectId()}/event_management/`,
        payload,
        function(res) {
          context.commit('GET_EVENT_LIST', res.data)
          resolve(res.data);
        },
        function(error) {
          reject(error);
        }
      );
    });
  },
  CREATE_EVENT: (context, payload) => {
    return new Promise((resolve, reject) => {
      common.postRequest(
        `/api/v1/${utils.getProjectId()}/event_management/`,
        payload,
        function(res) {
          resolve(res.data);
        },
        function(error) {
          reject(error);
        }
      );
    });
  },
  UPDATE_EVENT: (context, payload) => {
    return new Promise((resolve, reject) => {
      common.putRequest(
        `/api/v1/${utils.getProjectId()}/event_management/${payload.id}/`,
        payload,
        function(res) {
          resolve(res.data);
        },
        function(error) {
          reject(error);
        }
      );
    });
  },
  DELETE_EVENT: (context, payload) => {
    return new Promise((resolve, reject) => {
      common.deleteRequest(
        `/api/v1/${utils.getProjectId()}/event_management/${payload.id}/`,
        payload,
        function(res) {
          resolve(res.data);
        },
        function(error) {
          reject(error);
        }
      );
    });
  },
  SEND_NOTIFICATION_EVENT_TO_CUSTOMER: (context, payload) => {
    return new Promise((resolve, reject) => {
      common.postRequest(
        `/api/v1/${utils.getProjectId()}/event_management/send_notification_event_to_customer/`,
        payload,
        function(res) {
          resolve(res.data);
        },
        function(error) {
          reject(error);
        }
      );
    });
  },
  POST_APARTMENT_MEMBER: (context, payload) => {
    return new Promise((resolve, reject) => {
      common.postRequest(
        `/api/v1/${utils.getProjectId()}/apartmentresidents/post_apartment_resident_in_apartment/`,
        payload,
        function(res) {
          resolve(res.data);
        },
        function(error) {
          reject(error);
        }
      );
    });
  },
  // =======================================
  // Config Email Group
  // =======================================
  GET_CONFIG_EMAIL_GROUP: (context, payload) => {
    return new Promise((resolve, reject) => {
      common.getRequest(
        `/api/v1/${utils.getProjectId()}/config_email_group/`,
        payload,
        function(res) {
          context.commit('GET_CONFIG_EMAIL_GROUP', res.data)
          resolve(res.data);
        },
        function(error) {
          reject(error);
        }
      );
    });
  },
  POST_CONFIG_EMAIL_GROUP: (context, payload) => {
    return new Promise((resolve, reject) => {
      common.postRequest(
        `/api/v1/${utils.getProjectId()}/config_email_group/post_config_email_group/`,
        payload,
        function(res) {
          resolve(res.data);
        },
        function(error) {
          reject(error);
        }
      );
    });
  },
  // =======================================
  // Config Revenue Code
  // =======================================
  GET_CONFIG_REVENUE_CODE: (context, payload) => {
    return new Promise((resolve, reject) => {
      common.getRequest(
        `/api/v1/${utils.getProjectId()}/config_revenue_code/`,
        payload,
        function(res) {
          context.commit('GET_CONFIG_REVENUE_CODE', res.data)
          resolve(res.data);
        },
        function(error) {
          reject(error);
        }
      );
    });
  },
  CREATE_CONFIG_REVENUE_CODE: (context, payload) => {
    return new Promise((resolve, reject) => {
      common.postRequest(
        `/api/v1/${utils.getProjectId()}/config_revenue_code/`,
        payload,
        function(res) {
          resolve(res.data);
        },
        function(error) {
          reject(error);
        }
      );
    });
  },
  UPDATE_CONFIG_REVENUE_CODE: (context, payload) => {
    return new Promise((resolve, reject) => {
      common.putRequest(
        `/api/v1/${utils.getProjectId()}/config_revenue_code/${payload.id}/`,
        payload,
        function(res) {
          resolve(res.data);
        },
        function(error) {
          reject(error);
        }
      );
    });
  },
  GET_MAINTENANCE_TYPE_LIST: (context, payload) => {
    return new Promise((resolve, reject) => {
      common.getRequest(
        `/api/v1/${utils.getProjectId()}/assetV2/get_maintenance_type_list/`,
        payload,
        function(res) {
          context.commit('GET_MAINTENANCE_TYPE_LIST', res.data)
          resolve(res.data);
        },
        function(error) {
          reject(error);
        }
      );
    });
  },
  GET_ASSET_DETAIL_MAINTENANCE_HISTORY: (context, payload) => {
    return new Promise((resolve, reject) => {
      common.getRequest(
        `/api/v1/${utils.getProjectId()}/assetV2/${payload.id}/asset_detail_maintenace_history/`,
        payload,
        function(res) {
          if(res.data["page"] !== undefined){
            context.commit('GET_ASSET_DETAIL_MAINTENANCE_HISTORY_LIST', res.data)
          }
          resolve(res.data);
        },
        function(error) {
          reject(error);
        }
      );
    });
  },
  // =======================================
  // Maintenances
  // =======================================
  GET_MAINTENANCE_LIST: (context, payload) => {
    return new Promise((resolve, reject) => {
      common.getRequest(
        `/api/v1/${utils.getProjectId()}/maintenance/`,
        payload,
        function(res) {
          if(res.data["page"] !== undefined){
            context.commit('GET_MAINTENANCE_LIST', res.data)
          } else {
            context.commit('GET_MAINTENANCE_LIST_NO_PAGE', res.data)
          }
          resolve(res.data);
        },
        function(error) {
          reject(error);
        }
      );
    });
  },
  CREATE_MAINTENANCE: (context, payload) => {
    return new Promise((resolve, reject) => {
      common.postRequest(
        `/api/v1/${utils.getProjectId()}/maintenance/`,
        payload,
        function(res) {
          resolve(res.data);
        },
        function(error) {
          reject(error);
        }
      );
    });
  },
  UPDATE_MAINTENANCE: (context, payload) => {
    return new Promise((resolve, reject) => {
      common.putRequest(
        `/api/v1/${utils.getProjectId()}/maintenance/${payload.id}/`,
        payload,
        function(res) {
          resolve(res.data);
        },
        function(error) {
          reject(error);
        }
      );
    });
  },
  DELETE_MAINTENANCE: (context, payload) => {
    return new Promise((resolve, reject) => {
      common.deleteRequest(
        `/api/v1/${utils.getProjectId()}/maintenance/${payload.id}/`,
        payload,
        function(res) {
          resolve(res.data);
        },
        function(error) {
          reject(error);
        }
      );
    });
  },
  POST_APPROVAL_OR_NOT_APPROVAL_MAINTENANCE: (context, payload) => {
    return new Promise((resolve, reject) => {
      common.postRequest(
        `/api/v1/${utils.getProjectId()}/maintenance/post_approval_or_not_approval_maintainance/`,
        payload,
        function(res) {
          resolve(res.data);
        },
        function(error) {
          reject(error);
        }
      );
    });
  },
  IMPORT_MAINTAINANCE_FROM_EXCEL_FILE: (context, payload) => {
    return new Promise((resolve, reject) => {
      common.postRequest(
        `/api/v1/${utils.getProjectId()}/maintenance/import_maintainance_from_excel_file/`,
        payload,
        function(res) {
          resolve(res.data);
        },
        function(error) {
          reject(error);
        }
      );
    });
  },
  GET_MAINTENANCE_DETAIL: (context, payload) => {
    return new Promise((resolve, reject) => {
      common.getRequest(
        `/api/v1/${utils.getProjectId()}/maintenance/${payload.id}/`,
        payload,
        function(res) {
          context.commit('GET_MAINTENANCE_DETAIL', res.data)
          resolve(res.data);
        },
        function(error) {
          reject(error);
        }
      );
    });
  },
  GET_MAINTENANCE_HISTORY_LIST: (context, payload) => {
    return new Promise((resolve, reject) => {
      common.getRequest(
        `/api/v1/${utils.getProjectId()}/maintenance/get_maintenance_history/`,
        payload,
        function(res) {
          if(res.data["page"] !== undefined){
            context.commit('GET_MAINTENANCE_HISTORY_LIST', res.data)
          }
          resolve(res.data);
        },
        function(error) {
          reject(error);
        }
      );
    });
  },
  POST_ASSET_LIST_ACTIVITY_TRACKING: (context, payload) => {
    return new Promise((resolve, reject) => {
      common.postRequest(
        `/api/v1/${utils.getProjectId()}/maintenance/post_asset_list_activity_tracking/`,
        payload,
        function(res) {
          resolve(res.data);
        },
        function(error) {
          reject(error);
        }
      );
    });
  },
  REMOVE_ASSET_LIST_ACTIVITY_TRACKING: (context, payload) => {
    return new Promise((resolve, reject) => {
      common.postRequest(
        `/api/v1/${utils.getProjectId()}/maintenance/remove_asset_list_activity_tracking/`,
        payload,
        function(res) {
          resolve(res.data);
        },
        function(error) {
          reject(error);
        }
      );
    });
  },
  GET_ACTIVITY_TRACKING_LIST: (context, payload) => {
    return new Promise((resolve, reject) => {
      common.getRequest(
        `/api/v1/${utils.getProjectId()}/maintenance/get_activity_tracking_list/`,
        payload,
        function(res) {
          if(res.data["page"] !== undefined){
            context.commit('GET_ACTIVITY_TRACKING_LIST', res.data)
          }
          resolve(res.data);
        },
        function(error) {
          reject(error);
        }
      );
    });
  },
  IMPORT_ACTIVITY_TRACKING: (context, payload) => {
    return new Promise((resolve, reject) => {
      common.postRequest(
        `/api/v1/${utils.getProjectId()}/maintenance/import_activity_tracking/`,
        payload,
        function(res) {
          resolve(res.data);
        },
        function(error) {
          reject(error);
        }
      );
    });
  },
  POST_ASSET_LIST_ACTIVITY_PLAN: (context, payload) => {
    return new Promise((resolve, reject) => {
      common.postRequest(
        `/api/v1/${utils.getProjectId()}/maintenance/post_asset_list_activity_plan/`,
        payload,
        function(res) {
          resolve(res.data);
        },
        function(error) {
          reject(error);
        }
      );
    });
  },
  REMOVE_ASSET_LIST_ACTIVITY_PLAN: (context, payload) => {
    return new Promise((resolve, reject) => {
      common.postRequest(
        `/api/v1/${utils.getProjectId()}/maintenance/remove_asset_list_activity_plan/`,
        payload,
        function(res) {
          resolve(res.data);
        },
        function(error) {
          reject(error);
        }
      );
    });
  },
  GET_ACTIVITY_PLAN_LIST: (context, payload) => {
    return new Promise((resolve, reject) => {
      common.getRequest(
        `/api/v1/${utils.getProjectId()}/maintenance/get_activity_plan_list/`,
        payload,
        function(res) {
          if(res.data["page"] !== undefined){
            context.commit('GET_ACTIVITY_PLAN_LIST', res.data)
          }
          resolve(res.data);
        },
        function(error) {
          reject(error);
        }
      );
    });
  },
  UPDATE_STATUS_ACTIVITY_PLAN: (context, payload) => {
    return new Promise((resolve, reject) => {
      common.postRequest(
        `/api/v1/${utils.getProjectId()}/maintenance/update_status_activity_plan/`,
        payload,
        function(res) {
          resolve(res.data);
        },
        function(error) {
          reject(error);
        }
      );
    });
  },
  UPDATE_ASSET_ACTIVITY_PLAN: (context, payload) => {
    return new Promise((resolve, reject) => {
      common.putRequest(
        `/api/v1/${utils.getProjectId()}/maintenance/${payload.id}/update_asset_activity_plan/`,
        payload,
        function(res) {
          resolve(res.data);
        },
        function(error) {
          reject(error);
        }
      );
    });
  },
  UPDATE_MAINTENANCE_ASSIGN_TO: (context, payload) => {
    return new Promise((resolve, reject) => {
      common.postRequest(
        `/api/v1/${utils.getProjectId()}/maintenance/update_maintenance_assign_to/`,
        payload,
        function(res) {
          resolve(res.data);
        },
        function(error) {
          reject(error);
        }
      );
    });
  },
  // =======================================
  // External Link
  // =======================================
  GET_EXTERNAL_LINK_LIST: (context, payload) => {
    return new Promise((resolve, reject) => {
      common.getRequest(
        `/api/v1/${utils.getProjectId()}/external_link/`,
        payload,
        function(res) {
          context.commit('GET_EXTERNAL_LINK_LIST', res.data)
          resolve(res.data);
        },
        function(error) {
          reject(error);
        }
      );
    });
  },
  CREATE_EXTERNAL_LINK: (context, payload) => {
    return new Promise((resolve, reject) => {
      common.postRequest(
        `/api/v1/${utils.getProjectId()}/external_link/`,
        payload,
        function(res) {
          resolve(res.data);
        },
        function(error) {
          reject(error);
        }
      );
    });
  },
  UPDATE_EXTERNAL_LINK: (context, payload) => {
    return new Promise((resolve, reject) => {
      common.putRequest(
        `/api/v1/${utils.getProjectId()}/external_link/${payload.id}/`,
        payload,
        function(res) {
          resolve(res.data);
        },
        function(error) {
          reject(error);
        }
      );
    });
  },
  DELETE_EXTERNAL_LINK: (context, payload) => {
    return new Promise((resolve, reject) => {
      common.deleteRequest(
        `/api/v1/${utils.getProjectId()}/external_link/${payload.id}/`,
        payload,
        function(res) {
          resolve(res.data);
        },
        function(error) {
          reject(error);
        }
      );
    });
  },
  UPDATE_PRIORITY_EXTERNAL_LINK: (context, payload) => {
    return new Promise((resolve, reject) => {
      common.postRequest(
        `/api/v1/${utils.getProjectId()}/external_link/update_priority_external_link/`,
        payload,
        function(res) {
          resolve(res.data);
        },
        function(error) {
          reject(error);
        }
      );
    });
  },
  DELETE_PRIORITY_EXTERNAL_LINK: (context, payload) => {
    return new Promise((resolve, reject) => {
      common.deleteRequest(
        `/api/v1/${utils.getProjectId()}/external_link/${payload.id}/`,
        payload,
        function(res) {
          resolve(res.data);
        },
        function(error) {
          reject(error);
        }
      );
    });
  },
  // =======================================
  // Frequently Asked Questions
  // =======================================
  GET_FREQUENTLY_ASKED_QUESTIONS_LIST: (context, payload) => {
    return new Promise((resolve, reject) => {
      common.getRequest(
        `/api/v1/${utils.getProjectId()}/frequently_asked_questions/`,
        payload,
        function(res) {
          context.commit('GET_FREQUENTLY_ASKED_QUESTIONS_LIST', res.data)
          resolve(res.data);
        },
        function(error) {
          reject(error);
        }
      );
    });
  },
  CREATE_FREQUENTLY_ASKED_QUESTIONS: (context, payload) => {
    return new Promise((resolve, reject) => {
      common.postRequest(
        `/api/v1/${utils.getProjectId()}/frequently_asked_questions/`,
        payload,
        function(res) {
          resolve(res.data);
        },
        function(error) {
          reject(error);
        }
      );
    });
  },
  UPDATE_FREQUENTLY_ASKED_QUESTIONS: (context, payload) => {
    return new Promise((resolve, reject) => {
      common.putRequest(
        `/api/v1/${utils.getProjectId()}/frequently_asked_questions/${payload.id}/`,
        payload,
        function(res) {
          resolve(res.data);
        },
        function(error) {
          reject(error);
        }
      );
    });
  },
  DELETE_FREQUENTLY_ASKED_QUESTIONS: (context, payload) => {
    return new Promise((resolve, reject) => {
      common.deleteRequest(
        `/api/v1/${utils.getProjectId()}/frequently_asked_questions/${payload.id}/`,
        payload,
        function(res) {
          resolve(res.data);
        },
        function(error) {
          reject(error);
        }
      );
    });
  },
  GET_ALL_USER_IN_PROJECT: (context, payload) => {
    return new Promise((resolve, reject) => {
      common.getRequest(
        `/api/v1/${utils.getProjectId()}/users/get_all_user_in_project/`,
        payload,
        function(res) {
          resolve(res.data);
        },
        function(error) {
          reject(error);
        }
      );
    });
  },
  // =======================================
  // Incident
  // =======================================
  GET_INCIDENT_IN_FEEDBACK_LIST: (context, payload) => {
    return new Promise((resolve, reject) => {
      common.getRequest(
        `/api/v1/${utils.getProjectId()}/feedback/${payload.id}/get_maintenance_in_feedback/`,
        payload,
        function(res) {
          context.commit('GET_INCIDENT_IN_FEEDBACK_LIST', res.data)
          resolve(res.data);
        },
        function(error) {
          reject(error);
        }
      );
    });
  },
  // =======================================
  // Asset Supplier
  // =======================================
  GET_ASSET_SUPPLIER_LIST: (context, payload) => {
    return new Promise((resolve, reject) => {
      common.getRequest(
        `/api/v1/${utils.getProjectId()}/asset_supplier/`,
        payload,
        function(res) {
          if(res.data["page"] !== undefined){
            context.commit('GET_ASSET_SUPPLIER_LIST', res.data)
          } else {
            context.commit('GET_ASSET_SUPPLIER_LIST_NO_PAGE', res.data)
          }
          resolve(res.data);
        },
        function(error) {
          reject(error);
        }
      );
    });
  },
  CREATE_ASSET_SUPPLIER: (context, payload) => {
    return new Promise((resolve, reject) => {
      common.postRequest(
        `/api/v1/${utils.getProjectId()}/asset_supplier/`,
        payload,
        function(res) {
          resolve(res.data);
        },
        function(error) {
          reject(error);
        }
      );
    });
  },
  UPDATE_ASSET_SUPPLIER: (context, payload) => {
    return new Promise((resolve, reject) => {
      common.putRequest(
        `/api/v1/${utils.getProjectId()}/asset_supplier/${payload.id}/`,
        payload,
        function(res) {
          resolve(res.data);
        },
        function(error) {
          reject(error);
        }
      );
    });
  },
  DELETE_ASSET_SUPPLIER: (context, payload) => {
    return new Promise((resolve, reject) => {
      common.deleteRequest(
        `/api/v1/${utils.getProjectId()}/asset_supplier/${payload.id}/`,
        payload,
        function(res) {
          resolve(res.data);
        },
        function(error) {
          reject(error);
        }
      );
    });
  },
  IMPORT_ASSET_SUPPLIER: (context, payload) => {
    return new Promise((resolve, reject) => {
      common.postRequest(
        `/api/v1/${utils.getProjectId()}/asset_supplier/import_asset_supplier/`,
        payload,
        function(res) {
          resolve(res.data);
        },
        function(error) {
          reject(error);
        }
      );
    });
  },
  // =======================================
  // Approval Apartment Resident
  // =======================================
  GET_APPROVAL_APARTMENT_RESIDENT_LIST: (context, payload) => {
    return new Promise((resolve, reject) => {
      common.getRequest(
        `/api/v1/${utils.getProjectId()}/approval_apartment_resident/`,
        payload,
        function(res) {
          if(res.data["page"] !== undefined){
            context.commit('GET_APPROVAL_APARTMENT_RESIDENT_LIST', res.data)
          }
          resolve(res.data);
        },
        function(error) {
          reject(error);
        }
      );
    });
  },
  GET_NUMBER_APPROVAL_APARTMENT_RESIDENT: (context, payload) => {
    return new Promise((resolve, reject) => {
      common.getRequest(
        `/api/v1/${utils.getProjectId()}/approval_apartment_resident/get_number_apartment_resident_approval/`,
        payload,
        function(res) {
          context.commit('GET_NUMBER_APPROVAL_APARTMENT_RESIDENT', res.data)
          resolve(res.data);
        },
        function(error) {
          reject(error);
        }
      );
    });
  },
  UPDATE_APARTMENT_APPROVAL_STATUS: (context, payload) => {
    return new Promise((resolve, reject) => {
      common.postRequest(
        `/api/v1/${utils.getProjectId()}/approval_apartment_resident/update_apartment_approval_status/`,
        payload,
        function(res) {
          resolve(res.data);
        },
        function(error) {
          reject(error);
        }
      );
    });
  },
  GET_GENERAL_USER_SETTINGS: (context, payload) => {
    return new Promise((resolve, reject) => {
      common.getRequest(
        `/api/v1/${utils.getProjectId()}/users/get_general_user_settings/`,
        payload,
        function(res) {
          resolve(res.data);
        },
        function(error) {
          reject(error);
        }
      );
    });
  },
  UPDATE_IS_SHOW_WELLCOME: (context, payload) => {
    return new Promise((resolve, reject) => {
      common.postRequest(
        `/api/v1/${utils.getProjectId()}/users/update_is_show_wellcome/`,
        payload,
        function(res) {
          resolve(res.data);
        },
        function(error) {
          reject(error);
        }
      );
    });
  },
  // =======================================
  // Receipt Receive Info
  // =======================================
  GET_RECEIPT_RECEIVE_INFO_IN_APARTMENT: (context, payload) => {
    return new Promise((resolve, reject) => {
      common.getRequest(
        `/api/v1/${utils.getProjectId()}/receipt_receive_info/`,
        payload,
        function(res) {
          // context.commit('GET_APPROVAL_APARTMENT_RESIDENT_LIST', res.data)
          resolve(res.data);
        },
        function(error) {
          reject(error);
        }
      );
    });
  },
  POST_RECEIPT_RECEIVE_INFO: (context, payload) => {
    return new Promise((resolve, reject) => {
      common.postRequest(
        `/api/v1/${utils.getProjectId()}/receipt_receive_info/post_receipt_receive_info/`,
        payload,
        function(res) {
          resolve(res.data);
        },
        function(error) {
          reject(error);
        }
      );
    });
  },
  GET_RECEIPT_RECEIVE_INFO_DETAIL: (context, payload) => {
    return new Promise((resolve, reject) => {
      common.getRequest(
        `/api/v1/${utils.getProjectId()}/receipt_receive_info/get_receipt_receive_info/`,
        payload,
        function(res) {
          // context.commit('GET_APPROVAL_APARTMENT_RESIDENT_LIST', res.data)
          resolve(res.data);
        },
        function(error) {
          reject(error);
        }
      );
    });
  },
  SEND_NOTIFICATION_TO_APARTMENT: (context, payload) => {
    return new Promise((resolve, reject) => {
      common.postRequest(
        `/api/v1/${utils.getProjectId()}/apartment_notification/`,
        payload,
        function(res) {
          resolve(res.data);
        },
        function(error) {
          reject(error);
        }
      );
    });
  },
  GET_NOTIFICATION: (context, payload) => {
    return new Promise((resolve, reject) => {
      common.getRequest(
        `/api/v1/${utils.getProjectId()}/apartment_notification/`,
        payload,
        function(res) {
          context.commit('GET_NOTIFICATION', res.data)
          resolve(res.data);
        },
        function(error) {
          reject(error);
        }
      );
    });
  },
};



// WEBPACK FOOTER //
// ./src/store/actions.js